import { defineComponent, ref, computed, provide, openBlock, createElementBlock, renderSlot, useAttrs, inject, watch, mergeProps, unref, createElementVNode, normalizeClass, createVNode, Transition, withCtx, createCommentVNode, pushScopeId, popScopeId, createBlock, resolveDynamicComponent, useSlots, toDisplayString, withModifiers, withDirectives, vModelCheckbox, Fragment, createTextVNode, renderList, normalizeStyle, useCssVars, withKeys, vShow, vModelText, createSlots, nextTick, normalizeProps, guardReactiveProps, toHandlers, toRef, watchEffect, reactive, onMounted, onUnmounted, Teleport, onBeforeUnmount, vModelDynamic, createStaticVNode, isRef, vModelRadio, TransitionGroup } from "vue";
import { ChevronDownIcon, CloseIcon, CloseCircleFillIcon, LessIcon, CheckIcon, SpinnerIcon, ChevronUpIcon, HomeFillIcon, ChevronLeftIcon, ChevronRightIcon, CalendarIcon, EditIcon, BurgerIcon, FirstPageIcon, LastPageIcon, NoFullScreenIcon, FullScreenIcon } from "@frontiers/brink-icons";
import { useBreakpoints as useBreakpoints$1, useMediaQuery, onClickOutside, useFocusWithin, unrefElement, tryOnScopeDispose, useScrollLock, useElementSize, useDebounceFn, useTimeoutFn } from "@vueuse/core";
import { useFloating, offset, flip, size, shift, limitShift, arrow, autoUpdate, autoPlacement } from "@floating-ui/vue";
import { createFocusTrap } from "focus-trap";
const main = "";
const ACCORDION_STATE_KEY = Symbol.for("b-accordion-state");
const _hoisted_1$1f = { class: "b-accordion" };
const _sfc_main$1p = /* @__PURE__ */ defineComponent({
  __name: "b-accordion",
  props: {
    allowMultiple: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const activeItemIds = ref([]);
    const setActiveItem = (id) => {
      if (props.allowMultiple) {
        toggleMultiple(id);
      } else {
        setSingle(id);
      }
    };
    const toggleMultiple = (id) => {
      if (activeItemIds.value.includes(id)) {
        removeItem(id);
      } else {
        addItem(id);
      }
    };
    const removeItem = (id) => {
      activeItemIds.value = activeItemIds.value.filter((itemId) => itemId !== id);
    };
    const addItem = (id) => {
      activeItemIds.value = [...activeItemIds.value, id];
    };
    const setSingle = (id) => {
      activeItemIds.value = [id];
    };
    const accordionState = computed(() => ({
      allowMultiple: props.allowMultiple,
      activeItemIds: activeItemIds.value,
      setActiveItem
    }));
    provide(ACCORDION_STATE_KEY, accordionState);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", _hoisted_1$1f, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]);
    };
  }
});
const bAccordion_vue_vue_type_style_index_0_scoped_22cf4913_lang = "";
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const BAccordion = /* @__PURE__ */ _export_sfc(_sfc_main$1p, [["__scopeId", "data-v-22cf4913"]]);
const BREAKPOINTS_MAP = {
  "sm": 768,
  "md": 1024,
  "lg": 1280,
  "xl": 1440,
  "2xl": 1920
};
const useBreakpoints = () => {
  const breakpoints = useBreakpoints$1(BREAKPOINTS_MAP);
  return {
    "between": breakpoints.between,
    "greater": breakpoints.greater,
    "greaterOrEqual": breakpoints.greaterOrEqual,
    "smaller": breakpoints.smaller,
    "smallerOrEqual": breakpoints.smallerOrEqual,
    "sm": breakpoints.sm,
    "md": breakpoints.md,
    "lg": breakpoints.lg,
    "xl": breakpoints.xl,
    "2xl": breakpoints["2xl"]
  };
};
const isBrowser = () => typeof window !== "undefined";
const useHasMouse = () => {
  return isBrowser() ? useMediaQuery("(pointer: fine)") : ref(true);
};
const useSafeAttrs = (attrs) => computed(() => {
  if (Array.isArray(attrs) || typeof attrs !== "object" || attrs == null) {
    return {};
  }
  const { class: _, style: __, ...rest } = attrs;
  return {
    ...rest
  };
});
const removeCombiningDiacriticalMarks = typeof String.prototype.normalize === "function" ? (string) => string.normalize("NFD").replaceAll(/[\u0300-\u036F]/g, "") : (string) => string;
function normalizeString(string) {
  string = (string == null ? void 0 : string.trim().toLowerCase()) ?? "";
  return removeCombiningDiacriticalMarks(string);
}
function generateUniqueId() {
  const uniqueId = Date.now().toString(36) + Math.random().toString(36).slice(2);
  return uniqueId;
}
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function isDigitOnly(str) {
  const anyDigitRegex = /^\d+$/;
  return anyDigitRegex.test(str);
}
const _withScopeId$8 = (n) => (pushScopeId("data-v-39e115dd"), n = n(), popScopeId(), n);
const _hoisted_1$1e = /* @__PURE__ */ _withScopeId$8(() => /* @__PURE__ */ createElementVNode("div", { class: "b-accordion-item__divider" }, null, -1));
const _hoisted_2$X = { class: "b-accordion-item__icon" };
const _hoisted_3$D = { class: "b-accordion-item__content" };
const _hoisted_4$r = { key: 0 };
const _sfc_main$1o = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-accordion-item",
  emits: ["toggle"],
  setup(__props, { emit }) {
    const breakpoints = useBreakpoints();
    const greaterOrEqualThanMedium = breakpoints.greaterOrEqual("md");
    const isExpanded = ref(false);
    const itemId = generateUniqueId();
    const attrs = useAttrs();
    const accordionAttrs = useSafeAttrs(attrs);
    const accordionState = inject(ACCORDION_STATE_KEY);
    const toggle = () => {
      if (!(accordionState == null ? void 0 : accordionState.value.allowMultiple)) {
        toggleSingle();
      } else {
        toggleMultiple();
      }
    };
    const toggleSingle = () => {
      isExpanded.value = !isExpanded.value;
      accordionState == null ? void 0 : accordionState.value.setActiveItem(isExpanded.value ? itemId : "");
      if (isExpanded.value) {
        emitToggleEvent(itemId, isExpanded.value);
      }
    };
    const toggleMultiple = () => {
      accordionState == null ? void 0 : accordionState.value.setActiveItem(itemId);
      emitToggleEvent(itemId, isExpanded.value);
    };
    const emitToggleEvent = (toggledItemId, expanded) => {
      emit("toggle", toggledItemId, expanded);
    };
    const afterEnter = (el) => {
      const element = el;
      element.style.height = "auto";
    };
    const enter = (el) => {
      const element = el;
      const height = getComputedStyle(element).height;
      element.style.setProperty("height", "0px");
      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = height;
      });
    };
    const leave = (el) => {
      const element = el;
      const height = getComputedStyle(element).height;
      element.style.height = height;
      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.setProperty("height", "0px");
      });
    };
    watch(
      () => accordionState == null ? void 0 : accordionState.value.activeItemIds,
      (activeIds) => {
        if (!activeIds) {
          return;
        }
        isExpanded.value = activeIds.includes(itemId);
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", mergeProps({ class: "b-accordion-item" }, unref(accordionAttrs), {
        class: { "b-accordion-item--expanded": isExpanded.value }
      }), [
        _hoisted_1$1e,
        createElementVNode("button", {
          class: "b-accordion-item__header",
          onClick: toggle
        }, [
          renderSlot(_ctx.$slots, "header", {}, void 0, true),
          createElementVNode("div", _hoisted_2$X, [
            renderSlot(_ctx.$slots, "toggle-icon", {}, () => [
              createElementVNode("div", {
                class: normalizeClass(["b-accordion-item__chevron", {
                  "b-accordion-item__chevron--opened": isExpanded.value
                }])
              }, [
                createVNode(unref(ChevronDownIcon), {
                  size: unref(greaterOrEqualThanMedium) ? "lg" : "md"
                }, null, 8, ["size"])
              ], 2)
            ], true)
          ])
        ]),
        createElementVNode("div", _hoisted_3$D, [
          createVNode(Transition, {
            name: "b-accordion-item-transition",
            onEnter: enter,
            onAfterEnter: afterEnter,
            onLeave: leave
          }, {
            default: withCtx(() => [
              isExpanded.value ? (openBlock(), createElementBlock("div", _hoisted_4$r, [
                renderSlot(_ctx.$slots, "content", {}, void 0, true)
              ])) : createCommentVNode("", true)
            ]),
            _: 3
          })
        ])
      ], 16);
    };
  }
});
const bAccordionItem_vue_vue_type_style_index_0_scoped_39e115dd_lang = "";
const BAccordionItem = /* @__PURE__ */ _export_sfc(_sfc_main$1o, [["__scopeId", "data-v-39e115dd"]]);
const SIZE_MAP = {
  "sm": "12px",
  "md": "16px",
  "lg": "24px",
  "xl": "32px",
  "2xl": "48px"
};
const _hoisted_1$1d = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
const _hoisted_2$W = /* @__PURE__ */ createElementVNode("path", {
  fill: "#282828",
  d: "M5 5h14v14H5z"
}, null, -1);
const _hoisted_3$C = /* @__PURE__ */ createElementVNode("path", {
  fill: "#F2575D",
  d: "M12 1.44a10.56 10.56 0 1 0 0 21.12 10.56 10.56 0 0 0 0-21.12Zm5.09 14.294a.479.479 0 0 1 0 .68l-.679.679a.48.48 0 0 1-.677 0L12 13.358l-3.734 3.735a.48.48 0 0 1-.677 0l-.68-.68a.48.48 0 0 1 0-.679L10.643 12 6.91 8.268a.48.48 0 0 1 0-.68l.679-.678a.48.48 0 0 1 .677 0L12 10.644l3.734-3.734a.48.48 0 0 1 .677 0l.68.679a.478.478 0 0 1 0 .679L13.357 12l3.732 3.734Z"
}, null, -1);
const _hoisted_4$q = [
  _hoisted_2$W,
  _hoisted_3$C
];
function render$6(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1d, _hoisted_4$q);
}
const ErrorIconBlack = { render: render$6 };
const _hoisted_1$1c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
};
const _hoisted_2$V = /* @__PURE__ */ createElementVNode("path", {
  fill: "#fff",
  d: "M10 10h28v28H10z"
}, null, -1);
const _hoisted_3$B = /* @__PURE__ */ createElementVNode("path", {
  fill: "#D51A2C",
  d: "M24 2.88A21.12 21.12 0 0 0 4.488 15.918 21.12 21.12 0 1 0 24 2.88Zm10.18 28.589a.96.96 0 0 1 .282.679.96.96 0 0 1-.281.68l-1.359 1.358a.96.96 0 0 1-1.353 0l-7.47-7.47-7.468 7.47a.96.96 0 0 1-1.354 0l-1.358-1.359a.96.96 0 0 1-.282-.679.96.96 0 0 1 .282-.68L21.283 24l-7.464-7.464a.96.96 0 0 1-.282-.68.96.96 0 0 1 .282-.678l1.358-1.359a.96.96 0 0 1 1.354 0L24 21.288l7.469-7.469a.96.96 0 0 1 1.353 0l1.359 1.359a.96.96 0 0 1 .281.679.96.96 0 0 1-.281.679L26.717 24l7.464 7.469Z"
}, null, -1);
const _hoisted_4$p = [
  _hoisted_2$V,
  _hoisted_3$B
];
function render$5(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1c, _hoisted_4$p);
}
const ErrorIconWhite = { render: render$5 };
const _hoisted_1$1b = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$U = /* @__PURE__ */ createElementVNode("path", {
  fill: "#282828",
  d: "M5 5h14v14H5z"
}, null, -1);
const _hoisted_3$A = /* @__PURE__ */ createElementVNode("path", {
  fill: "#6D9EFD",
  d: "M12 1.44a10.56 10.56 0 1 0 0 21.12 10.56 10.56 0 0 0 0-21.12Zm-.96 5.26a.48.48 0 0 1 .48-.48h.96a.48.48 0 0 1 .48.48v.96a.48.48 0 0 1-.48.48h-.96a.48.48 0 0 1-.48-.48V6.7Zm2.88 10.6a.48.48 0 0 1-.48.48h-2.88a.48.48 0 0 1-.48-.48v-.96a.48.48 0 0 1 .48-.48h.48v-3.84h-.48a.48.48 0 0 1-.48-.48v-.96a.48.48 0 0 1 .48-.48h1.92a.48.48 0 0 1 .48.48v5.28h.48a.48.48 0 0 1 .48.48v.96Z"
}, null, -1);
const _hoisted_4$o = [
  _hoisted_2$U,
  _hoisted_3$A
];
function render$4(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1b, _hoisted_4$o);
}
const InfoIconBlack = { render: render$4 };
const _hoisted_1$1a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
};
const _hoisted_2$T = /* @__PURE__ */ createElementVNode("path", {
  fill: "#fff",
  d: "M10 10h28v28H10z"
}, null, -1);
const _hoisted_3$z = /* @__PURE__ */ createElementVNode("path", {
  fill: "#003BDE",
  d: "M24 2.88a21.12 21.12 0 1 0 0 42.24 21.12 21.12 0 0 0 0-42.24ZM22.08 13.4a.96.96 0 0 1 .96-.96h1.92a.96.96 0 0 1 .96.96v1.92a.96.96 0 0 1-.96.96h-1.92a.96.96 0 0 1-.96-.96V13.4Zm5.76 21.2a.96.96 0 0 1-.96.97h-5.76a.96.96 0 0 1-.96-.96v-1.92a.96.96 0 0 1 .96-.96h.96v-7.68h-.96a.96.96 0 0 1-.96-.96v-1.92a.96.96 0 0 1 .96-.96h3.84a.96.96 0 0 1 .96.96v10.56h.96a.96.96 0 0 1 .96.96v1.92Z"
}, null, -1);
const _hoisted_4$n = [
  _hoisted_2$T,
  _hoisted_3$z
];
function render$3(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1a, _hoisted_4$n);
}
const InfoIconWhite = { render: render$3 };
const _hoisted_1$19 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
};
const _hoisted_2$S = /* @__PURE__ */ createElementVNode("path", {
  fill: "#282828",
  d: "M10 10h28v28H10z"
}, null, -1);
const _hoisted_3$y = /* @__PURE__ */ createElementVNode("path", {
  fill: "#65C161",
  d: "M24 2.88a21.12 21.12 0 1 0 0 42.24 21.12 21.12 0 0 0 0-42.24ZM36.2 18.4 20.84 33.76a.96.96 0 0 1-1.36 0l-7.68-7.68a.96.96 0 0 1 0-1.36l1.36-1.35a.96.96 0 0 1 1.36 0l5.64 5.64L33.48 15.7a.96.96 0 0 1 1.36 0l1.36 1.35a.96.96 0 0 1 0 1.36Z"
}, null, -1);
const _hoisted_4$m = [
  _hoisted_2$S,
  _hoisted_3$y
];
function render$2(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$19, _hoisted_4$m);
}
const SuccessIcon = { render: render$2 };
const _hoisted_1$18 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
};
const _hoisted_2$R = /* @__PURE__ */ createElementVNode("path", {
  fill: "#282828",
  d: "M12 10h24v28H12z"
}, null, -1);
const _hoisted_3$x = /* @__PURE__ */ createElementVNode("path", {
  fill: "#E87626",
  d: "M24 2.88a21.12 21.12 0 1 0 0 42.24 21.12 21.12 0 0 0 0-42.24Zm1.92 31.73a.96.96 0 0 1-.96.96h-1.92a.96.96 0 0 1-.96-.96v-1.92a.96.96 0 0 1 .96-.96h1.92a.96.96 0 0 1 .96.96v1.92Zm0-7.68a.96.96 0 0 1-.96.96h-1.92a.96.96 0 0 1-.96-.96V13.49a.96.96 0 0 1 .96-.96h1.92a.96.96 0 0 1 .96.96v13.44Z"
}, null, -1);
const _hoisted_4$l = [
  _hoisted_2$R,
  _hoisted_3$x
];
function render$1(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$18, _hoisted_4$l);
}
const WarningIcon = { render: render$1 };
const _sfc_main$1n = /* @__PURE__ */ defineComponent({
  __name: "b-feedback-icon",
  props: {
    type: {},
    size: { default: "md" },
    colorScheme: { default: "black" }
  },
  setup(__props) {
    const props = __props;
    const feedbackIconMap = {
      black: {
        error: ErrorIconBlack,
        info: InfoIconBlack,
        success: SuccessIcon,
        warning: WarningIcon
      },
      white: {
        error: ErrorIconWhite,
        info: InfoIconWhite,
        success: SuccessIcon,
        warning: WarningIcon
      }
    };
    const iconPixelSize = computed(() => SIZE_MAP[props.size]);
    const iconComponent = computed(
      () => feedbackIconMap[props.colorScheme][props.type]
    );
    return (_ctx, _cache) => {
      return iconComponent.value ? (openBlock(), createBlock(resolveDynamicComponent(iconComponent.value), {
        key: 0,
        width: iconPixelSize.value,
        class: "b-feedback-icon"
      }, null, 8, ["width"])) : createCommentVNode("", true);
    };
  }
});
const bFeedbackIcon_vue_vue_type_style_index_0_scoped_f1340185_lang = "";
const BFeedbackIcon = /* @__PURE__ */ _export_sfc(_sfc_main$1n, [["__scopeId", "data-v-f1340185"]]);
const _withScopeId$7 = (n) => (pushScopeId("data-v-fdff5c21"), n = n(), popScopeId(), n);
const _hoisted_1$17 = ["aria-label"];
const _hoisted_2$Q = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("div", { class: "b-alert__left-bar" }, null, -1));
const _hoisted_3$w = { class: "b-alert__wrapper" };
const _hoisted_4$k = {
  key: 0,
  class: "b-alert__icon"
};
const _hoisted_5$e = { class: "b-alert__content" };
const _hoisted_6$e = {
  key: 1,
  class: "b-alert__additionalText"
};
const _hoisted_7$b = {
  key: 2,
  class: "b-alert__cta"
};
const _hoisted_8$7 = {
  key: 0,
  class: "b-alert__cta-button"
};
const _hoisted_9$6 = {
  key: 1,
  class: "b-alert__cta-link"
};
const COMPACT_TEXT_DELIMITER$1 = 40;
const _sfc_main$1m = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-alert",
  props: {
    type: { default: "info" },
    message: {},
    additionalText: { default: void 0 },
    showCloseIcon: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props, { emit }) {
    const props = __props;
    const slots = useSlots();
    const attrs = useAttrs();
    const alertAttrs = useSafeAttrs(attrs);
    const breakpoints = useBreakpoints();
    const greaterThanMd = breakpoints.greaterOrEqual("lg");
    const isLine = computed(
      () => !(props.message.length >= COMPACT_TEXT_DELIMITER$1 || props.additionalText)
    );
    const ariaLabel = computed(
      () => `${props.message}. ${props.additionalText ?? ""}`
    );
    const feedbackIconSize = computed(() => greaterThanMd.value ? "lg" : "md");
    const linkIconSize = computed(() => greaterThanMd.value ? "md" : "sm");
    const hasCustomAction = computed(() => slots["button"] || slots["link"]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({
        "aria-live": "polite",
        role: "alert",
        "aria-label": ariaLabel.value
      }, unref(alertAttrs), {
        class: ["b-alert", [
          `b-alert--${_ctx.type}`,
          {
            "b-alert--line": isLine.value
          }
        ]]
      }), [
        _hoisted_2$Q,
        createElementVNode("div", _hoisted_3$w, [
          _ctx.type ? (openBlock(), createElementBlock("div", _hoisted_4$k, [
            createVNode(unref(BFeedbackIcon), {
              type: props.type,
              "data-cy": `b-alert-icon-${_ctx.type}`,
              size: feedbackIconSize.value,
              "color-scheme": "white"
            }, null, 8, ["type", "data-cy", "size"])
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_5$e, [
            createElementVNode("p", {
              class: normalizeClass(["b-alert__message", {
                "b-alert__message--with-max-width": _ctx.showCloseIcon
              }])
            }, toDisplayString(_ctx.message), 3),
            _ctx.showCloseIcon ? (openBlock(), createElementBlock("button", {
              key: 0,
              "aria-label": "Close",
              "data-cy": "b-alert-close",
              class: "b-alert__close",
              onClick: _cache[0] || (_cache[0] = ($event) => emit("close"))
            }, [
              createVNode(unref(CloseIcon), { size: "md" })
            ])) : createCommentVNode("", true),
            _ctx.additionalText ? (openBlock(), createElementBlock("div", _hoisted_6$e, toDisplayString(_ctx.additionalText), 1)) : createCommentVNode("", true),
            hasCustomAction.value ? (openBlock(), createElementBlock("div", _hoisted_7$b, [
              unref(slots)["button"] ? (openBlock(), createElementBlock("div", _hoisted_8$7, [
                renderSlot(_ctx.$slots, "button", {
                  colorScheme: "black",
                  size: "md",
                  variant: "outline"
                }, void 0, true)
              ])) : createCommentVNode("", true),
              unref(slots)["link"] ? (openBlock(), createElementBlock("div", _hoisted_9$6, [
                renderSlot(_ctx.$slots, "link", {
                  colorScheme: "black",
                  size: linkIconSize.value
                }, void 0, true)
              ])) : createCommentVNode("", true)
            ])) : createCommentVNode("", true)
          ])
        ])
      ], 16, _hoisted_1$17);
    };
  }
});
const bAlert_vue_vue_type_style_index_0_scoped_fdff5c21_lang = "";
const bAlert = /* @__PURE__ */ _export_sfc(_sfc_main$1m, [["__scopeId", "data-v-fdff5c21"]]);
const ACTIVE_DESCENDANT_CONTEXT = Symbol(
  "activeDescendantContext"
);
const genDescendantId = (descendantPrefixId, index) => `${descendantPrefixId}-${index}`;
const useActiveDescendantOptions = () => {
  return inject(ACTIVE_DESCENDANT_CONTEXT);
};
const useActiveDescendant = ({
  descendants
}) => {
  const descendantPrefixId = generateUniqueId();
  const activeIndex = ref(-1);
  const activeDescendantId = computed(() => {
    if (activeIndex.value === -1) {
      return;
    }
    return genDescendantId(descendantPrefixId, activeIndex.value);
  });
  watch(descendants, () => {
    activeIndex.value = 0;
  });
  provide(ACTIVE_DESCENDANT_CONTEXT, {
    activeIndex,
    activeDescendantId,
    descendantPrefixId,
    applyDescendantAttributes,
    isActiveDescendant
  });
  function goToPreviousDescendant() {
    if (activeIndex.value === 0) {
      activeIndex.value = descendants.value.length - 1;
    } else {
      activeIndex.value -= 1;
    }
  }
  function goToNextDescendant() {
    if (activeIndex.value === descendants.value.length - 1) {
      activeIndex.value = 0;
    } else {
      activeIndex.value += 1;
    }
  }
  function goToFirstDescendant() {
    activeIndex.value = 0;
  }
  function goToLastDescendant() {
    activeIndex.value = descendants.value.length - 1;
  }
  function resetDescendant() {
    activeIndex.value = -1;
  }
  function getActiveDescendant() {
    if (!isBrowser() || !activeDescendantId.value) {
      return null;
    }
    return document.getElementById(activeDescendantId.value);
  }
  function getActiveDescendantValue() {
    var _a;
    return (_a = getActiveDescendant()) == null ? void 0 : _a.dataset.option;
  }
  function applyDescendantAttributes(idx, value) {
    return {
      "data-option": value,
      "id": genDescendantId(descendantPrefixId, idx)
    };
  }
  function isActiveDescendant(idx) {
    return activeIndex.value === idx;
  }
  return {
    activeDescendantId,
    getActiveDescendant,
    getActiveDescendantValue,
    goToFirstDescendant,
    goToLastDescendant,
    goToNextDescendant,
    goToPreviousDescendant,
    resetDescendant
  };
};
const _hoisted_1$16 = { class: "b-chip-input__label" };
const _hoisted_2$P = ["aria-label", "onClick"];
const _sfc_main$1l = /* @__PURE__ */ defineComponent({
  ...{ inheritAttrs: false },
  __name: "b-chip-input",
  props: {
    colorScheme: { default: "black" },
    label: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    size: { default: "md" }
  },
  emits: ["delete"],
  setup(__props, { emit }) {
    const props = __props;
    const slots = useSlots();
    const chipInputAttrs = useSafeAttrs(useAttrs());
    const chipSizeToDeleteIconSizeMap = {
      xl: "md",
      lg: "md",
      md: "sm",
      sm: "sm"
    };
    const chipSizeToAvatarSizeMap = {
      xl: "xs",
      lg: "2xs",
      md: "2xs",
      sm: "3xs"
    };
    const chipSizeToIconSizeMap = {
      xl: "lg",
      lg: "md",
      md: "md",
      sm: "sm"
    };
    const avatarSize = computed(() => chipSizeToAvatarSizeMap[props.size]);
    const iconSize = computed(() => chipSizeToIconSizeMap[props.size]);
    const deleteIconSize = computed(() => chipSizeToDeleteIconSizeMap[props.size]);
    const renderIcon = computed(() => !!slots.icon && !slots.avatar);
    const renderAvatar = computed(() => !!slots.avatar);
    function emitDelete() {
      if (!props.disabled && !props.readonly) {
        emit("delete", props.label);
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({
        class: ["b-chip-input", [
          `b-chip-input--${_ctx.size}`,
          `b-chip-input--${_ctx.colorScheme}`,
          {
            "b-chip-input--disabled": _ctx.disabled,
            "b-chip-input--readonly": _ctx.readonly,
            "b-chip-input--has-icon": renderIcon.value,
            "b-chip-input--has-avatar": renderAvatar.value
          }
        ]]
      }, unref(chipInputAttrs)), [
        renderAvatar.value ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["b-chip-input__avatar", [
            `b-chip-input__avatar--${_ctx.size}`,
            `b-chip-input__avatar--${_ctx.colorScheme}`,
            { "b-chip-input__avatar--disabled": _ctx.disabled }
          ]])
        }, [
          renderSlot(_ctx.$slots, "avatar", { size: avatarSize.value }, void 0, true)
        ], 2)) : createCommentVNode("", true),
        renderIcon.value ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["b-chip-input__icon", `b-chip-input__icon--${_ctx.size}`])
        }, [
          renderSlot(_ctx.$slots, "icon", {
            size: iconSize.value,
            fill: "currentColor"
          }, void 0, true)
        ], 2)) : createCommentVNode("", true),
        createElementVNode("span", _hoisted_1$16, toDisplayString(_ctx.label), 1),
        createElementVNode("button", {
          class: normalizeClass(["b-chip-input__delete", [
            `b-chip-input__delete--${_ctx.colorScheme}`,
            {
              "b-chip-input__delete--disabled": _ctx.disabled,
              "b-chip-input__delete--readonly": _ctx.readonly
            }
          ]]),
          "aria-label": `delete ${_ctx.label}`,
          onClick: withModifiers(emitDelete, ["stop"])
        }, [
          createVNode(unref(CloseIcon), {
            size: deleteIconSize.value,
            fill: "currentColor"
          }, null, 8, ["size"])
        ], 10, _hoisted_2$P)
      ], 16);
    };
  }
});
const bChipInput_vue_vue_type_style_index_0_scoped_2d15175b_lang = "";
const BChipInput = /* @__PURE__ */ _export_sfc(_sfc_main$1l, [["__scopeId", "data-v-2d15175b"]]);
const _hoisted_1$15 = {
  key: 0,
  class: "b-form-error",
  role: "alert",
  "aria-live": "assertive"
};
const _sfc_main$1k = /* @__PURE__ */ defineComponent({
  __name: "b-form-error",
  props: {
    errorMessage: {},
    colorScheme: { default: "black" }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return !!_ctx.errorMessage ? (openBlock(), createElementBlock("div", _hoisted_1$15, [
        _ctx.colorScheme === "black" ? (openBlock(), createBlock(unref(CloseCircleFillIcon), {
          key: 0,
          size: "sm",
          fill: "var(--icon-fill-color)",
          "data-test-id": "b-form-error-icon-circle",
          class: "b-form-error__icon"
        })) : (openBlock(), createBlock(unref(BFeedbackIcon), {
          key: 1,
          type: "error",
          "color-scheme": "white",
          size: "sm",
          "data-test-id": "b-form-error-icon-feedback",
          class: "b-form-error__icon"
        })),
        createElementVNode("span", {
          class: normalizeClass(["b-form-error__text", `b-form-error__text--${_ctx.colorScheme}`])
        }, toDisplayString(_ctx.errorMessage), 3)
      ])) : createCommentVNode("", true);
    };
  }
});
const bFormError_vue_vue_type_style_index_0_scoped_7dc32920_lang = "";
const BFormError = /* @__PURE__ */ _export_sfc(_sfc_main$1k, [["__scopeId", "data-v-7dc32920"]]);
const CHECKBOX_GROUP_STATE_KEY = Symbol(
  "checkboxGroupProps"
);
const _hoisted_1$14 = { class: "b-checkbox" };
const _hoisted_2$O = ["for"];
const _hoisted_3$v = ["id", "disabled", "aria-invalid", "aria-checked"];
const _sfc_main$1j = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-checkbox",
  props: {
    colorScheme: { default: "black" },
    disabled: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false },
    invalid: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    label: { default: void 0 },
    modelValue: { type: Boolean },
    errorMessage: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit }) {
    const props = __props;
    const slots = useSlots();
    const checkboxRef = ref();
    __expose({
      checkbox: checkboxRef
    });
    const checkboxGroupState = inject(CHECKBOX_GROUP_STATE_KEY, null);
    const checkboxAttrs = useSafeAttrs(useAttrs());
    const checkboxId = generateUniqueId();
    checkboxGroupState == null ? void 0 : checkboxGroupState.value.register(checkboxId);
    const isControlled = computed(
      () => checkboxGroupState == null ? void 0 : checkboxGroupState.value.checkboxStateMap.has(checkboxId)
    );
    const isChecked = computed(
      () => !!(checkboxGroupState == null ? void 0 : checkboxGroupState.value.checkboxStateMap.get(checkboxId)) || !!props.modelValue
    );
    const proxiedModel = computed({
      get() {
        return isChecked.value;
      },
      set(value) {
        checkboxGroupState == null ? void 0 : checkboxGroupState.value.update(checkboxId, value);
        emit("update:modelValue", value);
      }
    });
    const computedColorScheme = computed(
      () => (checkboxGroupState == null ? void 0 : checkboxGroupState.value.colorScheme) ?? props.colorScheme
    );
    const computedInvalid = computed(() => {
      if (isControlled.value) {
        return isChecked.value ? false : !!(checkboxGroupState == null ? void 0 : checkboxGroupState.value.invalid);
      } else {
        return props.invalid;
      }
    });
    const computedDisabled = computed(() => {
      if (isControlled.value) {
        return !!(checkboxGroupState == null ? void 0 : checkboxGroupState.value.disabled);
      } else {
        return props.disabled;
      }
    });
    const computedReadonly = computed(() => {
      if (isControlled.value) {
        return !!(checkboxGroupState == null ? void 0 : checkboxGroupState.value.readonly);
      } else {
        return props.readonly;
      }
    });
    const ariaChecked = computed(
      () => props.indeterminate ? "mixed" : proxiedModel.value
    );
    const hasCheckmark = computed(() => proxiedModel.value || props.indeterminate);
    function onClick(event) {
      if (computedReadonly.value) {
        event.preventDefault();
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$14, [
        createElementVNode("label", {
          class: normalizeClass(["b-checkbox__label", [
            `b-checkbox__label--${computedColorScheme.value}`,
            {
              "b-checkbox__label--disabled": computedDisabled.value,
              "b-checkbox__label--invalid": computedInvalid.value,
              "b-checkbox__label--readonly": computedReadonly.value
            }
          ]]),
          for: unref(checkboxId)
        }, [
          withDirectives(createElementVNode("input", mergeProps({
            id: unref(checkboxId),
            ref_key: "checkboxRef",
            ref: checkboxRef,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => proxiedModel.value = $event),
            type: "checkbox",
            disabled: computedDisabled.value,
            "aria-invalid": computedInvalid.value,
            "aria-checked": ariaChecked.value,
            class: ["b-checkbox__input", `b-checkbox__input--${computedColorScheme.value}`]
          }, unref(checkboxAttrs), { onClick }), null, 16, _hoisted_3$v), [
            [vModelCheckbox, proxiedModel.value]
          ]),
          createElementVNode("span", {
            class: normalizeClass(["b-checkbox__icon", [
              `b-checkbox__icon--${computedColorScheme.value}`,
              {
                "b-checkbox__icon--disabled": computedDisabled.value,
                "b-checkbox__icon--invalid": computedInvalid.value,
                "b-checkbox__icon--has-checkmark": hasCheckmark.value,
                "b-checkbox__icon--readonly": computedReadonly.value
              }
            ]])
          }, [
            hasCheckmark.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              _ctx.indeterminate ? (openBlock(), createBlock(unref(LessIcon), {
                key: 0,
                size: "md"
              })) : (openBlock(), createBlock(unref(CheckIcon), {
                key: 1,
                size: "md"
              }))
            ], 64)) : createCommentVNode("", true)
          ], 2),
          _ctx.label || unref(slots)["custom-label"] ? (openBlock(), createElementBlock("span", {
            key: 0,
            class: normalizeClass(["b-checkbox__text", [
              `b-checkbox__text--${computedColorScheme.value}`,
              {
                "b-checkbox__text--has-checkmark": hasCheckmark.value,
                "b-checkbox__text--disabled": computedDisabled.value,
                "b-checkbox__text--invalid": computedInvalid.value,
                "b-checkbox__text--readonly": computedReadonly.value
              }
            ]])
          }, [
            renderSlot(_ctx.$slots, "custom-label", {}, () => [
              createTextVNode(toDisplayString(_ctx.label), 1)
            ], true)
          ], 2)) : createCommentVNode("", true)
        ], 10, _hoisted_2$O),
        _ctx.invalid ? (openBlock(), createBlock(unref(BFormError), {
          key: 0,
          class: "b-checkbox__error",
          "color-scheme": _ctx.colorScheme,
          "error-message": _ctx.errorMessage
        }, null, 8, ["color-scheme", "error-message"])) : createCommentVNode("", true)
      ]);
    };
  }
});
const bCheckbox_vue_vue_type_style_index_0_scoped_336378b4_lang = "";
const BCheckbox = /* @__PURE__ */ _export_sfc(_sfc_main$1j, [["__scopeId", "data-v-336378b4"]]);
const _hoisted_1$13 = { class: "b-checkbox-group__wrapper" };
const _sfc_main$1i = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-checkbox-group",
  props: {
    modelValue: {},
    colorScheme: { default: "black" },
    disabled: { type: Boolean, default: false },
    invalid: { type: Boolean, default: false },
    readonly: { type: Boolean },
    errorMessage: { default: void 0 }
  },
  emits: {
    /**
     * Update model value
     */
    "update:modelValue": (value) => value
  },
  setup(__props, { emit }) {
    const props = __props;
    const checkboxGroupAttrs = useSafeAttrs(useAttrs());
    const checkboxStateMap = ref(/* @__PURE__ */ new Map());
    const registerCheckbox = (checkboxId) => {
      if (!checkboxStateMap.value.has(checkboxId)) {
        const indexInModelValue = checkboxStateMap.value.size;
        checkboxStateMap.value.set(checkboxId, props.modelValue[indexInModelValue]);
      }
    };
    const updateValue = (checkboxId, value) => {
      checkboxStateMap.value.set(checkboxId, value);
      emit("update:modelValue", [...checkboxStateMap.value.values()]);
    };
    const checkboxGroupState = computed(() => ({
      checkboxStateMap: checkboxStateMap.value,
      colorScheme: props.colorScheme,
      disabled: props.disabled,
      invalid: props.invalid,
      readonly: props.readonly,
      register: registerCheckbox,
      update: updateValue
    }));
    provide(CHECKBOX_GROUP_STATE_KEY, checkboxGroupState);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({ class: "b-checkbox-group" }, unref(checkboxGroupAttrs)), [
        createElementVNode("div", _hoisted_1$13, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        _ctx.invalid ? (openBlock(), createBlock(unref(BFormError), {
          key: 0,
          class: "b-checkbox-group__error",
          "color-scheme": _ctx.colorScheme,
          "error-message": _ctx.errorMessage
        }, null, 8, ["color-scheme", "error-message"])) : createCommentVNode("", true)
      ], 16);
    };
  }
});
const bCheckboxGroup_vue_vue_type_style_index_0_scoped_9f36d157_lang = "";
const bCheckboxGroup = /* @__PURE__ */ _export_sfc(_sfc_main$1i, [["__scopeId", "data-v-9f36d157"]]);
const _hoisted_1$12 = {
  key: 0,
  class: "b-listbox__header"
};
const _hoisted_2$N = { class: "b-listbox__header-selected-values" };
const _hoisted_3$u = {
  key: 0,
  class: "b-listbox__caption"
};
const _hoisted_4$j = ["aria-disabled", "aria-selected", "onClick"];
const _hoisted_5$d = {
  key: 0,
  class: "b-listbox__multiple-option"
};
const _hoisted_6$d = {
  key: 1,
  class: "b-listbox__single-option"
};
const _hoisted_7$a = { key: 0 };
const _hoisted_8$6 = { class: "b-listbox__option-text" };
const _hoisted_9$5 = {
  key: 1,
  class: "b-listbox__empty"
};
const _sfc_main$1h = /* @__PURE__ */ defineComponent({
  __name: "b-listbox",
  props: {
    options: {},
    modelValue: {},
    variant: {},
    multiSelectable: { type: Boolean },
    captionMessage: {}
  },
  emits: ["click-selected", "clear-all"],
  setup(__props, { expose: __expose, emit }) {
    const props = __props;
    const slots = useSlots();
    const listboxRef = ref(null);
    const listboxOptionsRef = ref(null);
    __expose({ listboxRef, listboxOptionsRef });
    const { applyDescendantAttributes, isActiveDescendant } = useActiveDescendantOptions() ?? {};
    function onSelect(value) {
      emit("click-selected", value);
    }
    function isSelected(value) {
      if (typeof props.modelValue === "string") {
        return props.modelValue === value;
      }
      if (Array.isArray(props.modelValue)) {
        return props.modelValue.includes(value);
      }
    }
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock("div", mergeProps({
        ref_key: "listboxRef",
        ref: listboxRef,
        class: "b-listbox"
      }, _ctx.$attrs), [
        _ctx.multiSelectable ? (openBlock(), createElementBlock("div", _hoisted_1$12, [
          createElementVNode("span", _hoisted_2$N, toDisplayString(`${((_a = _ctx.modelValue) == null ? void 0 : _a.length) ?? 0} selected`), 1),
          createElementVNode("button", {
            "aria-label": "Clear all previously selected options",
            class: "b-listbox__header-clear-button",
            onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("clear-all"), ["stop", "prevent"]))
          }, " Clear all ")
        ])) : createCommentVNode("", true),
        createElementVNode("div", {
          ref_key: "listboxOptionsRef",
          ref: listboxOptionsRef,
          role: "listbox",
          class: "b-listbox__options"
        }, [
          props.captionMessage ? (openBlock(), createElementBlock("div", _hoisted_3$u, toDisplayString(props.captionMessage), 1)) : createCommentVNode("", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option, idx) => {
            var _a2, _b;
            return openBlock(), createElementBlock("div", mergeProps((_a2 = unref(applyDescendantAttributes)) == null ? void 0 : _a2(idx, option.value), {
              key: option.value,
              class: ["b-listbox__option", {
                "b-listbox__option--selected": isSelected(option.value),
                "b-listbox__option--disabled": !!option.disabled,
                "b-listbox__option--active": (_b = unref(isActiveDescendant)) == null ? void 0 : _b(idx)
              }],
              "aria-disabled": !!option.disabled,
              "aria-selected": isSelected(option.value),
              role: "option",
              onMousedown: _cache[1] || (_cache[1] = withModifiers(() => {
              }, ["stop", "prevent"])),
              onClick: withModifiers(($event) => !option.disabled && onSelect(option.value), ["stop", "prevent"])
            }), [
              props.variant === "checkbox" ? (openBlock(), createElementBlock("div", _hoisted_5$d, [
                createVNode(unref(BCheckbox), {
                  disabled: !!option.disabled,
                  "aria-hidden": "true",
                  "model-value": !option.disabled && isSelected(option.value),
                  tabindex: "-1",
                  "onUpdate:modelValue": ($event) => onSelect(option.value)
                }, {
                  "custom-label": withCtx(() => [
                    createTextVNode(toDisplayString(option.label), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "model-value", "onUpdate:modelValue"])
              ])) : (openBlock(), createElementBlock("div", _hoisted_6$d, [
                props.variant === "ticks" ? (openBlock(), createElementBlock("div", _hoisted_7$a, [
                  createVNode(unref(CheckIcon), {
                    style: normalizeStyle({
                      visibility: isSelected(option.value) ? "visible" : "hidden"
                    }),
                    size: "md"
                  }, null, 8, ["style"])
                ])) : createCommentVNode("", true),
                createElementVNode("span", _hoisted_8$6, toDisplayString(option.label), 1)
              ]))
            ], 16, _hoisted_4$j);
          }), 128)),
          unref(slots)["empty-content"] ? (openBlock(), createElementBlock("div", _hoisted_9$5, [
            renderSlot(_ctx.$slots, "empty-content", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ], 512)
      ], 16);
    };
  }
});
const bListbox_vue_vue_type_style_index_0_scoped_5e75504e_lang = "";
const BListbox = /* @__PURE__ */ _export_sfc(_sfc_main$1h, [["__scopeId", "data-v-5e75504e"]]);
const LISTBOX_DISTANCE_FROM_VIEWPORT_EDGE = 64;
const createListboxIds = () => {
  const triggerId = `listbox-trigger-${generateUniqueId()}`;
  const listboxId = `listbox-menu-${generateUniqueId()}`;
  return {
    triggerId,
    listboxId
  };
};
const useListboxFloating = ({
  listboxRef,
  referenceRef
}) => {
  const floating = useFloating(referenceRef, listboxRef, {
    placement: "bottom",
    middleware: [
      offset(5),
      flip(),
      size({
        apply({ availableHeight, elements }) {
          Object.assign(elements.floating.style, {
            minHeight: "3rem",
            maxHeight: `${availableHeight - LISTBOX_DISTANCE_FROM_VIEWPORT_EDGE}px`
          });
        }
      })
    ]
  });
  return floating;
};
const _hoisted_1$11 = { class: "b-spinner" };
const _sfc_main$1g = /* @__PURE__ */ defineComponent({
  __name: "b-spinner",
  props: {
    color: { default: "currentColor" },
    size: { default: "md" },
    display: { default: "flex" }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "1641392c": _ctx.display
    }));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$11, [
        createVNode(unref(SpinnerIcon), {
          class: "b-spinner-icon",
          fill: _ctx.color,
          size: _ctx.size
        }, null, 8, ["fill", "size"])
      ]);
    };
  }
});
const bSpinner_vue_vue_type_style_index_0_scoped_563e200a_lang = "";
const BSpinner = /* @__PURE__ */ _export_sfc(_sfc_main$1g, [["__scopeId", "data-v-563e200a"]]);
const isOptionPartialMatch = (optionLabel, searchText) => normalizeString(optionLabel).includes(normalizeString(searchText));
const isOptionExactMatch = (optionLabel, searchText) => normalizeString(optionLabel) === normalizeString(searchText);
const _hoisted_1$10 = ["onKeydown"];
const _hoisted_2$M = ["for"];
const _hoisted_3$t = ["tabindex", "disabled", "aria-readonly", "aria-controls", "aria-expanded", "aria-activedescendant", "onKeydown"];
const _hoisted_4$i = {
  key: 0,
  class: "b-autocomplete__chips-cloud"
};
const _hoisted_5$c = {
  key: 1,
  class: "b-autocomplete__selections"
};
const _hoisted_6$c = { class: "b-autocomplete__chips-cloud" };
const _hoisted_7$9 = ["id", "aria-controls", "aria-expanded", "aria-activedescendant", "onKeydown"];
const _hoisted_8$5 = { class: "b-autocomplete__suffix" };
const _hoisted_9$4 = ["onClick"];
const _hoisted_10$2 = {
  key: 1,
  class: "b-autocomplete__spinner"
};
const _hoisted_11$1 = {
  key: 0,
  class: "b-autocomplete__messages"
};
const _hoisted_12 = {
  key: 0,
  class: "b-autocomplete__empty-content"
};
const _hoisted_13 = {
  key: 1,
  class: "b-autocomplete__empty-content"
};
const _sfc_main$1f = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-autocomplete",
  props: {
    colorScheme: { default: "black" },
    options: {},
    modelValue: {},
    label: {},
    invalid: { type: Boolean },
    disabled: { type: Boolean, default: void 0 },
    readonly: { type: Boolean, default: void 0 },
    errorMessage: { default: null },
    hint: { default: void 0 },
    loading: { type: Boolean },
    variant: { default: "single" },
    creatable: { type: Boolean },
    clearSearchOnSelection: { type: Boolean, default: false },
    notFoundMessage: { default: "No matches to your query could be found. Try another search term" },
    emptyMessage: { default: "No options available" },
    isMatch: { type: Function, default: isOptionPartialMatch }
  },
  emits: ["update:modelValue", "search"],
  setup(__props, { expose: __expose, emit: emits }) {
    const props = __props;
    const safeAttrs = useSafeAttrs(useAttrs());
    const autocompleteRef = ref(null);
    const triggerRef = ref(null);
    const listboxRef = ref(null);
    const searchInputRef = ref(null);
    const formControlRef = ref(null);
    __expose({
      trigger: triggerRef,
      autocomplete: autocompleteRef,
      search: searchInputRef
    });
    const isExpanded = ref(false);
    const internalModel = ref(props.modelValue);
    const searchModel = ref("");
    const createdValues = ref([]);
    const { listboxId, triggerId } = createListboxIds();
    const { floatingStyles, update: updateListboxPlacement } = useListboxFloating({
      listboxRef,
      referenceRef: formControlRef
    });
    const search = computed({
      get: () => searchModel.value,
      set: (value) => {
        searchModel.value = value;
        emits("search", value);
      }
    });
    const proxiedModel = computed({
      get: () => internalModel.value,
      set: (value) => {
        internalModel.value = value;
        if (props.modelValue !== value) {
          emits("update:modelValue", value);
        }
        updateListboxPlacement();
      }
    });
    const mergedOptions = computed(() => {
      return [...props.options, ...createdValues.value];
    });
    const availableOptions = computed(() => {
      if (props.variant === "chips") {
        return mergedOptions.value.filter(
          (option) => !props.modelValue.includes(option.value)
        );
      }
      return [...mergedOptions.value];
    });
    const filteredOptions = computed(() => {
      return availableOptions.value.filter(
        (option) => props.isMatch(option.label, search.value)
      );
    });
    const hasNoOptions = computed(() => {
      return mergedOptions.value.length === 0;
    });
    const shouldShowEmptyMessage = computed(() => {
      if (filteredOptions.value.length > 0) {
        return false;
      }
      if (props.creatable && searchModel.value.length > 0 && Array.isArray(proxiedModel.value)) {
        return !!proxiedModel.value.some(
          (value) => isOptionExactMatch(value, searchModel.value)
        );
      }
      return !props.loading && searchModel.value.length > 0 && filteredOptions.value.length === 0;
    });
    const shouldShowCreatableRow = computed(() => {
      if (props.variant !== "chips" || !props.creatable || !Array.isArray(proxiedModel.value)) {
        return false;
      }
      if (search.value.trim().length === 0) {
        return false;
      }
      if (!proxiedModel.value.some(
        (value) => isOptionExactMatch(value, searchModel.value)
      )) {
        return true;
      }
      return false;
    });
    const captionMessage = computed(() => {
      if (props.loading) {
        return "Loading...";
      }
      if (search.value.length > 0) {
        return `${filteredOptions.value.length} result${filteredOptions.value.length === 1 ? `` : `s`}`;
      }
      return "";
    });
    const optionsDisplayed = computed(
      () => search.value.length > 0 ? filteredOptions.value : availableOptions.value
    );
    const listboxVariant = computed(
      () => props.variant === "chips" ? "default" : props.variant === "multiple" ? "checkbox" : "ticks"
    );
    const isPopulated = computed(
      () => isExpanded.value || proxiedModel.value.length > 0
    );
    const displaySelections = computed(() => {
      var _a;
      if (props.variant === "chips") {
        return "";
      }
      if (props.variant === "multiple" && proxiedModel.value.length > 0) {
        return `${proxiedModel.value.length} selected`;
      }
      if (props.variant === "single" && proxiedModel.value.length > 0) {
        return ((_a = mergedOptions.value.find((option) => option.value === internalModel.value)) == null ? void 0 : _a.label) ?? "";
      }
      return "";
    });
    const hasSmallLabel = computed(() => {
      if (isPopulated.value) {
        return true;
      }
      if (props.disabled || props.readonly) {
        return false;
      }
      return focused.value;
    });
    const {
      activeDescendantId,
      getActiveDescendant,
      getActiveDescendantValue,
      goToNextDescendant,
      goToPreviousDescendant,
      goToLastDescendant,
      goToFirstDescendant,
      resetDescendant
    } = useActiveDescendant({
      descendants: optionsDisplayed
    });
    watch(
      () => activeDescendantId.value,
      (value) => {
        if (value) {
          const activeDescendant = getActiveDescendant();
          activeDescendant == null ? void 0 : activeDescendant.scrollIntoView({
            block: "nearest",
            inline: "nearest"
          });
        }
      }
    );
    watch(
      () => props.modelValue,
      (value) => {
        proxiedModel.value = value;
      }
    );
    onClickOutside(autocompleteRef, () => {
      closeDropdown();
    });
    function onEnterKey() {
      const value = getActiveDescendantValue();
      if (value) {
        select(value);
      }
    }
    function onClickSelect(value) {
      select(value);
    }
    function onCreatable(value) {
      createdValues.value = [
        ...createdValues.value,
        {
          label: value,
          value
        }
      ];
      select(value);
    }
    function onResetModels() {
      if (props.variant === "single") {
        proxiedModel.value = "";
      } else {
        proxiedModel.value = [];
      }
      search.value = "";
    }
    function onDelete(e) {
      if (searchModel.value.length === 0 && props.variant === "chips") {
        e.preventDefault();
        deleteLastSelection();
        return;
      }
    }
    function onAutocompleteClick() {
      if (isExpanded.value) {
        focusSearchInput();
      } else {
        openDropdown();
      }
    }
    function onChevronClick() {
      isExpanded.value ? closeDropdown() : openDropdown();
    }
    function select(value) {
      if (isSelected(value)) {
        return deselect(value);
      }
      if (props.variant === "chips") {
        props.clearSearchOnSelection && (search.value = "");
        proxiedModel.value = [...proxiedModel.value, value];
        return;
      }
      if (props.variant === "multiple") {
        props.clearSearchOnSelection && (search.value = "");
        proxiedModel.value = [...proxiedModel.value, value];
        return;
      }
      if (props.variant === "single") {
        search.value = "";
        proxiedModel.value = value;
        closeDropdown();
        nextTick(() => {
          focusTrigger();
        });
        return;
      }
    }
    function deselect(value) {
      if (props.creatable) {
        createdValues.value = createdValues.value.filter((v) => v.value !== value);
      }
      if (props.variant === "chips" || props.variant === "multiple") {
        proxiedModel.value = proxiedModel.value.filter(
          (v) => v !== value
        );
        nextTick(() => {
          focusSearchInput();
        });
        return;
      }
      if (props.variant === "single") {
        nextTick(() => {
          focusTrigger();
        });
        return;
      }
    }
    function openDropdown() {
      if (props.disabled || props.readonly || isExpanded.value) {
        return;
      }
      isExpanded.value = true;
      nextTick(() => {
        focusSearchInput();
      });
    }
    function closeDropdown() {
      search.value = "";
      isExpanded.value = false;
      resetDescendant();
    }
    function onEscKey() {
      if (isExpanded.value) {
        closeDropdown();
        nextTick(() => {
          focusTrigger();
        });
      }
    }
    function focusSearchInput() {
      var _a;
      (_a = searchInputRef.value) == null ? void 0 : _a.focus();
    }
    function focusTrigger() {
      var _a;
      (_a = triggerRef.value) == null ? void 0 : _a.focus();
    }
    function isSelected(value) {
      if (props.variant === "single") {
        return proxiedModel.value === value;
      } else {
        return proxiedModel.value.includes(value);
      }
    }
    function deleteLastSelection() {
      if (proxiedModel.value.length > 0) {
        proxiedModel.value = proxiedModel.value.slice(
          0,
          proxiedModel.value.length - 1
        );
      }
    }
    function generateChipProps(value) {
      var _a;
      const label = ((_a = mergedOptions.value.find((option) => option.value === value)) == null ? void 0 : _a.label) ?? "";
      return {
        label,
        onDelete: props.readonly || props.disabled ? void 0 : () => deselect(value),
        colorScheme: props.colorScheme,
        size: "md",
        disabled: props.disabled,
        readonly: props.readonly
      };
    }
    function onMouseDown(event) {
      if (event.target !== searchInputRef.value) {
        event.preventDefault();
      }
    }
    const { focused } = useFocusWithin(autocompleteRef);
    watch(
      () => focused.value,
      (val) => {
        if (!val) {
          closeDropdown();
          return;
        }
        if (val && !isExpanded.value) {
          openDropdown();
        }
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(unref(safeAttrs), {
        ref_key: "autocompleteRef",
        ref: autocompleteRef,
        class: "b-autocomplete",
        onMousedown: onMouseDown,
        onKeydown: withKeys(withModifiers(onEscKey, ["prevent"]), ["escape"])
      }), [
        createElementVNode("div", {
          ref_key: "formControlRef",
          ref: formControlRef,
          class: normalizeClass(["b-autocomplete__form-control", [
            `b-autocomplete__form-control--${_ctx.colorScheme}`,
            {
              "b-autocomplete__form-control--invalid": _ctx.invalid,
              "b-autocomplete__form-control--disabled": _ctx.disabled,
              "b-autocomplete__form-control--readonly": _ctx.readonly,
              "b-autocomplete__form-control--cursor-pointer": !_ctx.disabled && !_ctx.readonly,
              "b-autocomplete__form-control--auto-height": _ctx.variant === "chips"
            }
          ]]),
          onClick: onAutocompleteClick
        }, [
          createElementVNode("label", {
            class: normalizeClass(["b-autocomplete__label", [
              `b-autocomplete__label--${_ctx.colorScheme}`,
              {
                "b-autocomplete__label--small": hasSmallLabel.value,
                "b-autocomplete__label--disabled": _ctx.disabled,
                "b-autocomplete__label--readonly": _ctx.readonly,
                "b-autocomplete__label--invalid": _ctx.invalid
              }
            ]]),
            for: unref(triggerId)
          }, toDisplayString(_ctx.label), 11, _hoisted_2$M),
          createElementVNode("div", {
            class: normalizeClass(["b-autocomplete__control", {
              "b-autocomplete__control--auto-height": _ctx.variant === "chips"
            }])
          }, [
            withDirectives(createElementVNode("div", {
              ref_key: "triggerRef",
              ref: triggerRef,
              tabindex: _ctx.disabled ? -1 : 0,
              role: "combobox",
              disabled: _ctx.disabled,
              "aria-readonly": _ctx.readonly,
              autocomplete: "off",
              "aria-autocomplete": "list",
              spellcheck: "false",
              "aria-controls": unref(listboxId),
              "aria-expanded": isExpanded.value,
              "aria-haspopup": "listbox",
              "aria-activedescendant": unref(activeDescendantId),
              class: "b-autocomplete__trigger",
              onKeydown: withKeys(withModifiers(openDropdown, ["prevent"]), ["down", "enter", "space", "up"])
            }, [
              props.variant === "chips" ? (openBlock(), createElementBlock("div", _hoisted_4$i, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(proxiedModel.value, (selectedValue) => {
                  return openBlock(), createBlock(unref(BChipInput), mergeProps({ key: selectedValue }, generateChipProps(selectedValue), {
                    onKeydown: [
                      _cache[0] || (_cache[0] = withKeys(withModifiers(() => {
                      }, ["stop"]), ["space"])),
                      _cache[1] || (_cache[1] = withKeys(withModifiers(() => {
                      }, ["stop"]), ["enter"]))
                    ]
                  }), null, 16);
                }), 128))
              ])) : (openBlock(), createElementBlock("span", _hoisted_5$c, toDisplayString(displaySelections.value), 1))
            ], 40, _hoisted_3$t), [
              [vShow, !isExpanded.value]
            ]),
            withDirectives(createElementVNode("div", _hoisted_6$c, [
              props.variant === "chips" ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(proxiedModel.value, (selectedValue) => {
                return openBlock(), createBlock(unref(BChipInput), mergeProps({ key: selectedValue }, generateChipProps(selectedValue), {
                  onKeydown: [
                    _cache[2] || (_cache[2] = withKeys(withModifiers(() => {
                    }, ["stop"]), ["space"])),
                    _cache[3] || (_cache[3] = withKeys(withModifiers(() => {
                    }, ["stop"]), ["enter"]))
                  ]
                }), null, 16);
              }), 128)) : createCommentVNode("", true),
              withDirectives(createElementVNode("input", {
                id: unref(triggerId),
                ref_key: "searchInputRef",
                ref: searchInputRef,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => search.value = $event),
                class: normalizeClass(["b-autocomplete__search", `b-autocomplete__search--${_ctx.colorScheme}`]),
                type: "text",
                placeholder: "Search...",
                role: "combobox",
                autocomplete: "off",
                "aria-autocomplete": "list",
                autocapitalize: "false",
                spellcheck: "false",
                "aria-controls": unref(listboxId),
                "aria-expanded": isExpanded.value,
                "aria-haspopup": "listbox",
                "aria-activedescendant": unref(activeDescendantId),
                onKeydown: [
                  withKeys(onDelete, ["delete"]),
                  _cache[5] || (_cache[5] = withKeys(withModifiers(
                    //@ts-ignore
                    (...args) => unref(goToPreviousDescendant) && unref(goToPreviousDescendant)(...args),
                    ["prevent"]
                  ), ["up"])),
                  _cache[6] || (_cache[6] = withKeys(withModifiers(
                    //@ts-ignore
                    (...args) => unref(goToNextDescendant) && unref(goToNextDescendant)(...args),
                    ["prevent"]
                  ), ["down"])),
                  withKeys(withModifiers(onEnterKey, ["prevent"]), ["enter"]),
                  _cache[7] || (_cache[7] = withKeys(withModifiers(
                    //@ts-ignore
                    (...args) => unref(goToFirstDescendant) && unref(goToFirstDescendant)(...args),
                    ["prevent"]
                  ), ["home"])),
                  _cache[8] || (_cache[8] = withKeys(withModifiers(
                    //@ts-ignore
                    (...args) => unref(goToLastDescendant) && unref(goToLastDescendant)(...args),
                    ["prevent"]
                  ), ["end"]))
                ]
              }, null, 42, _hoisted_7$9), [
                [vModelText, search.value]
              ])
            ], 512), [
              [vShow, isExpanded.value]
            ])
          ], 2),
          createElementVNode("div", _hoisted_8$5, [
            !_ctx.loading ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "b-autocomplete__toggle-icon",
              onClick: withModifiers(onChevronClick, ["stop", "prevent"])
            }, [
              isExpanded.value ? (openBlock(), createBlock(unref(ChevronUpIcon), {
                key: 0,
                size: "md"
              })) : (openBlock(), createBlock(unref(ChevronDownIcon), {
                key: 1,
                size: "md"
              }))
            ], 8, _hoisted_9$4)) : (openBlock(), createElementBlock("div", _hoisted_10$2, [
              createVNode(unref(BSpinner), { size: "md" })
            ]))
          ])
        ], 2),
        _ctx.invalid && !!_ctx.errorMessage || _ctx.hint ? (openBlock(), createElementBlock("div", _hoisted_11$1, [
          _ctx.invalid ? (openBlock(), createBlock(unref(BFormError), {
            key: 0,
            class: "b-autocomplete__error",
            "color-scheme": _ctx.colorScheme,
            invalid: _ctx.invalid,
            "error-message": _ctx.errorMessage
          }, null, 8, ["color-scheme", "invalid", "error-message"])) : createCommentVNode("", true),
          !!_ctx.hint ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(["b-autocomplete__hint", [`b-autocomplete__hint--${_ctx.colorScheme}`]])
          }, toDisplayString(_ctx.hint), 3)) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        isExpanded.value ? (openBlock(), createBlock(unref(BListbox), {
          key: 1,
          id: unref(listboxId),
          ref_key: "listboxRef",
          ref: listboxRef,
          "aria-labelledby": unref(triggerId),
          "caption-message": captionMessage.value,
          "model-value": proxiedModel.value,
          "multi-selectable": props.variant !== "single",
          options: optionsDisplayed.value,
          style: normalizeStyle(unref(floatingStyles)),
          variant: listboxVariant.value,
          onClickSelected: onClickSelect,
          onClearAll: onResetModels
        }, createSlots({ _: 2 }, [
          hasNoOptions.value || shouldShowCreatableRow.value || shouldShowEmptyMessage.value ? {
            name: "empty-content",
            fn: withCtx(() => [
              hasNoOptions.value ? (openBlock(), createElementBlock("div", _hoisted_12, toDisplayString(_ctx.emptyMessage), 1)) : shouldShowEmptyMessage.value ? (openBlock(), createElementBlock("div", _hoisted_13, toDisplayString(_ctx.notFoundMessage), 1)) : createCommentVNode("", true),
              shouldShowCreatableRow.value ? (openBlock(), createElementBlock("button", {
                key: 2,
                class: "b-autocomplete__creatable-row",
                onClick: _cache[9] || (_cache[9] = withModifiers(($event) => onCreatable(search.value), ["stop", "prevent"]))
              }, ' Create "' + toDisplayString(search.value) + '" ', 1)) : createCommentVNode("", true)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["id", "aria-labelledby", "caption-message", "model-value", "multi-selectable", "options", "style", "variant"])) : createCommentVNode("", true)
      ], 16, _hoisted_1$10);
    };
  }
});
const bAutocomplete_vue_vue_type_style_index_0_scoped_824b3f4a_lang = "";
const bAutocomplete = /* @__PURE__ */ _export_sfc(_sfc_main$1f, [["__scopeId", "data-v-824b3f4a"]]);
const _hoisted_1$$ = {
  key: 0,
  class: "b-avatar__figure"
};
const _hoisted_2$L = ["src", "srcset", "alt"];
const _hoisted_3$s = { key: 1 };
const _sfc_main$1e = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-avatar",
  props: {
    src: { default: void 0 },
    srcSet: { default: void 0 },
    alt: {},
    size: { default: "lg" },
    colorScheme: { default: "black" },
    initials: { default: void 0 }
  },
  setup(__props) {
    const props = __props;
    const SIZE_TO_INITIALS_MAP = {
      "3xl": 2,
      "2xl": 2,
      "xl": 2,
      "lg": 2,
      "md": 2,
      "sm": 1,
      "xs": 1,
      "2xs": 1,
      "3xs": 1
    };
    const imageError = ref(false);
    const handleImageError = () => {
      imageError.value = true;
    };
    const sanitizedInitials = computed(() => {
      if (typeof props.initials !== "string" || props.initials.length === 0) {
        return;
      }
      return props.initials.trim().slice(0, SIZE_TO_INITIALS_MAP[props.size]).toUpperCase();
    });
    const showImage = computed(() => {
      return !imageError.value && props.src !== void 0 && props.src.length > 0;
    });
    watch(
      () => props.src,
      () => {
        imageError.value = false;
      }
    );
    const avatarAttrs = useSafeAttrs(useAttrs());
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({ class: "b-avatar" }, unref(avatarAttrs), {
        class: [
          `b-avatar--${_ctx.size}`,
          `b-avatar--${_ctx.colorScheme}`,
          { "b-avatar--with-image": showImage.value }
        ]
      }), [
        showImage.value ? (openBlock(), createElementBlock("figure", _hoisted_1$$, [
          createElementVNode("img", {
            src: _ctx.src,
            class: "b-avatar__img",
            srcset: _ctx.srcSet,
            alt: _ctx.alt,
            onError: handleImageError
          }, null, 40, _hoisted_2$L)
        ])) : (openBlock(), createElementBlock("p", _hoisted_3$s, toDisplayString(sanitizedInitials.value), 1))
      ], 16);
    };
  }
});
const bAvatar_vue_vue_type_style_index_0_scoped_574bc087_lang = "";
const bAvatar = /* @__PURE__ */ _export_sfc(_sfc_main$1e, [["__scopeId", "data-v-574bc087"]]);
function isExternalLink(link) {
  const externalPrefixes = [
    "http",
    "mailto",
    "tel:",
    "data:",
    "javascript:",
    "file:",
    "ftp:",
    "sftp:",
    "whatsapp:",
    "#",
    "://"
  ];
  return !!link && typeof link === "string" && externalPrefixes.some((externalPrefix) => link.startsWith(externalPrefix));
}
const ARROW_SIZE = 6;
const TOOLTIP_SKIDDING = -8;
const TOOLTIP_OFFSET = 2;
const TOOLTIP_DISTANCE = ARROW_SIZE + TOOLTIP_OFFSET;
const TOOLTIP_SCREEN_BORDER_PADDING = 10;
const _hoisted_1$_ = ["onKeydown"];
const _hoisted_2$K = ["id", "aria-hidden"];
const _sfc_main$1d = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-tooltip",
  props: {
    placement: { default: "auto" },
    forceVisible: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const tooltipAttrs = useSafeAttrs(useAttrs());
    const contentRef = ref(null);
    const contentArrowRef = ref(null);
    const triggerRef = ref(null);
    const tooltipActive = ref(false);
    const tooltipId = generateUniqueId();
    const shouldAddAutoplacementMiddlewere = () => props.placement === "auto" ? [autoPlacement()] : [];
    const middleware = ref([
      ...shouldAddAutoplacementMiddlewere(),
      offset({
        mainAxis: TOOLTIP_DISTANCE,
        alignmentAxis: TOOLTIP_SKIDDING
      }),
      flip(),
      shift({
        limiter: limitShift(),
        padding: TOOLTIP_SCREEN_BORDER_PADDING
      }),
      arrow({
        element: contentArrowRef,
        padding: TOOLTIP_DISTANCE
      })
    ]);
    const placement = computed(
      () => props.placement === "auto" ? void 0 : props.placement
    );
    const {
      floatingStyles,
      middlewareData,
      placement: floatingPlacement
    } = useFloating(triggerRef, contentRef, {
      placement,
      middleware,
      whileElementsMounted: autoUpdate
    });
    const side = computed(() => floatingPlacement.value.split("-")[0]);
    const contentArrowPosition = computed(() => {
      const { x, y } = middlewareData.value.arrow ?? {};
      const isLeftPlacement = floatingPlacement.value.includes("left");
      const isTopPlacement = floatingPlacement.value.includes("top");
      return {
        left: x ? `${x}px` : isLeftPlacement ? "100%" : "0",
        top: y ? `${y}px` : isTopPlacement ? "100%" : "0"
      };
    });
    const tooltipVisible = computed(
      () => props.forceVisible || tooltipActive.value
    );
    function show() {
      tooltipActive.value = true;
    }
    function hide() {
      tooltipActive.value = false;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "b-tooltip",
        onMouseleave: hide,
        onKeydown: withKeys(hide, ["esc"])
      }, [
        createElementVNode("div", {
          ref_key: "triggerRef",
          ref: triggerRef,
          class: "b-tooltip__trigger"
        }, [
          renderSlot(_ctx.$slots, "trigger", {
            ariaDescribedby: unref(tooltipId),
            onFocus: show,
            onBlur: hide,
            onMouseenter: show
          }, void 0, true)
        ], 512),
        tooltipVisible.value ? (openBlock(), createElementBlock("div", mergeProps({
          key: 0,
          id: unref(tooltipId),
          ref_key: "contentRef",
          ref: contentRef
        }, unref(tooltipAttrs), {
          class: ["b-tooltip__content", `b-tooltip__content--${side.value}`],
          style: unref(floatingStyles),
          role: "tooltip",
          "aria-hidden": !tooltipVisible.value,
          "aria-live": "polite"
        }), [
          renderSlot(_ctx.$slots, "content", {}, void 0, true),
          createElementVNode("div", {
            ref_key: "contentArrowRef",
            ref: contentArrowRef,
            class: "b-tooltip__content-arrow",
            style: normalizeStyle(contentArrowPosition.value)
          }, null, 4)
        ], 16, _hoisted_2$K)) : createCommentVNode("", true)
      ], 40, _hoisted_1$_);
    };
  }
});
const bTooltip_vue_vue_type_style_index_0_scoped_af0f0086_lang = "";
const BTooltip = /* @__PURE__ */ _export_sfc(_sfc_main$1d, [["__scopeId", "data-v-af0f0086"]]);
const BREADCRUMB_COLORSCHEME_SYMBOL = Symbol.for(
  "breadcrumb-colorscheme"
);
const _hoisted_1$Z = { class: "b-breadcrumbs-item__wrapper" };
const _hoisted_2$J = { class: "b-breadcrumbs-item__text" };
const MAX_CHARACTERS = 35;
const _sfc_main$1c = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-breadcrumbs-item",
  props: {
    label: {},
    to: {},
    onClick: {},
    home: { type: Boolean },
    as: { default: "a" }
  },
  setup(__props) {
    const props = __props;
    const attrs = useSafeAttrs(useAttrs());
    const breakpoints = useBreakpoints();
    const greaterOrEqualThanLarge = breakpoints.greaterOrEqual("lg");
    const hasMouse = useHasMouse();
    const colorScheme = inject(
      BREADCRUMB_COLORSCHEME_SYMBOL
    );
    const isTooltipVisible = computed(() => {
      return hasMouse.value && hasTrimmedText.value;
    });
    const hasTrimmedText = computed(() => {
      return props.label && props.label.length >= MAX_CHARACTERS;
    });
    const textLabel = computed(() => {
      if (!props.label) {
        return "";
      }
      return hasTrimmedText.value ? `${props.label.slice(0, MAX_CHARACTERS)}...` : props.label;
    });
    const hrefProp = computed(
      () => typeof props.to === "string" && isExternalLink(props.to) ? { href: props.to } : { to: props.to }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["b-breadcrumbs-item", [`b-breadcrumbs-item--${unref(colorScheme)}`]])
      }, [
        _ctx.home ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.as), mergeProps({
          key: 0,
          class: "b-breadcrumbs-item__home"
        }, { ...unref(attrs), ...hrefProp.value, "aria-label": _ctx.label || "Home" }), {
          default: withCtx(() => [
            createVNode(unref(HomeFillIcon), { size: "sm" })
          ]),
          _: 1
        }, 16)) : (openBlock(), createBlock(resolveDynamicComponent(_ctx.as), normalizeProps(mergeProps({ key: 1 }, { ...unref(attrs), ...hrefProp.value })), {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_1$Z, [
              !unref(greaterOrEqualThanLarge) ? (openBlock(), createBlock(unref(ChevronLeftIcon), {
                key: 0,
                size: "sm",
                class: "b-breadcrumbs-item__backlink-icon"
              })) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_2$J, [
                isTooltipVisible.value ? (openBlock(), createBlock(unref(BTooltip), {
                  key: 0,
                  placement: "bottom"
                }, {
                  trigger: withCtx((scope) => [
                    createElementVNode("span", normalizeProps(guardReactiveProps(scope)), toDisplayString(textLabel.value), 17)
                  ]),
                  content: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.label), 1)
                  ]),
                  _: 1
                })) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(textLabel.value), 1)
                ], 64))
              ])
            ])
          ]),
          _: 1
        }, 16))
      ], 2);
    };
  }
});
const bBreadcrumbsItem_vue_vue_type_style_index_0_scoped_4a3fb311_lang = "";
const BBreadcrumbsItem = /* @__PURE__ */ _export_sfc(_sfc_main$1c, [["__scopeId", "data-v-4a3fb311"]]);
const _hoisted_1$Y = { class: "b-breadcrumbs__list" };
const _hoisted_2$I = {
  key: 0,
  class: "b-breadcrumbs__separator"
};
const _hoisted_3$r = { class: "b-breadcrumbs__backlink" };
const _sfc_main$1b = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-breadcrumbs",
  props: {
    colorScheme: { default: "black" },
    items: {}
  },
  setup(__props) {
    const props = __props;
    const attrs = useAttrs();
    const breadcrumbsAttrs = useSafeAttrs(attrs);
    const breakpoints = useBreakpoints();
    const greaterOrEqualThanLarge = breakpoints.greaterOrEqual("lg");
    const lastItemIdx = computed(() => props.items.length - 1);
    const lastLink = computed(() => props.items.at(lastItemIdx.value));
    const colorScheme = computed(() => props.colorScheme);
    provide(BREADCRUMB_COLORSCHEME_SYMBOL, colorScheme);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", mergeProps(unref(breadcrumbsAttrs), {
        class: ["b-breadcrumbs", `b-breadcrumbs--${colorScheme.value}`],
        "data-cy": "b-breadcrumbs"
      }), [
        createElementVNode("ul", _hoisted_1$Y, [
          unref(greaterOrEqualThanLarge) ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.items, (item, idx) => {
            return openBlock(), createElementBlock("li", {
              key: item.label,
              class: "b-breadcrumbs__item"
            }, [
              renderSlot(_ctx.$slots, "item", { item }, () => [
                createVNode(BBreadcrumbsItem, normalizeProps(guardReactiveProps(item)), null, 16)
              ], true),
              idx < lastItemIdx.value ? (openBlock(), createElementBlock("div", _hoisted_2$I, [
                createVNode(unref(ChevronRightIcon), { size: "sm" })
              ])) : createCommentVNode("", true)
            ]);
          }), 128)) : renderSlot(_ctx.$slots, "item", {
            key: 1,
            item: lastLink.value
          }, () => [
            createElementVNode("div", _hoisted_3$r, [
              createVNode(BBreadcrumbsItem, normalizeProps(guardReactiveProps(lastLink.value)), null, 16)
            ])
          ], true)
        ])
      ], 16);
    };
  }
});
const bBreadcrumbs_vue_vue_type_style_index_0_scoped_734a52c2_lang = "";
const bBreadcrumbs = /* @__PURE__ */ _export_sfc(_sfc_main$1b, [["__scopeId", "data-v-734a52c2"]]);
function linkHrefParser(props) {
  const { as, to } = props;
  if (!to) {
    return {};
  }
  if (as === "a") {
    return {
      href: to
    };
  }
  if (as === "router-link") {
    return {
      to
    };
  }
  if (typeof as === "object") {
    return { to };
  }
  return {};
}
const _hoisted_1$X = { class: "b-button__spinner" };
const _sfc_main$1a = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-button",
  props: {
    colorScheme: { default: "blue" },
    disabled: { type: Boolean, default: void 0 },
    loading: { type: Boolean, default: false },
    variant: { default: "fill" },
    size: { default: "md" },
    iconPosition: { default: "right" },
    as: { default: "button" },
    to: {}
  },
  emits: ["click"],
  setup(__props, { expose: __expose, emit }) {
    const props = __props;
    useCssVars((_ctx) => ({
      "6bf96eb0": iconOrder.value
    }));
    const slots = useSlots();
    const buttonRef = ref(null);
    __expose({
      button: buttonRef
    });
    const btnAttrs = useSafeAttrs(useAttrs());
    const buttonSizeToSpinnerSizeMap = {
      sm: "md",
      md: "lg",
      lg: "lg"
    };
    const buttonSizeToIconSizeMap = {
      sm: "sm",
      md: "md",
      lg: "md"
    };
    const spinnerSize = computed(() => buttonSizeToSpinnerSizeMap[props.size]);
    const iconSize = computed(() => buttonSizeToIconSizeMap[props.size]);
    const iconOrder = computed(() => props.iconPosition === "left" ? 0 : 1);
    const linkAttrs = computed(
      () => linkHrefParser({ as: props.as, to: props.to })
    );
    const isLink = computed(() => !!props.to);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.as), mergeProps({
        ref_key: "buttonRef",
        ref: buttonRef,
        role: isLink.value ? "link" : "button",
        "data-cy": "b-button"
      }, { ...unref(btnAttrs), ...linkAttrs.value }, {
        class: ["b-button", [
          `b-button--${_ctx.colorScheme}`,
          `b-button--${_ctx.size}`,
          `b-button--${_ctx.variant}`,
          {
            "b-button--loading": _ctx.loading,
            "b-button--disabled": _ctx.disabled
          }
        ]],
        tabindex: isLink.value && _ctx.disabled ? -1 : 0,
        "aria-disabled": _ctx.disabled,
        disabled: _ctx.disabled,
        onClick: _cache[0] || (_cache[0] = ($event) => emit("click", $event))
      }), {
        default: withCtx(() => [
          unref(slots)["icon"] ? (openBlock(), createElementBlock("div", {
            key: 0,
            "data-cy": "b-button-icon",
            class: normalizeClass([
              "b-button__icon",
              !_ctx.loading ? "b-button__icon--visibile" : "b-button__icon--hidden"
            ])
          }, [
            renderSlot(_ctx.$slots, "icon", {
              size: iconSize.value,
              fill: "currentColor"
            }, void 0, true)
          ], 2)) : createCommentVNode("", true),
          withDirectives(createElementVNode("span", _hoisted_1$X, [
            createVNode(unref(BSpinner), { size: spinnerSize.value }, null, 8, ["size"])
          ], 512), [
            [vShow, _ctx.loading]
          ]),
          createElementVNode("span", {
            class: normalizeClass(["b-button__text", {
              "b-button__text--visible": !_ctx.loading,
              "b-button__text--hidden": _ctx.loading
            }])
          }, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 2)
        ]),
        _: 3
      }, 16, ["role", "tabindex", "aria-disabled", "disabled", "class"]);
    };
  }
});
const bButton_vue_vue_type_style_index_0_scoped_abb99f1c_lang = "";
const BButton = /* @__PURE__ */ _export_sfc(_sfc_main$1a, [["__scopeId", "data-v-abb99f1c"]]);
function useSelectionDetection() {
  let pointerMovement;
  let startPoint;
  const pointerMovementPxThreshold = 4;
  const isSelecting = ref(false);
  return {
    listeners: {
      pointerdown: (event) => {
        isSelecting.value = false;
        startPoint = {
          x: event.clientX,
          y: event.clientY
        };
      },
      pointermove: (event) => {
        if (!startPoint) {
          return;
        }
        pointerMovement = Math.abs(startPoint.x - event.clientX) + Math.abs(startPoint.y - event.clientY);
        isSelecting.value = pointerMovement >= pointerMovementPxThreshold;
      }
    },
    isSelecting
  };
}
function addThousandsSeparators(number) {
  return number.toLocaleString("en-US", { useGrouping: true });
}
function abbreviateNumber(number) {
  if (number < 1e4) {
    return addThousandsSeparators(number);
  }
  const units = ["k", "m", "b", "t"];
  const exponent = Math.floor(Math.log10(number) / 3);
  const decimal = Math.pow(1e3, exponent);
  const unit = units[exponent - 1];
  const formattedNumber = (number / decimal).toString().slice(0, 4).replace(/(\..*)0+$/, "$1");
  return formattedNumber.endsWith(".") ? formattedNumber.slice(0, -1) + unit : formattedNumber + unit;
}
const parseLinkProps = ({
  to,
  as
}) => {
  if (as === "a" && typeof to === "string") {
    return { href: to };
  }
  return { to };
};
const _sfc_main$19 = /* @__PURE__ */ defineComponent({
  __name: "b-card-link",
  props: {
    isSelecting: { type: Boolean },
    link: {}
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    __expose({ navigateToLink });
    const linkRef = ref();
    const linkComponent = computed(() => props.link.as ?? "a");
    const linkProps = computed(() => {
      const { to, as: _as, ...remainingProps } = props.link;
      const hrefProp = parseLinkProps({
        as: linkComponent.value,
        to
      });
      return {
        ...remainingProps,
        ...hrefProp
      };
    });
    function navigateToLink(event) {
      var _a;
      const link = linkRef.value instanceof HTMLElement ? linkRef.value : (_a = linkRef.value) == null ? void 0 : _a.$el;
      if (link && event.target !== link && !props.isSelecting) {
        link.click();
      }
    }
    return (_ctx, _cache) => {
      var _a;
      return ((_a = _ctx.link) == null ? void 0 : _a.to) ? (openBlock(), createBlock(resolveDynamicComponent(linkComponent.value), mergeProps({ key: 0 }, linkProps.value, {
        ref_key: "linkRef",
        ref: linkRef
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16)) : createCommentVNode("", true);
    };
  }
});
const _hoisted_1$W = { class: "b-card-stats__value" };
const _sfc_main$18 = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-card-stats-list",
  props: {
    stats: {},
    format: { default: "full" }
  },
  setup(__props) {
    const props = __props;
    const safeAttrs = useSafeAttrs(useAttrs());
    const formattedStats = computed(
      () => props.stats.filter((stat) => stat.value > 0).map(({ value, label }) => ({ label, value: formatStatValue(value) }))
    );
    function formatStatValue(value) {
      if (props.format === "abbreviated") {
        return abbreviateNumber(value);
      } else {
        return addThousandsSeparators(value);
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", mergeProps({ class: "b-card-stats" }, unref(safeAttrs)), [
        (openBlock(true), createElementBlock(Fragment, null, renderList(formattedStats.value, ({ label, value }) => {
          return openBlock(), createElementBlock("li", {
            key: label,
            class: "b-card-stats__entry"
          }, [
            createElementVNode("span", _hoisted_1$W, toDisplayString(value), 1),
            createTextVNode(" " + toDisplayString(label), 1)
          ]);
        }), 128))
      ], 16);
    };
  }
});
const bCardStatsList_vue_vue_type_style_index_0_scoped_0b793be6_lang = "";
const BCardStatsList = /* @__PURE__ */ _export_sfc(_sfc_main$18, [["__scopeId", "data-v-0b793be6"]]);
const _hoisted_1$V = { class: "b-card-article__header" };
const _hoisted_2$H = { class: "b-card-article__type" };
const _hoisted_3$q = { class: "b-card-article__published" };
const _hoisted_4$h = {
  key: 0,
  class: "b-card-article__authors"
};
const _hoisted_5$b = {
  key: 1,
  class: "b-card-article__image-wrapper"
};
const _hoisted_6$b = {
  key: 2,
  class: "b-card-article__footer"
};
const _hoisted_7$8 = {
  key: 0,
  class: "b-card-article__reference"
};
const _hoisted_8$4 = {
  key: 0,
  class: "b-card-article__journal-title"
};
const _hoisted_9$3 = {
  key: 1,
  class: "b-card-article__doi"
};
const _sfc_main$17 = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-card-article",
  props: {
    title: {},
    header: {},
    published: {},
    authors: { default: () => [] },
    journalTitle: {},
    articleDoi: {},
    citations: {},
    views: {},
    titleAs: { default: "h1" },
    link: {},
    statsNumberFormat: {}
  },
  setup(__props) {
    const props = __props;
    const attrs = useSafeAttrs(useAttrs());
    const linkComponent = ref();
    const { listeners, isSelecting } = useSelectionDetection();
    const stats = computed(() => {
      const { views, citations } = props;
      return [
        { label: "views", value: views ?? 0 },
        { label: "citations", value: citations ?? 0 }
      ];
    });
    const shouldRenderStats = computed(
      () => !!props.citations || !!props.views
    );
    const shouldRenderFooter = computed(
      () => shouldRenderStats.value || !!props.journalTitle || !!props.articleDoi
    );
    const authorsText = computed(() => {
      if (typeof props.authors === "string") {
        return props.authors;
      }
      const formattedAuthorsList = props.authors.length > 10 ? [
        ...props.authors.slice(0, 9),
        `${props.authors.length - 10} more`,
        props.authors.at(-1)
      ] : props.authors;
      return formattedAuthorsList.join("  ·  ");
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("article", mergeProps({
        class: ["b-card-article", [
          {
            "b-card-article--has-link": !!_ctx.link
          }
        ]]
      }, unref(attrs), toHandlers(unref(listeners), true), {
        onClick: _cache[0] || (_cache[0] = //@ts-ignore
        (...args) => {
          var _a, _b;
          return ((_a = linkComponent.value) == null ? void 0 : _a.navigateToLink) && ((_b = linkComponent.value) == null ? void 0 : _b.navigateToLink(...args));
        })
      }), [
        createElementVNode("div", _hoisted_1$V, [
          createElementVNode("p", _hoisted_2$H, toDisplayString(_ctx.header), 1),
          createElementVNode("p", _hoisted_3$q, toDisplayString(_ctx.published), 1)
        ]),
        (openBlock(), createBlock(resolveDynamicComponent(_ctx.titleAs), { class: "b-card-article__title" }, {
          default: withCtx(() => [
            _ctx.link ? (openBlock(), createBlock(_sfc_main$19, {
              key: 0,
              ref_key: "linkComponent",
              ref: linkComponent,
              "is-selecting": unref(isSelecting),
              link: _ctx.link
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.title), 1)
              ]),
              _: 1
            }, 8, ["is-selecting", "link"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(_ctx.title), 1)
            ], 64))
          ]),
          _: 1
        })),
        authorsText.value ? (openBlock(), createElementBlock("p", _hoisted_4$h, toDisplayString(authorsText.value), 1)) : createCommentVNode("", true),
        _ctx.$slots.image ? (openBlock(), createElementBlock("div", _hoisted_5$b, [
          renderSlot(_ctx.$slots, "image", normalizeProps(guardReactiveProps({
            style: {
              "width": "100%",
              "height": "100%",
              "object-fit": "cover"
            }
          })), void 0, true)
        ])) : createCommentVNode("", true),
        shouldRenderFooter.value ? (openBlock(), createElementBlock("footer", _hoisted_6$b, [
          _ctx.journalTitle || _ctx.articleDoi ? (openBlock(), createElementBlock("div", _hoisted_7$8, [
            _ctx.journalTitle ? (openBlock(), createElementBlock("p", _hoisted_8$4, toDisplayString(_ctx.journalTitle), 1)) : createCommentVNode("", true),
            _ctx.articleDoi ? (openBlock(), createElementBlock("p", _hoisted_9$3, toDisplayString(_ctx.articleDoi), 1)) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          shouldRenderStats.value ? (openBlock(), createBlock(BCardStatsList, {
            key: 1,
            stats: stats.value,
            format: _ctx.statsNumberFormat
          }, null, 8, ["stats", "format"])) : createCommentVNode("", true)
        ])) : createCommentVNode("", true)
      ], 16);
    };
  }
});
const bCardArticle_vue_vue_type_style_index_0_scoped_131af256_lang = "";
const bCardArticle = /* @__PURE__ */ _export_sfc(_sfc_main$17, [["__scopeId", "data-v-131af256"]]);
const _hoisted_1$U = { class: "b-card-people__avatar" };
const _hoisted_2$G = {
  class: "b-card-people__header",
  role: "generic"
};
const _hoisted_3$p = { class: "b-card-people__body" };
const _hoisted_4$g = ["title"];
const _hoisted_5$a = {
  key: 0,
  class: "b-card-people__footer"
};
const _hoisted_6$a = ["title"];
const _hoisted_7$7 = ["title"];
const _sfc_main$16 = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-card-people",
  props: {
    name: {},
    nameAs: { default: "h1" },
    institution: {},
    location: {},
    professionalRole: {},
    professionalArea: {},
    layout: { default: "vertical" },
    link: {}
  },
  setup(__props) {
    const props = __props;
    const linkComponent = ref();
    const attrs = useSafeAttrs(useAttrs());
    const { listeners, isSelecting } = useSelectionDetection();
    const avatarProps = computed(() => ({
      alt: props.name,
      size: "lg"
    }));
    const bodyContent = computed(() => [props.institution, props.location]);
    function navigateToLink(event) {
      var _a;
      (_a = linkComponent.value) == null ? void 0 : _a.navigateToLink(event);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("article", mergeProps({
        class: ["b-card-people", [
          `b-card-people--${_ctx.layout}`,
          {
            "b-card-people--is-interactive": _ctx.link
          }
        ]]
      }, unref(attrs), { onClick: navigateToLink }, toHandlers(unref(listeners), true)), [
        createElementVNode("div", _hoisted_1$U, [
          renderSlot(_ctx.$slots, "avatar", normalizeProps(guardReactiveProps(avatarProps.value)), void 0, true)
        ]),
        createElementVNode("header", _hoisted_2$G, [
          (openBlock(), createBlock(resolveDynamicComponent(_ctx.nameAs), {
            class: "b-card-people__name",
            title: _ctx.name
          }, {
            default: withCtx(() => [
              _ctx.link ? (openBlock(), createBlock(_sfc_main$19, {
                key: 0,
                ref_key: "linkComponent",
                ref: linkComponent,
                "is-selecting": unref(isSelecting),
                link: _ctx.link
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.name), 1)
                ]),
                _: 1
              }, 8, ["is-selecting", "link"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(_ctx.name), 1)
              ], 64))
            ]),
            _: 1
          }, 8, ["title"]))
        ]),
        createElementVNode("div", _hoisted_3$p, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(bodyContent.value, (paragraph, index) => {
            return openBlock(), createElementBlock("p", {
              key: index,
              class: "b-card-people__body-paragraph",
              title: paragraph
            }, toDisplayString(paragraph), 9, _hoisted_4$g);
          }), 128))
        ]),
        _ctx.professionalRole || _ctx.professionalArea ? (openBlock(), createElementBlock("footer", _hoisted_5$a, [
          _ctx.professionalRole ? (openBlock(), createElementBlock("p", {
            key: 0,
            class: "b-card-people__professional-role",
            title: _ctx.professionalRole
          }, toDisplayString(_ctx.professionalRole), 9, _hoisted_6$a)) : createCommentVNode("", true),
          _ctx.professionalArea ? (openBlock(), createElementBlock("p", {
            key: 1,
            class: "b-card-people__professional-area",
            title: _ctx.professionalArea
          }, toDisplayString(_ctx.professionalArea), 9, _hoisted_7$7)) : createCommentVNode("", true)
        ])) : createCommentVNode("", true)
      ], 16);
    };
  }
});
const bCardPeople_vue_vue_type_style_index_0_scoped_fe86faf7_lang = "";
const bCardPeople = /* @__PURE__ */ _export_sfc(_sfc_main$16, [["__scopeId", "data-v-fe86faf7"]]);
const _hoisted_1$T = {
  key: 0,
  class: "b-tag__icon"
};
const _hoisted_2$F = { class: "b-tag__label" };
const _sfc_main$15 = /* @__PURE__ */ defineComponent({
  __name: "b-tag",
  props: {
    colorScheme: {},
    variant: { default: "fill" },
    size: { default: "md" },
    iconPosition: { default: "right" }
  },
  setup(__props) {
    const props = __props;
    useCssVars((_ctx) => ({
      "f38b1f04": icon_order.value
    }));
    const slots = useSlots();
    const iconSizeMap = {
      md: "sm",
      lg: "sm"
    };
    const icon_order = computed(() => props.iconPosition === "left" ? "0" : "1");
    const tagAttrs = useSafeAttrs(useAttrs());
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({
        "data-cy": "b-tag",
        class: "b-tag"
      }, unref(tagAttrs), {
        class: [`b-tag--${_ctx.colorScheme}`, `b-tag--${_ctx.variant}`, `b-tag--${_ctx.size}`]
      }), [
        unref(slots)["icon"] ? (openBlock(), createElementBlock("div", _hoisted_1$T, [
          renderSlot(_ctx.$slots, "icon", {
            size: iconSizeMap[_ctx.size],
            fill: "currentColor"
          }, void 0, true)
        ])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_2$F, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ])
      ], 16);
    };
  }
});
const bTag_vue_vue_type_style_index_0_scoped_1477a19f_lang = "";
const BTag = /* @__PURE__ */ _export_sfc(_sfc_main$15, [["__scopeId", "data-v-1477a19f"]]);
const _hoisted_1$S = {
  key: 0,
  class: "b-card-rt__tag"
};
const _hoisted_2$E = {
  key: 1,
  class: "b-card-rt__image-wrapper"
};
const _hoisted_3$o = { class: "b-card-rt__header" };
const _hoisted_4$f = { class: "b-card-rt__type" };
const _hoisted_5$9 = {
  key: 2,
  class: "b-card-rt__authors"
};
const _hoisted_6$9 = {
  key: 3,
  class: "b-card-rt__footer"
};
const _sfc_main$14 = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-card-rt",
  props: {
    tagLabel: {},
    title: {},
    header: {},
    authors: {},
    articlesNumber: {},
    views: {},
    titleAs: { default: "h1" },
    link: {},
    statsNumberFormat: {}
  },
  setup(__props) {
    const props = __props;
    const attrs = useSafeAttrs(useAttrs());
    const linkComponent = ref();
    const { listeners, isSelecting } = useSelectionDetection();
    const stats = computed(() => {
      const { views, articlesNumber } = props;
      return [
        { label: "views", value: views ?? 0 },
        { label: "articles", value: articlesNumber ?? 0 }
      ];
    });
    const shouldRenderFooter = computed(
      () => !!props.views || !!props.articlesNumber
    );
    const authorsText = computed(() => {
      if (typeof props.authors === "string") {
        return props.authors;
      }
      const authors = props.authors ?? [];
      const formattedAuthorsList = authors.length > 10 ? [...authors.slice(0, 9), `${authors.length - 10} more`, authors.at(-1)] : authors;
      return formattedAuthorsList.join("  ·  ");
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("article", mergeProps({
        class: ["b-card-rt", [
          {
            "b-card-rt--has-link": !!_ctx.link
          }
        ]]
      }, unref(attrs), toHandlers(unref(listeners), true), {
        onClick: _cache[0] || (_cache[0] = //@ts-ignore
        (...args) => {
          var _a, _b;
          return ((_a = linkComponent.value) == null ? void 0 : _a.navigateToLink) && ((_b = linkComponent.value) == null ? void 0 : _b.navigateToLink(...args));
        })
      }), [
        _ctx.tagLabel ? (openBlock(), createElementBlock("div", _hoisted_1$S, [
          createVNode(BTag, {
            "color-scheme": "black",
            size: "md"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.tagLabel), 1)
            ]),
            _: 1
          })
        ])) : createCommentVNode("", true),
        _ctx.$slots.image ? (openBlock(), createElementBlock("div", _hoisted_2$E, [
          renderSlot(_ctx.$slots, "image", normalizeProps(guardReactiveProps({
            style: {
              "width": "100%",
              "height": "100%",
              "object-fit": "cover"
            }
          })), void 0, true)
        ])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_3$o, [
          createElementVNode("p", _hoisted_4$f, toDisplayString(_ctx.header), 1)
        ]),
        (openBlock(), createBlock(resolveDynamicComponent(_ctx.titleAs), { class: "b-card-rt__title" }, {
          default: withCtx(() => [
            _ctx.link ? (openBlock(), createBlock(_sfc_main$19, {
              key: 0,
              ref_key: "linkComponent",
              ref: linkComponent,
              "is-selecting": unref(isSelecting),
              link: _ctx.link
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.title), 1)
              ]),
              _: 1
            }, 8, ["is-selecting", "link"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(_ctx.title), 1)
            ], 64))
          ]),
          _: 1
        })),
        authorsText.value ? (openBlock(), createElementBlock("p", _hoisted_5$9, toDisplayString(authorsText.value), 1)) : createCommentVNode("", true),
        shouldRenderFooter.value ? (openBlock(), createElementBlock("footer", _hoisted_6$9, [
          createVNode(BCardStatsList, {
            stats: stats.value,
            format: _ctx.statsNumberFormat
          }, null, 8, ["stats", "format"])
        ])) : createCommentVNode("", true)
      ], 16);
    };
  }
});
const bCardRt_vue_vue_type_style_index_0_scoped_b453a5cd_lang = "";
const bCardRt = /* @__PURE__ */ _export_sfc(_sfc_main$14, [["__scopeId", "data-v-b453a5cd"]]);
const _hoisted_1$R = ["disabled", "aria-pressed"];
const _hoisted_2$D = { class: "b-chip-filter__label" };
const _sfc_main$13 = /* @__PURE__ */ defineComponent({
  ...{ inheritAttrs: false },
  __name: "b-chip-filter",
  props: {
    colorScheme: { default: "black" },
    label: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    size: { default: "md" },
    modelValue: { type: Boolean, default: false },
    showTick: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit }) {
    const props = __props;
    const slots = useSlots();
    const chipFilterRef = ref(null);
    __expose({
      button: chipFilterRef
    });
    const chipFilterAttrs = useSafeAttrs(useAttrs());
    const chipSizeToAvatarSizeMap = {
      xl: "xs",
      lg: "2xs",
      md: "2xs",
      sm: "3xs"
    };
    const chipSizeToIconSizeMap = {
      xl: "lg",
      lg: "md",
      md: "md",
      sm: "sm"
    };
    const avatarSize = computed(() => chipSizeToAvatarSizeMap[props.size]);
    const renderAvatar = computed(() => !props.showTick && !!slots.avatar);
    const iconSize = computed(() => chipSizeToIconSizeMap[props.size]);
    const renderIcon = computed(
      () => !props.showTick && !!slots.icon && !slots.avatar
    );
    function toggleModelValue() {
      if (props.disabled || props.readonly) {
        return;
      }
      emit("update:modelValue", !props.modelValue);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", mergeProps({
        ref_key: "chipFilterRef",
        ref: chipFilterRef,
        class: ["b-chip-filter", [
          `b-chip-filter--${_ctx.size}`,
          `b-chip-filter--${_ctx.colorScheme}`,
          {
            "b-chip-filter--selected": _ctx.modelValue,
            "b-chip-filter--disabled": _ctx.disabled,
            "b-chip-filter--readonly": _ctx.readonly,
            "b-chip-filter--has-tick-icon": _ctx.showTick && _ctx.modelValue,
            "b-chip-filter--has-icon": renderIcon.value,
            "b-chip-filter--has-avatar": renderAvatar.value
          }
        ]],
        disabled: _ctx.disabled,
        "aria-pressed": _ctx.modelValue
      }, unref(chipFilterAttrs), { onClick: toggleModelValue }), [
        _ctx.showTick && _ctx.modelValue ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["b-chip-filter__tick-icon", `b-chip-filter__icon--${_ctx.size}`])
        }, [
          createVNode(unref(CheckIcon), { size: iconSize.value }, null, 8, ["size"])
        ], 2)) : createCommentVNode("", true),
        renderAvatar.value ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["b-chip-filter__avatar", [
            `b-chip-filter__avatar--${_ctx.size}`,
            `b-chip-filter__avatar--${_ctx.colorScheme}`,
            {
              "b-chip-filter__avatar--selected": _ctx.modelValue,
              "b-chip-filter__avatar--disabled": _ctx.disabled
            }
          ]])
        }, [
          renderSlot(_ctx.$slots, "avatar", { size: avatarSize.value }, void 0, true)
        ], 2)) : createCommentVNode("", true),
        renderIcon.value ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass(["b-chip-filter__icon", [
            `b-chip-filter__icon--${_ctx.size}`,
            {
              "b-chip-filter__icon--selected": _ctx.modelValue
            }
          ]])
        }, [
          renderSlot(_ctx.$slots, "icon", {
            size: iconSize.value,
            fill: "currentColor"
          }, void 0, true)
        ], 2)) : createCommentVNode("", true),
        createElementVNode("span", _hoisted_2$D, toDisplayString(_ctx.label), 1)
      ], 16, _hoisted_1$R);
    };
  }
});
const bChipFilter_vue_vue_type_style_index_0_scoped_d5c5b023_lang = "";
const bChipFilter = /* @__PURE__ */ _export_sfc(_sfc_main$13, [["__scopeId", "data-v-d5c5b023"]]);
const _hoisted_1$Q = ["id", "aria-labelledby", "aria-controls", "aria-expanded", "aria-activedescendant", "onKeydown"];
const _hoisted_2$C = ["id"];
const _hoisted_3$n = { class: "b-chip-select__empty-message" };
const _sfc_main$12 = /* @__PURE__ */ defineComponent({
  ...{ inheritAttrs: false },
  __name: "b-chip-select",
  props: {
    label: {},
    options: {},
    modelValue: {},
    variant: { default: "single" },
    loading: { type: Boolean },
    emptyMessage: { default: "No options available" },
    size: { default: "lg" },
    colorScheme: { default: "black" },
    disabled: { type: Boolean },
    readonly: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props, { expose: __expose, emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const chipSelectAttrs = useSafeAttrs(useAttrs());
    const selectRef = ref(null);
    const triggerRef = ref(null);
    const listboxRef = ref(null);
    const labelId = generateUniqueId();
    const internalModel = ref(props.modelValue);
    const isExpanded = ref(false);
    __expose({
      select: selectRef,
      trigger: triggerRef
    });
    const chipSizeToAvatarSizeMap = {
      xl: "xs",
      lg: "2xs"
    };
    const chipSizeToIconSizeMap = {
      xl: "lg",
      lg: "md"
    };
    const chipSizeToChevronSizeMap = {
      xl: "md",
      lg: "sm"
    };
    const avatarSize = computed(() => chipSizeToAvatarSizeMap[props.size]);
    const iconSize = computed(() => chipSizeToIconSizeMap[props.size]);
    const renderIcon = computed(() => !!slots.icon && !slots.avatar);
    const renderAvatar = computed(() => !!slots.avatar);
    const chevronSize = computed(() => chipSizeToChevronSizeMap[props.size]);
    const proxiedModel = computed({
      get: () => internalModel.value,
      set: (value) => {
        internalModel.value = value;
        emits("update:modelValue", value);
        emits("change", value);
      }
    });
    const displaySelection = computed(() => {
      var _a;
      if (props.variant === "single" && typeof proxiedModel.value === "string" && proxiedModel.value.length > 0) {
        return ((_a = props.options.find((option) => option.value === internalModel.value)) == null ? void 0 : _a.label) ?? "";
      }
      if (props.variant === "multiple" && proxiedModel.value.length > 0) {
        return `${proxiedModel.value.length} selected`;
      }
      return "";
    });
    const captionMessage = computed(() => {
      return props.loading ? "Loading..." : "";
    });
    const isSelected = computed(() => {
      if (props.variant === "multiple") {
        return proxiedModel.value.length > 0;
      } else {
        return proxiedModel.value !== "";
      }
    });
    onClickOutside(listboxRef, closeListbox, { ignore: [triggerRef] });
    const { listboxId, triggerId } = createListboxIds();
    const { focused } = useFocusWithin(selectRef);
    const { floatingStyles } = useListboxFloating({
      listboxRef,
      referenceRef: triggerRef
    });
    const {
      activeDescendantId,
      getActiveDescendant,
      getActiveDescendantValue,
      goToNextDescendant,
      goToPreviousDescendant,
      goToLastDescendant,
      goToFirstDescendant,
      resetDescendant
    } = useActiveDescendant({
      descendants: toRef(props, "options")
    });
    watch(
      () => activeDescendantId.value,
      (value) => {
        if (value) {
          const activeDescendant = getActiveDescendant();
          activeDescendant == null ? void 0 : activeDescendant.scrollIntoView({
            block: "nearest",
            inline: "nearest"
          });
        }
      }
    );
    watch(focused, (isFocused) => {
      if (!isFocused) {
        closeListbox();
      }
    });
    function toggleListbox() {
      if (!props.disabled && !props.readonly) {
        isExpanded.value = !isExpanded.value;
      }
    }
    function openListbox() {
      if (!props.disabled && !props.readonly) {
        isExpanded.value = true;
      }
    }
    function closeListbox() {
      isExpanded.value = false;
      resetDescendant();
    }
    function isValueSelected(value) {
      if (props.variant === "multiple") {
        return proxiedModel.value.includes(value);
      } else {
        return proxiedModel.value === value;
      }
    }
    function onOptionSelected(value) {
      if (props.variant === "single") {
        proxiedModel.value = value;
        closeListbox();
      }
      if (props.variant === "multiple") {
        if (isValueSelected(value)) {
          proxiedModel.value = proxiedModel.value.filter(
            (v) => v !== value
          );
        } else {
          proxiedModel.value = [...proxiedModel.value, value];
        }
      }
    }
    function onArrowKey(direction) {
      if (!isExpanded.value) {
        openListbox();
      }
      if (direction === "down") {
        goToNextDescendant();
      } else {
        goToPreviousDescendant();
      }
    }
    function onEnterOrSpaceKey() {
      if (isExpanded.value) {
        const value = getActiveDescendantValue();
        if (value) {
          onOptionSelected(value);
        } else {
          closeListbox();
        }
      } else {
        openListbox();
      }
    }
    function onClearAll() {
      proxiedModel.value = [];
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "selectRef",
        ref: selectRef,
        class: "b-chip-select",
        onMousedown: _cache[5] || (_cache[5] = withModifiers(() => {
        }, ["prevent"]))
      }, [
        createElementVNode("button", mergeProps({
          id: unref(triggerId),
          ref_key: "triggerRef",
          ref: triggerRef,
          role: "combobox",
          class: ["b-chip-select__trigger", [
            `b-chip-select__trigger--${_ctx.size}`,
            `b-chip-select__trigger--${_ctx.colorScheme}`,
            {
              "b-chip-select__trigger--selected": isSelected.value,
              "b-chip-select__trigger--disabled": _ctx.disabled,
              "b-chip-select__trigger--readonly": _ctx.readonly,
              "b-chip-select__trigger--has-icon": renderIcon.value,
              "b-chip-select__trigger--has-avatar": renderAvatar.value
            }
          ]],
          "aria-labelledby": unref(labelId),
          "aria-controls": unref(listboxId),
          "aria-expanded": isExpanded.value,
          "aria-haspopup": "listbox",
          "aria-activedescendant": unref(activeDescendantId)
        }, unref(chipSelectAttrs), {
          onClick: toggleListbox,
          onKeydown: [
            withKeys(withModifiers(closeListbox, ["prevent"]), ["escape"]),
            _cache[0] || (_cache[0] = withKeys(withModifiers(($event) => onArrowKey("up"), ["prevent"]), ["up"])),
            _cache[1] || (_cache[1] = withKeys(withModifiers(($event) => onArrowKey("down"), ["prevent"]), ["down"])),
            withKeys(withModifiers(onEnterOrSpaceKey, ["prevent"]), ["enter"]),
            withKeys(withModifiers(onEnterOrSpaceKey, ["prevent"]), ["space"]),
            _cache[2] || (_cache[2] = withKeys(withModifiers(
              //@ts-ignore
              (...args) => unref(goToFirstDescendant) && unref(goToFirstDescendant)(...args),
              ["prevent"]
            ), ["home"])),
            _cache[3] || (_cache[3] = withKeys(withModifiers(
              //@ts-ignore
              (...args) => unref(goToLastDescendant) && unref(goToLastDescendant)(...args),
              ["prevent"]
            ), ["end"]))
          ]
        }), [
          renderAvatar.value ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["b-chip-select__avatar", [
              `b-chip-select__avatar--${_ctx.size}`,
              `b-chip-select__avatar--${_ctx.colorScheme}`,
              { "b-chip-select__avatar--disabled": _ctx.disabled }
            ]])
          }, [
            renderSlot(_ctx.$slots, "avatar", { size: avatarSize.value })
          ], 2)) : createCommentVNode("", true),
          renderIcon.value ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(["b-chip-select__icon", `b-chip-select__icon--${_ctx.size}`])
          }, [
            renderSlot(_ctx.$slots, "icon", {
              size: iconSize.value,
              fill: "currentColor"
            })
          ], 2)) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass(["b-chip-select__texts", `b-chip-select__texts--${_ctx.size}`])
          }, [
            createElementVNode("span", {
              id: unref(labelId),
              class: normalizeClass(["b-chip-select__label", [
                `b-chip-select__label--${_ctx.size}`,
                { "b-chip-select__label--small": isSelected.value }
              ]])
            }, toDisplayString(_ctx.label), 11, _hoisted_2$C),
            createElementVNode("span", {
              class: normalizeClass(["b-chip-select__selected-value", {
                "b-chip-select__selected-value--visible": displaySelection.value.length
              }])
            }, toDisplayString(displaySelection.value), 3)
          ], 2),
          !_ctx.loading ? (openBlock(), createElementBlock("div", {
            key: 2,
            class: normalizeClass(["b-chip-select__chevron", `b-chip-select__chevron--${_ctx.size}`])
          }, [
            isExpanded.value ? (openBlock(), createBlock(unref(ChevronUpIcon), {
              key: 0,
              size: chevronSize.value
            }, null, 8, ["size"])) : (openBlock(), createBlock(unref(ChevronDownIcon), {
              key: 1,
              size: chevronSize.value
            }, null, 8, ["size"]))
          ], 2)) : (openBlock(), createElementBlock("div", {
            key: 3,
            class: normalizeClass(["b-chip-select__spinner", `b-chip-select__spinner--${_ctx.size}`])
          }, [
            createVNode(unref(BSpinner), { size: chevronSize.value }, null, 8, ["size"])
          ], 2))
        ], 16, _hoisted_1$Q),
        isExpanded.value ? (openBlock(), createBlock(unref(BListbox), {
          key: 0,
          id: unref(listboxId),
          ref_key: "listboxRef",
          ref: listboxRef,
          modelValue: proxiedModel.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => proxiedModel.value = $event),
          class: "b-chip-select__listbox",
          style: normalizeStyle(unref(floatingStyles)),
          variant: props.variant === "multiple" ? "checkbox" : "ticks",
          "multi-selectable": props.variant === "multiple",
          options: _ctx.loading ? [] : _ctx.options,
          "caption-message": captionMessage.value,
          "aria-labelledby": unref(triggerId),
          onClearAll,
          onClickSelected: onOptionSelected
        }, createSlots({ _: 2 }, [
          _ctx.options.length === 0 && !_ctx.loading ? {
            name: "empty-content",
            fn: withCtx(() => [
              createElementVNode("div", _hoisted_3$n, toDisplayString(_ctx.emptyMessage), 1)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["id", "modelValue", "style", "variant", "multi-selectable", "options", "caption-message", "aria-labelledby"])) : createCommentVNode("", true)
      ], 544);
    };
  }
});
const bChipSelect_vue_vue_type_style_index_0_lang = "";
const CONTEXTUAL_MENU_STATE = Symbol(
  "ContextualMenuState"
);
const PLACEMENT_VALUES = [
  "bottom-start",
  "bottom-end",
  "top-start",
  "top-end",
  "left-start",
  "left-end",
  "right-start",
  "right-end"
];
const _hoisted_1$P = ["onKeydown"];
const MENU_OFFSET = 4;
const SCREEN_BORDER_PADDING = 10;
const _sfc_main$11 = /* @__PURE__ */ defineComponent({
  __name: "b-contextual-menu",
  props: {
    placement: { default: "bottom-end" }
  },
  setup(__props) {
    const props = __props;
    const contextualMenuRef = ref(null);
    const triggerRef = ref(null);
    const contentRef = ref(null);
    const menuListId = `contextual-menu-${generateUniqueId()}`;
    const menuAttrs = useSafeAttrs(useAttrs());
    const isDisplayed = ref(false);
    const focusLastItem = ref(false);
    const shouldAddAutoplacementMiddleware = computed(
      () => props.placement === "auto" ? autoPlacement({ allowedPlacements: PLACEMENT_VALUES }) : flip({
        fallbackAxisSideDirection: "end"
      })
    );
    const middleware = computed(() => [
      shouldAddAutoplacementMiddleware.value,
      offset({
        mainAxis: MENU_OFFSET
      }),
      shift({
        limiter: limitShift(),
        padding: SCREEN_BORDER_PADDING
      })
    ]);
    const placement = computed(
      () => props.placement === "auto" ? void 0 : props.placement
    );
    const { floatingStyles } = useFloating(triggerRef, contentRef, {
      placement,
      middleware,
      whileElementsMounted: autoUpdate
    });
    onClickOutside(contextualMenuRef, close);
    function onArrowKeys(event) {
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        focusLastItem.value = event.key === "ArrowUp";
        isDisplayed.value = true;
      }
    }
    function toggle() {
      isDisplayed.value = !isDisplayed.value;
    }
    function close() {
      isDisplayed.value = false;
      focusLastItem.value = false;
    }
    provide(
      CONTEXTUAL_MENU_STATE,
      computed(() => ({
        menuListId,
        isDisplayed: isDisplayed.value,
        focusLastItem: focusLastItem.value,
        close
      }))
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "contextualMenuRef",
        ref: contextualMenuRef,
        class: "b-contextual-menu",
        onKeydown: [
          withKeys(close, ["escape"]),
          withKeys(close, ["tab"])
        ]
      }, [
        createElementVNode("div", {
          ref_key: "triggerRef",
          ref: triggerRef,
          class: "b-contextual-menu__trigger"
        }, [
          renderSlot(_ctx.$slots, "trigger", {
            "aria-Controls": menuListId,
            "aria-Expanded": isDisplayed.value,
            onClick: toggle,
            onKeydown: onArrowKeys
          }, void 0, true)
        ], 512),
        isDisplayed.value ? (openBlock(), createElementBlock("div", mergeProps({
          key: 0,
          ref_key: "contentRef",
          ref: contentRef
        }, unref(menuAttrs), {
          class: "b-contextual-menu__content",
          style: unref(floatingStyles)
        }), [
          renderSlot(_ctx.$slots, "content", {}, void 0, true)
        ], 16)) : createCommentVNode("", true)
      ], 40, _hoisted_1$P);
    };
  }
});
const bContextualMenu_vue_vue_type_style_index_0_scoped_1ac52696_lang = "";
const BContextualMenu = /* @__PURE__ */ _export_sfc(_sfc_main$11, [["__scopeId", "data-v-1ac52696"]]);
const _hoisted_1$O = {
  key: 0,
  class: "b-contextual-menu-item__icon"
};
const _hoisted_2$B = { class: "b-contextual-menu-item__label" };
const _sfc_main$10 = /* @__PURE__ */ defineComponent({
  __name: "b-contextual-menu-item",
  props: {
    item: {}
  },
  setup(__props) {
    const props = __props;
    const menuState = inject(CONTEXTUAL_MENU_STATE);
    const linkProps = computed(
      () => linkHrefParser({ as: props.item.as, to: props.item.to })
    );
    const onPress = (event) => {
      var _a, _b;
      if (props.item.disabled) {
        return;
      }
      (_b = (_a = props.item).onClick) == null ? void 0 : _b.call(_a, event);
      menuState == null ? void 0 : menuState.value.close();
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.item.as ?? "button"), mergeProps({
        class: ["b-contextual-menu-item", {
          "b-contextual-menu-item--disabled": _ctx.item.disabled
        }]
      }, linkProps.value, {
        role: "menuitem",
        "aria-disabled": !!_ctx.item.disabled,
        tabindex: -1,
        onClick: onPress,
        onKeydown: [
          withKeys(withModifiers(onPress, ["prevent"]), ["enter"]),
          withKeys(withModifiers(onPress, ["prevent"]), ["space"])
        ]
      }), {
        default: withCtx(() => [
          !!_ctx.item.iconComponent ? (openBlock(), createElementBlock("div", _hoisted_1$O, [
            (openBlock(), createBlock(resolveDynamicComponent(_ctx.item.iconComponent), {
              fill: "currentColor",
              size: "md"
            }))
          ])) : createCommentVNode("", true),
          createElementVNode("span", _hoisted_2$B, toDisplayString(_ctx.item.label), 1)
        ]),
        _: 1
      }, 16, ["class", "aria-disabled", "onKeydown"]);
    };
  }
});
const bContextualMenuItem_vue_vue_type_style_index_0_scoped_fee808c3_lang = "";
const BContextualMenuItem = /* @__PURE__ */ _export_sfc(_sfc_main$10, [["__scopeId", "data-v-fee808c3"]]);
const _hoisted_1$N = {
  key: 0,
  class: "b-contextual-menu-content__title"
};
const _hoisted_2$A = ["id", "aria-activedescendant"];
const _sfc_main$$ = /* @__PURE__ */ defineComponent({
  __name: "b-contextual-menu-content",
  props: {
    title: { default: void 0 },
    items: {}
  },
  setup(__props) {
    const props = __props;
    const menuState = inject(CONTEXTUAL_MENU_STATE);
    const activeDescendantId = ref(void 0);
    const genActiveDescendantId = (hash, index) => `contextual-menu-item-${hash}-option-${index}`;
    const menuItems = computed(() => {
      return props.items.map((child, index) => ({
        ...child,
        id: genActiveDescendantId(generateUniqueId(), index)
      }));
    });
    const menuAttrs = useSafeAttrs(useAttrs());
    const currentMenuItemIndex = ref(-1);
    const menuItemsRef = ref(null);
    const menuItemsNodes = computed(() => {
      var _a;
      return [
        ...((_a = menuItemsRef.value) == null ? void 0 : _a.querySelectorAll(
          '[role="menuitem"][aria-disabled="false"]'
        )) ?? []
      ];
    });
    watchEffect(() => {
      var _a;
      if ((_a = menuState == null ? void 0 : menuState.value) == null ? void 0 : _a.isDisplayed) {
        nextTick(() => {
          var _a2;
          currentMenuItemIndex.value = ((_a2 = menuState == null ? void 0 : menuState.value) == null ? void 0 : _a2.focusLastItem) ? menuItemsNodes.value.length - 1 : 0;
        });
      }
    });
    watch(currentMenuItemIndex, () => {
      var _a;
      const nextItem = (_a = menuItemsNodes.value) == null ? void 0 : _a[currentMenuItemIndex.value];
      if (nextItem) {
        menuItemsNodes.value.forEach((node) => node.setAttribute("tabindex", "-1"));
        nextItem.setAttribute("tabindex", "0");
        nextItem.focus();
      }
    });
    function focusPreviousItem() {
      const nextIndex = currentMenuItemIndex.value - 1;
      currentMenuItemIndex.value = nextIndex < 0 ? (menuItemsNodes.value.length ?? 0) - 1 : nextIndex;
    }
    function focusNextItem() {
      currentMenuItemIndex.value = (currentMenuItemIndex.value + 1) % (menuItemsNodes.value.length ?? 0);
    }
    function handleItemHover(event) {
      const nextIndex = menuItemsNodes.value.indexOf(event.target);
      if (nextIndex >= 0) {
        currentMenuItemIndex.value = nextIndex;
      }
    }
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock("div", mergeProps({ class: "b-contextual-menu-content" }, unref(menuAttrs)), [
        _ctx.title ? (openBlock(), createElementBlock("div", _hoisted_1$N, toDisplayString(_ctx.title), 1)) : createCommentVNode("", true),
        createElementVNode("ul", {
          id: (_a = unref(menuState)) == null ? void 0 : _a.menuListId,
          ref_key: "menuItemsRef",
          ref: menuItemsRef,
          class: "b-contextual-menu-content__list",
          role: "menu",
          "aria-activedescendant": activeDescendantId.value
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(menuItems.value, (item, index) => {
            return openBlock(), createElementBlock("li", {
              key: item.label + index
            }, [
              createVNode(BContextualMenuItem, {
                item,
                onKeydown: [
                  withKeys(withModifiers(focusPreviousItem, ["prevent"]), ["up"]),
                  withKeys(withModifiers(focusNextItem, ["prevent"]), ["down"])
                ],
                onMouseenter: _cache[0] || (_cache[0] = ($event) => handleItemHover($event)),
                onFocus: ($event) => activeDescendantId.value = item.id
              }, null, 8, ["item", "onKeydown", "onFocus"])
            ]);
          }), 128))
        ], 8, _hoisted_2$A)
      ], 16);
    };
  }
});
const bContextualMenuContent_vue_vue_type_style_index_0_scoped_6485fe1b_lang = "";
const BContextualMenuContent = /* @__PURE__ */ _export_sfc(_sfc_main$$, [["__scopeId", "data-v-6485fe1b"]]);
const _hoisted_1$M = ["for"];
const _hoisted_2$z = { class: "b-form-control__control" };
const _hoisted_3$m = {
  key: 0,
  class: "b-form-control__suffix"
};
const _hoisted_4$e = {
  key: 0,
  class: "b-form-control__details"
};
const _hoisted_5$8 = { class: "b-form-control__messages" };
const _hoisted_6$8 = {
  key: 0,
  class: "b-form-control__details-right-slot"
};
const _sfc_main$_ = /* @__PURE__ */ defineComponent({
  __name: "b-form-control",
  props: {
    colorScheme: { default: "black" },
    label: { default: void 0 },
    invalid: { type: Boolean, default: false },
    hint: { default: void 0 },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    labelFor: {},
    populated: { type: Boolean },
    height: { default: "fixed" },
    noPaddingRight: { type: Boolean },
    showCursorPointer: { type: Boolean, default: false }
  },
  emits: ["click-form-control"],
  setup(__props, { expose: __expose, emit: _emits }) {
    const props = __props;
    const formControlRef = ref(null);
    const { focused } = useFocusWithin(formControlRef);
    __expose({
      formControlRef
    });
    const slots = useSlots();
    const hasSmallLabel = computed(() => {
      if (props.populated) {
        return true;
      }
      if (props.disabled || props.readonly) {
        return false;
      }
      return focused.value;
    });
    const hasErrorSlotContent = computed(() => {
      return props.invalid && !!slots.error;
    });
    const hasDetails = computed(() => {
      return !!slots["details-right"] || !!hasErrorSlotContent.value || !!props.hint;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        createElementVNode("div", {
          ref_key: "formControlRef",
          ref: formControlRef,
          class: normalizeClass(["b-form-control", [
            `b-form-control--${_ctx.colorScheme}`,
            {
              "b-form-control--invalid": _ctx.invalid,
              "b-form-control--disabled": _ctx.disabled,
              "b-form-control--readonly": _ctx.readonly,
              "b-form-control--auto-height": _ctx.height === "auto",
              "b-form-control--with-suffix": !!_ctx.$slots.suffix,
              "b-form-control--no-padding-right": !!_ctx.noPaddingRight,
              "b-form-control--cursor-pointer": _ctx.showCursorPointer
            }
          ]]),
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click-form-control"))
        }, [
          createElementVNode("label", {
            class: normalizeClass(["b-form-control__label", {
              "b-form-control__label--small": hasSmallLabel.value
            }]),
            for: _ctx.labelFor
          }, toDisplayString(_ctx.label), 11, _hoisted_1$M),
          createElementVNode("div", _hoisted_2$z, [
            renderSlot(_ctx.$slots, "control", {}, void 0, true)
          ]),
          unref(slots).suffix ? (openBlock(), createElementBlock("div", _hoisted_3$m, [
            renderSlot(_ctx.$slots, "suffix", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ], 2),
        hasDetails.value ? (openBlock(), createElementBlock("div", _hoisted_4$e, [
          createElementVNode("div", _hoisted_5$8, [
            hasErrorSlotContent.value ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["b-form-control__error", { "b-form-control__error--with-hint": !!_ctx.hint }])
            }, [
              renderSlot(_ctx.$slots, "error", {}, void 0, true)
            ], 2)) : createCommentVNode("", true),
            !!_ctx.hint ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: normalizeClass(["b-form-control__hint", [`b-form-control__hint--${_ctx.colorScheme}`]])
            }, toDisplayString(_ctx.hint), 3)) : createCommentVNode("", true)
          ]),
          unref(slots)["details-right"] ? (openBlock(), createElementBlock("div", _hoisted_6$8, [
            renderSlot(_ctx.$slots, "details-right", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
const bFormControl_vue_vue_type_style_index_0_scoped_ffddd276_lang = "";
const BFormControl = /* @__PURE__ */ _export_sfc(_sfc_main$_, [["__scopeId", "data-v-ffddd276"]]);
function dateToFormatedDateString(date) {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
function stringToDate(string, separator) {
  const [day, month, year] = string.split(separator);
  return new Date(
    Number.parseInt(year),
    Number.parseInt(month) - 1,
    Number.parseInt(day)
  );
}
const _hoisted_1$L = ["id", "value", "disabled", "readonly", "onClick", "onKeydown"];
const DATE_PLACEHOLDER = "DD/MM/YYYY";
const YEAR_PLACEHOLDER = "YYYY";
const MONTH_PLACEHOLDER = "MM";
const DAY_PLACEHOLDER = "DD";
const SEPARATOR = "/";
const _sfc_main$Z = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-date-input",
  props: {
    invalid: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    colorScheme: { default: "black" },
    disabled: { type: Boolean, default: false },
    modelValue: {},
    errorMessage: { default: void 0 },
    label: {},
    hint: { default: void 0 }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(__props, { emit }) {
    const props = __props;
    const NonValidCharsRegexp = new RegExp(`[^0-9DMY${SEPARATOR}]`, "g");
    const inputAttrs = useSafeAttrs(useAttrs());
    const id = generateUniqueId();
    const dateInputRef = ref(null);
    const isFocused = ref(false);
    const selectedDatePart = ref(0);
    const typedDigits = ref(0);
    const internalModel = ref(DATE_PLACEHOLDER);
    const dateParts = DATE_PLACEHOLDER.split(SEPARATOR).map(
      (placeholder) => reactive({
        placeholder,
        start: DATE_PLACEHOLDER.indexOf(placeholder),
        end: DATE_PLACEHOLDER.indexOf(placeholder) + placeholder.length,
        value: null
      })
    );
    const currentDatePart = computed(() => dateParts[selectedDatePart.value]);
    const dayValue = computed(
      () => {
        var _a;
        return (_a = dateParts.find((part) => part.placeholder === DAY_PLACEHOLDER)) == null ? void 0 : _a.value;
      }
    );
    const monthValue = computed(
      () => {
        var _a;
        return (_a = dateParts.find((part) => part.placeholder === MONTH_PLACEHOLDER)) == null ? void 0 : _a.value;
      }
    );
    const yearValue = computed(
      () => {
        var _a;
        return (_a = dateParts.find((part) => part.placeholder === YEAR_PLACEHOLDER)) == null ? void 0 : _a.value;
      }
    );
    const populated = computed(
      () => internalModel.value !== DATE_PLACEHOLDER || isFocused.value
    );
    watch(
      () => props.modelValue,
      () => {
        if (props.modelValue) {
          const stringDate = dateToFormatedDateString(props.modelValue);
          dateParts.forEach(
            (part) => part.value = Number(stringDate.slice(part.start, part.end))
          );
          updateInternalModel();
        }
      },
      { immediate: true }
    );
    watch(
      dateParts.map((part) => () => part.value),
      updateInternalModel
    );
    watch(selectedDatePart, () => {
      selectRange();
      typedDigits.value = 0;
    });
    function updateInternalModel() {
      if ((dayValue.value ?? 0) > getMaxDatePart(DAY_PLACEHOLDER)) {
        const dayPart = dateParts.find(
          (part) => part.placeholder === DAY_PLACEHOLDER
        );
        if (dayPart) {
          dayPart.value = getMaxDatePart(DAY_PLACEHOLDER);
        }
      }
      internalModel.value = dateParts.map(
        (part) => part.value !== null ? part.value.toString().padStart(part.end - part.start, "0") : part.placeholder
      ).join(SEPARATOR);
      setTimeout(() => {
        selectRange();
      }, 0);
    }
    function getMaxDatePart(placeholder) {
      switch (placeholder) {
        case DAY_PLACEHOLDER: {
          if (yearValue.value && monthValue.value) {
            return new Date(yearValue.value, monthValue.value, 0).getDate();
          }
          if (monthValue.value) {
            return new Date(2e3, monthValue.value, 0).getDate();
          }
          return 31;
        }
        case MONTH_PLACEHOLDER: {
          return 12;
        }
        case YEAR_PLACEHOLDER: {
          return 9999;
        }
        default: {
          return 0;
        }
      }
    }
    function selectRange() {
      var _a;
      (_a = dateInputRef.value) == null ? void 0 : _a.setSelectionRange(
        currentDatePart.value.start,
        currentDatePart.value.end
      );
    }
    function handleFocus(event) {
      selectRange();
      isFocused.value = true;
      emit("focus", event);
    }
    function handleBlur(event) {
      isFocused.value = false;
      emit("blur", event);
      if (internalModel.value === DATE_PLACEHOLDER) {
        emit("update:modelValue", null);
      } else {
        const date = stringToDate(internalModel.value, SEPARATOR);
        if (date.toString() !== "Invalid Date") {
          emit("update:modelValue", date);
        }
      }
    }
    function handleClick() {
      var _a;
      const cursorPosition = ((_a = dateInputRef.value) == null ? void 0 : _a.selectionStart) ?? 0;
      const index = dateParts.findIndex(
        (part) => cursorPosition >= part.start && cursorPosition <= part.end
      );
      selectedDatePart.value = index || selectedDatePart.value;
      selectRange();
    }
    function handleKey(event) {
      const isNumber = /^\d$/i.test(event.key);
      const isTab = event.key === "Tab";
      if (isTab) {
        return;
      }
      event.preventDefault();
      if (isNumber) {
        updateDatePart(Number(event.key));
      }
      resetOnSpecialCharacter(event.key);
    }
    function resetOnSpecialCharacter(key) {
      setTimeout(() => {
        var _a;
        if (dateInputRef.value && (key === "Dead" || // "Dead" is the key value for ´ ¨ `
        NonValidCharsRegexp.test(((_a = dateInputRef.value) == null ? void 0 : _a.value) ?? ""))) {
          dateInputRef.value.value = internalModel.value;
        }
      });
    }
    function handleTab(event) {
      if (event.shiftKey) {
        if (selectedDatePart.value !== 0) {
          selectPreviousDatePart();
          event.preventDefault();
        }
      } else {
        if (selectedDatePart.value !== 2) {
          selectNextDatePart();
          event.preventDefault();
        }
      }
    }
    function updateDatePart(newDigit) {
      const currentDatePartLength = currentDatePart.value.end - currentDatePart.value.start;
      if (currentDatePart.value.value === null || typedDigits.value === 0) {
        currentDatePart.value.value = newDigit;
      } else {
        let newValue = currentDatePart.value.value * 10 + newDigit;
        if (newValue.toString().length > currentDatePartLength) {
          newValue = Number(newValue.toString().slice(1));
        }
        if (newValue > getMaxDatePart(currentDatePart.value.placeholder)) {
          selectNextDatePart();
          return;
        } else {
          currentDatePart.value.value = newValue;
        }
      }
      typedDigits.value++;
      if (typedDigits.value === currentDatePartLength) {
        selectNextDatePart();
      }
    }
    function increaseDatePart() {
      if (currentDatePart.value.value === null) {
        if (currentDatePart.value.placeholder === YEAR_PLACEHOLDER) {
          currentDatePart.value.value = (/* @__PURE__ */ new Date()).getFullYear();
        } else {
          currentDatePart.value.value = 1;
        }
      } else {
        const isMaxValue = currentDatePart.value.value === getMaxDatePart(currentDatePart.value.placeholder);
        if (isMaxValue) {
          currentDatePart.value.value = 1;
        } else {
          currentDatePart.value.value++;
        }
      }
    }
    const decreaseDatePart = () => {
      const maxValue = getMaxDatePart(currentDatePart.value.placeholder);
      if (currentDatePart.value.value === null) {
        if (currentDatePart.value.placeholder === YEAR_PLACEHOLDER) {
          currentDatePart.value.value = (/* @__PURE__ */ new Date()).getFullYear();
        } else {
          currentDatePart.value.value = maxValue;
        }
      } else {
        const isMinValue = currentDatePart.value.value === 1;
        if (isMinValue) {
          currentDatePart.value.value = maxValue;
        } else {
          currentDatePart.value.value--;
        }
      }
    };
    function selectNextDatePart() {
      selectedDatePart.value = (selectedDatePart.value + 1) % 3;
    }
    function selectPreviousDatePart() {
      selectedDatePart.value--;
      if (selectedDatePart.value < 0) {
        selectedDatePart.value = 2;
      }
    }
    function deleteDatePart() {
      currentDatePart.value.value = null;
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(BFormControl, {
        "label-for": unref(id),
        populated: populated.value,
        label: _ctx.label,
        invalid: _ctx.invalid,
        "error-message": _ctx.errorMessage,
        "color-scheme": _ctx.colorScheme,
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        hint: _ctx.hint
      }, {
        control: withCtx(() => [
          createElementVNode("input", mergeProps({
            id: unref(id),
            ref_key: "dateInputRef",
            ref: dateInputRef,
            value: internalModel.value,
            disabled: _ctx.disabled,
            readonly: _ctx.readonly,
            class: [{ "b-date-input--populated": populated.value }, "b-date-input"],
            type: "text"
          }, unref(inputAttrs), {
            inputmode: "numeric",
            onDrop: _cache[0] || (_cache[0] = withModifiers(() => {
            }, ["prevent"])),
            onMouseup: _cache[1] || (_cache[1] = withModifiers(() => {
            }, ["prevent"])),
            onClick: withModifiers(handleClick, ["prevent"]),
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeydown: [
              handleKey,
              withKeys(handleTab, ["tab"]),
              withKeys(withModifiers(selectNextDatePart, ["prevent"]), ["right"]),
              withKeys(withModifiers(selectPreviousDatePart, ["prevent"]), ["left"]),
              withKeys(withModifiers(increaseDatePart, ["prevent"]), ["up"]),
              withKeys(withModifiers(decreaseDatePart, ["prevent"]), ["down"]),
              withKeys(withModifiers(deleteDatePart, ["prevent"]), ["delete"]),
              withKeys(withModifiers(deleteDatePart, ["prevent"]), ["backspace"])
            ]
          }), null, 16, _hoisted_1$L)
        ]),
        suffix: withCtx(() => [
          createVNode(unref(CalendarIcon))
        ]),
        _: 1
      }, 8, ["label-for", "populated", "label", "invalid", "error-message", "color-scheme", "disabled", "readonly", "hint"]);
    };
  }
});
const bDateInput_vue_vue_type_style_index_0_scoped_ba308aaf_lang = "";
const bDateInput = /* @__PURE__ */ _export_sfc(_sfc_main$Z, [["__scopeId", "data-v-ba308aaf"]]);
function useFocusTrap(target, options = {}) {
  let trap;
  const { immediate, ...focusTrapOptions } = options;
  const hasFocus = ref(false);
  const isPaused = ref(false);
  const activate = (opts) => trap && trap.activate(opts);
  const deactivate = (opts) => trap && trap.deactivate(opts);
  const pause = () => {
    if (trap) {
      trap.pause();
      isPaused.value = true;
    }
  };
  const unpause = () => {
    if (trap) {
      trap.unpause();
      isPaused.value = false;
    }
  };
  watch(
    () => unrefElement(target),
    (el) => {
      if (!el)
        return;
      trap = createFocusTrap(el, {
        ...focusTrapOptions,
        onActivate() {
          hasFocus.value = true;
          if (options.onActivate)
            options.onActivate();
        },
        onDeactivate() {
          hasFocus.value = false;
          if (options.onDeactivate)
            options.onDeactivate();
        }
      });
      if (immediate)
        activate();
    },
    { flush: "post" }
  );
  tryOnScopeDispose(() => deactivate());
  return {
    hasFocus,
    isPaused,
    activate,
    deactivate,
    pause,
    unpause
  };
}
const useModalTrap = (el, options) => {
  const { activate, deactivate } = useFocusTrap(el, {
    ...options
  });
  onMounted(() => {
    nextTick(() => {
      try {
        activate();
      } catch {
        console.warn(
          "You have tried to use a Modal Trap without any tabbable elements. Please add a tabbable element to your modal."
        );
      }
    });
  });
  onUnmounted(() => {
    deactivate();
  });
};
const _hoisted_1$K = { class: "b-modal" };
const _hoisted_2$y = ["aria-labelledby"];
const _hoisted_3$l = {
  key: 0,
  class: "b-modal__overlay",
  "aria-hidden": "true"
};
const _sfc_main$Y = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-modal",
  props: {
    labelledById: {},
    disableScrollLock: { type: Boolean },
    hideOverlay: { type: Boolean },
    focusTrapOptions: {}
  },
  emits: ["click-outside"],
  setup(__props, { emit }) {
    const props = __props;
    const modalRef = ref(null);
    useModalTrap(modalRef, props.focusTrapOptions);
    onClickOutside(modalRef, () => {
      emit("click-outside");
    });
    const isLocked = useScrollLock(isBrowser() ? document.body : void 0);
    watch(
      () => props.disableScrollLock,
      (value) => isLocked.value = !value,
      { immediate: true }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$K, [
        createElementVNode("div", mergeProps(_ctx.$attrs, {
          ref_key: "modalRef",
          ref: modalRef,
          role: "dialog",
          "aria-labelledby": _ctx.labelledById,
          "aria-modal": "true",
          class: "b-modal__content"
        }), [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ], 16, _hoisted_2$y),
        !_ctx.hideOverlay ? (openBlock(), createElementBlock("div", _hoisted_3$l)) : createCommentVNode("", true)
      ]);
    };
  }
});
const bModal_vue_vue_type_style_index_0_scoped_894e8b8b_lang = "";
const BModal = /* @__PURE__ */ _export_sfc(_sfc_main$Y, [["__scopeId", "data-v-894e8b8b"]]);
const _hoisted_1$J = ["onKeydown"];
const _hoisted_2$x = ["id"];
const _sfc_main$X = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-dialog",
  props: {
    modelValue: { type: Boolean },
    title: {},
    compact: { type: Boolean },
    aspectRatio: { default: "square" },
    focusTrapOptions: {},
    teleportTo: { default: "body" },
    disableScrollLock: { type: Boolean }
  },
  emits: ["close", "update:modelValue"],
  setup(__props, { emit }) {
    const slots = useSlots();
    const dialogBodyRef = ref(null);
    const hasContentScrollable = ref(false);
    const labelId = generateUniqueId();
    watchEffect(() => {
      if (dialogBodyRef.value) {
        hasContentScrollable.value = dialogBodyRef.value.scrollHeight > dialogBodyRef.value.clientHeight;
      }
    });
    const closeDialog = () => {
      emit("close");
      emit("update:modelValue", false);
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Teleport, { to: _ctx.teleportTo }, [
        createVNode(Transition, {
          appear: "",
          name: "b-dialog-fade-"
        }, {
          default: withCtx(() => [
            _ctx.modelValue ? (openBlock(), createBlock(BModal, {
              key: 0,
              "disable-scroll-lock": _ctx.disableScrollLock,
              "labelled-by-id": unref(labelId),
              "focus-trap-options": { allowOutsideClick: true, ..._ctx.focusTrapOptions },
              onClickOutside: closeDialog
            }, {
              default: withCtx(() => [
                createElementVNode("div", {
                  class: normalizeClass(["b-dialog__panel", [`b-dialog__panel--${_ctx.aspectRatio}`]]),
                  onKeydown: withKeys(closeDialog, ["escape"])
                }, [
                  createElementVNode("div", {
                    id: unref(labelId),
                    class: normalizeClass(["b-dialog__title", { "b-dialog__title--compact": _ctx.compact }])
                  }, [
                    renderSlot(_ctx.$slots, "title-prefix", {}, void 0, true),
                    createTextVNode(toDisplayString(_ctx.title), 1)
                  ], 10, _hoisted_2$x),
                  createElementVNode("div", {
                    ref_key: "dialogBodyRef",
                    ref: dialogBodyRef,
                    class: normalizeClass(["b-dialog__body", {
                      "b-dialog__body--scrollable": hasContentScrollable.value,
                      "b-dialog__body--compact": _ctx.compact
                    }])
                  }, [
                    renderSlot(_ctx.$slots, "default", {}, void 0, true)
                  ], 2),
                  unref(slots).footer ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: normalizeClass(["b-dialog__footer", {
                      "b-dialog__footer--scrollable": hasContentScrollable.value,
                      "b-dialog__footer--compact": _ctx.compact
                    }])
                  }, [
                    renderSlot(_ctx.$slots, "footer", {}, void 0, true)
                  ], 2)) : createCommentVNode("", true),
                  createElementVNode("button", {
                    class: "b-dialog__close-button",
                    "aria-label": "close dialog",
                    onClick: closeDialog
                  }, [
                    createVNode(unref(CloseIcon), { size: "lg" })
                  ])
                ], 42, _hoisted_1$J)
              ]),
              _: 3
            }, 8, ["disable-scroll-lock", "labelled-by-id", "focus-trap-options"])) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ], 8, ["to"]);
    };
  }
});
const bDialog_vue_vue_type_style_index_0_scoped_2e39b792_lang = "";
const bDialog = /* @__PURE__ */ _export_sfc(_sfc_main$X, [["__scopeId", "data-v-2e39b792"]]);
const _hoisted_1$I = ["aria-labelledby", "disabled"];
const _hoisted_2$w = {
  key: 0,
  "data-cy": "b-floating-button-icon",
  class: "b-floating-button__icon"
};
const _hoisted_3$k = ["id"];
const _sfc_main$W = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-floating-button",
  props: {
    colorScheme: { default: "blue" },
    disabled: { type: Boolean },
    variant: { default: "fill" },
    size: { default: "md" },
    iconPosition: { default: "right" }
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    useCssVars((_ctx) => ({
      "c5ab7bec": order.value
    }));
    const slots = useSlots();
    const buttonRef = ref(null);
    __expose({
      button: buttonRef
    });
    const textId = generateUniqueId();
    const attrs = useAttrs();
    const btnAttrs = useSafeAttrs(attrs);
    const isOnlyIcon = computed(() => !slots.default);
    const order = computed(() => props.iconPosition === "left" ? "0" : "1");
    onMounted(() => {
      if (isOnlyIcon.value && !(btnAttrs == null ? void 0 : btnAttrs.value["aria-label"])) {
        console.warn(
          "Please provide a text label or aria-label for a BFloatingButton"
        );
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", mergeProps({
        ref_key: "buttonRef",
        ref: buttonRef,
        "data-cy": "b-floating-button",
        "aria-labelledby": unref(textId)
      }, unref(btnAttrs), {
        class: ["b-floating-button", [
          `b-floating-button--${_ctx.size}`,
          `b-floating-button--${_ctx.variant}`,
          `b-floating-button--${_ctx.colorScheme}`,
          {
            "b-floating-button--disabled": _ctx.disabled
          }
        ]],
        disabled: _ctx.disabled
      }), [
        _ctx.$slots["icon"] ? (openBlock(), createElementBlock("div", _hoisted_2$w, [
          renderSlot(_ctx.$slots, "icon", {
            size: "md",
            fill: "currentColor"
          }, void 0, true)
        ])) : createCommentVNode("", true),
        _ctx.$slots["default"] ? (openBlock(), createElementBlock("span", {
          key: 1,
          id: unref(textId),
          class: "b-floating-button__text",
          "data-cy": "b-floating-button-text"
        }, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ], 8, _hoisted_3$k)) : createCommentVNode("", true)
      ], 16, _hoisted_1$I);
    };
  }
});
const bFloatingButton_vue_vue_type_style_index_0_scoped_65173925_lang = "";
const bFloatingButton = /* @__PURE__ */ _export_sfc(_sfc_main$W, [["__scopeId", "data-v-65173925"]]);
const _hoisted_1$H = {
  key: 0,
  "data-cy": "b-link-icon",
  class: "b-link__icon"
};
const _hoisted_2$v = ["id"];
const _sfc_main$V = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-link",
  props: {
    colorScheme: { default: "blue" },
    size: { default: "md" },
    inline: { type: Boolean },
    as: { default: "a" },
    to: {},
    iconPosition: { default: "left" }
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    useCssVars((_ctx) => ({
      "68dd31ef": iconOrder.value
    }));
    const slots = useSlots();
    const linkRef = ref(null);
    __expose({
      link: linkRef
    });
    const attrs = useAttrs();
    const id = generateUniqueId();
    const linkAttrs = useSafeAttrs(attrs);
    const colorClassName = computed(() => {
      if (props.colorScheme === "black") {
        return "b-link--black";
      }
      if (props.colorScheme === "white") {
        return "b-link--white";
      }
      return "b-link--accent";
    });
    const hrefProp = computed(
      () => typeof props.to === "string" && isExternalLink(props.to) ? { href: props.to } : { to: props.to }
    );
    const buttonSizeToIconSizeMap = {
      sm: "sm",
      md: "md"
    };
    const iconSize = computed(() => buttonSizeToIconSizeMap[props.size]);
    const iconOrder = computed(() => props.iconPosition === "left" ? 0 : 1);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.as), mergeProps({
        ref_key: "linkRef",
        ref: linkRef
      }, { ...unref(linkAttrs), ...hrefProp.value }, {
        "aria-labelledby": unref(id),
        class: ["b-link", [
          colorClassName.value,
          `b-link--${_ctx.size}`,
          `b-link--${_ctx.colorScheme}`,
          { "b-link--inline": _ctx.inline }
        ]]
      }), {
        default: withCtx(() => [
          unref(slots).icon ? (openBlock(), createElementBlock("div", _hoisted_1$H, [
            renderSlot(_ctx.$slots, "icon", {
              size: iconSize.value,
              fill: "currentColor"
            }, void 0, true)
          ])) : createCommentVNode("", true),
          createElementVNode("span", {
            id: unref(id),
            class: "b-link__text"
          }, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 8, _hoisted_2$v)
        ]),
        _: 3
      }, 16, ["aria-labelledby", "class"]);
    };
  }
});
const bLink_vue_vue_type_style_index_0_scoped_aec1a28e_lang = "";
const BLink = /* @__PURE__ */ _export_sfc(_sfc_main$V, [["__scopeId", "data-v-aec1a28e"]]);
const _hoisted_1$G = { class: "b-footer-base__copyright" };
const _hoisted_2$u = { class: "b-footer-base__links-list" };
const _sfc_main$U = /* @__PURE__ */ defineComponent({
  __name: "b-footer-base",
  props: {
    copyrightText: {},
    links: {},
    withSeparator: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["b-footer-base", { "b-footer-base--has-separator": _ctx.withSeparator }])
      }, [
        createElementVNode("p", _hoisted_1$G, toDisplayString(_ctx.copyrightText), 1),
        createElementVNode("ul", _hoisted_2$u, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.links, ({ as = "a", to, label, ...extraAttrs }) => {
            return openBlock(), createElementBlock("li", {
              key: label,
              class: "b-footer-base__links-item"
            }, [
              createVNode(unref(BLink), mergeProps({
                as,
                to,
                size: "sm",
                "color-scheme": "black"
              }, extraAttrs), {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(label), 1)
                ]),
                _: 2
              }, 1040, ["as", "to"])
            ]);
          }), 128))
        ])
      ], 2);
    };
  }
});
const bFooterBase_vue_vue_type_style_index_0_scoped_b85798b5_lang = "";
const BFooterBase = /* @__PURE__ */ _export_sfc(_sfc_main$U, [["__scopeId", "data-v-b85798b5"]]);
const _withScopeId$6 = (n) => (pushScopeId("data-v-894a539e"), n = n(), popScopeId(), n);
const _hoisted_1$F = { class: "b-footer-accordion-content" };
const _hoisted_2$t = {
  key: 0,
  class: "b-footer-column"
};
const _hoisted_3$j = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("h1", { class: "b-footer-column__title" }, "Follow us", -1));
const _hoisted_4$d = {
  key: 1,
  class: "b-footer-groups"
};
const _hoisted_5$7 = { class: "b-footer-column__title" };
const _hoisted_6$7 = {
  key: 0,
  class: "b-footer-groups__item b-footer-column"
};
const _hoisted_7$6 = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("h1", { class: "b-footer-column__title" }, "Follow us", -1));
const _sfc_main$T = /* @__PURE__ */ defineComponent({
  __name: "b-footer-groups-list",
  props: {
    groups: {},
    withAccordion: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _ctx.withAccordion ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createVNode(unref(BAccordion), null, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groups, (group) => {
              return openBlock(), createBlock(unref(BAccordionItem), {
                key: group.title
              }, {
                header: withCtx(() => [
                  createTextVNode(toDisplayString(group.title), 1)
                ]),
                content: withCtx(() => [
                  createElementVNode("div", _hoisted_1$F, [
                    renderSlot(_ctx.$slots, "links", {
                      links: group.children
                    }, void 0, true)
                  ])
                ]),
                _: 2
              }, 1024);
            }), 128))
          ]),
          _: 3
        }),
        _ctx.$slots.social ? (openBlock(), createElementBlock("div", _hoisted_2$t, [
          _hoisted_3$j,
          renderSlot(_ctx.$slots, "social", {}, void 0, true)
        ])) : createCommentVNode("", true)
      ], 64)) : (openBlock(), createElementBlock("ul", _hoisted_4$d, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groups, (group) => {
          return openBlock(), createElementBlock("li", {
            key: group.title,
            class: "b-footer-column"
          }, [
            createElementVNode("h1", _hoisted_5$7, toDisplayString(group.title), 1),
            renderSlot(_ctx.$slots, "links", {
              links: group.children
            }, void 0, true)
          ]);
        }), 128)),
        _ctx.$slots.social ? (openBlock(), createElementBlock("li", _hoisted_6$7, [
          _hoisted_7$6,
          renderSlot(_ctx.$slots, "social", {}, void 0, true)
        ])) : createCommentVNode("", true)
      ]));
    };
  }
});
const bFooterGroupsList_vue_vue_type_style_index_0_scoped_894a539e_lang = "";
const BFooterGroupsList = /* @__PURE__ */ _export_sfc(_sfc_main$T, [["__scopeId", "data-v-894a539e"]]);
const _sfc_main$S = /* @__PURE__ */ defineComponent({
  __name: "b-footer-links-list",
  props: {
    links: {},
    layout: {}
  },
  setup(__props) {
    const props = __props;
    const computedLinks = computed(() => {
      return props.links.map(({ to, as = "a", ...rest }) => {
        const linkProp = linkHrefParser({ to, as });
        return {
          as,
          ...linkProp,
          ...rest
        };
      });
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: normalizeClass(["b-footer-links-list", [`b-footer-links-list--${_ctx.layout}`]])
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(computedLinks.value, ({ as, label, ...extraAttrs }) => {
          return openBlock(), createElementBlock("li", {
            key: label,
            class: normalizeClass(["b-footer-links-list__item", [`b-footer-links-list__item--${_ctx.layout}`]])
          }, [
            (openBlock(), createBlock(resolveDynamicComponent(as), mergeProps({
              class: ["b-footer-links-list__link", [`b-footer-links-list__link--${_ctx.layout}`]]
            }, extraAttrs), {
              default: withCtx(() => [
                createTextVNode(toDisplayString(label), 1)
              ]),
              _: 2
            }, 1040, ["class"]))
          ], 2);
        }), 128))
      ], 2);
    };
  }
});
const bFooterLinksList_vue_vue_type_style_index_0_scoped_b4aa10f8_lang = "";
const BFooterLinksList = /* @__PURE__ */ _export_sfc(_sfc_main$S, [["__scopeId", "data-v-b4aa10f8"]]);
const _hoisted_1$E = { class: "b-footer-social-links" };
const _sfc_main$R = /* @__PURE__ */ defineComponent({
  __name: "b-footer-social-links",
  props: {
    links: {}
  },
  setup(__props) {
    const props = __props;
    const computedLinks = computed(() => {
      return props.links.map(({ to, as = "a", ...rest }) => {
        const linkProp = linkHrefParser({ to, as });
        return {
          as,
          ...linkProp,
          ...rest
        };
      });
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", _hoisted_1$E, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(computedLinks.value, ({ as, iconComponent, label, ...extraAttrs }) => {
          return openBlock(), createElementBlock("li", {
            key: label,
            class: "b-footer-social-links__item"
          }, [
            (openBlock(), createBlock(resolveDynamicComponent(as), mergeProps({
              "aria-label": label,
              target: "_blank"
            }, extraAttrs, { class: "b-footer-social-links__link" }), {
              default: withCtx(() => [
                (openBlock(), createBlock(resolveDynamicComponent(iconComponent), { size: "lg" }))
              ]),
              _: 2
            }, 1040, ["aria-label"]))
          ]);
        }), 128))
      ]);
    };
  }
});
const bFooterSocialLinks_vue_vue_type_style_index_0_scoped_30bd7e42_lang = "";
const BFooterSocialLinks = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["__scopeId", "data-v-30bd7e42"]]);
const _hoisted_1$D = { class: "b-footer__wrapper" };
const _hoisted_2$s = {
  key: 1,
  class: "b-footer__simple-links"
};
const _sfc_main$Q = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-footer",
  props: {
    copyrightText: {},
    links: {},
    socialLinks: {},
    copyrightRightSideLinks: {}
  },
  setup(__props) {
    const props = __props;
    const footerAttrs = useSafeAttrs(useAttrs());
    const breakpoints = useBreakpoints();
    const isMdOrAbove = breakpoints.greaterOrEqual("md");
    const isTabletOrAbove = computed(
      () => !isBrowser() || isMdOrAbove.value
    );
    function isLinksGroup(links = []) {
      return links.length > 0 && Array.isArray(links[0].children);
    }
    const variant = computed(() => {
      const links = props.links ?? [];
      if (links.length === 0) {
        return "base";
      }
      return isLinksGroup(links) ? "groups" : "simplified";
    });
    const simplifiedFooterLayout = computed(
      () => isMdOrAbove.value ? "horizontal" : "vertical"
    );
    const computedCopyrightText = computed(() => {
      if (props.copyrightText) {
        return props.copyrightText;
      }
      const year = (/* @__PURE__ */ new Date()).getFullYear();
      return `© ${year} Frontiers Media S.A. All rights reserved`;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("footer", mergeProps({
        class: ["b-footer", [`b-footer--${variant.value}`]]
      }, unref(footerAttrs)), [
        createElementVNode("div", _hoisted_1$D, [
          isLinksGroup(_ctx.links) ? (openBlock(), createBlock(BFooterGroupsList, {
            key: 0,
            groups: _ctx.links,
            "with-accordion": !isTabletOrAbove.value
          }, {
            links: withCtx((scope) => [
              createVNode(BFooterLinksList, {
                links: scope.links,
                layout: "vertical"
              }, null, 8, ["links"])
            ]),
            social: withCtx(() => [
              _ctx.socialLinks ? (openBlock(), createBlock(BFooterSocialLinks, {
                key: 0,
                links: _ctx.socialLinks
              }, null, 8, ["links"])) : createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["groups", "with-accordion"])) : variant.value === "simplified" ? (openBlock(), createElementBlock("div", _hoisted_2$s, [
            _ctx.links ? (openBlock(), createBlock(BFooterLinksList, {
              key: 0,
              links: _ctx.links,
              layout: simplifiedFooterLayout.value
            }, null, 8, ["links", "layout"])) : createCommentVNode("", true),
            _ctx.socialLinks ? (openBlock(), createBlock(BFooterSocialLinks, {
              key: 1,
              links: _ctx.socialLinks
            }, null, 8, ["links"])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          _ctx.copyrightRightSideLinks ? (openBlock(), createBlock(BFooterBase, {
            key: 2,
            links: _ctx.copyrightRightSideLinks,
            "copyright-text": computedCopyrightText.value,
            "with-separator": variant.value !== "base"
          }, null, 8, ["links", "copyright-text", "with-separator"])) : createCommentVNode("", true)
        ])
      ], 16);
    };
  }
});
const bFooter_vue_vue_type_style_index_0_scoped_7b4341fa_lang = "";
const bFooter = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["__scopeId", "data-v-7b4341fa"]]);
const _hoisted_1$C = { class: "b-sliding-panel" };
const SCROLL_FACTOR = 0.7;
const _sfc_main$P = /* @__PURE__ */ defineComponent({
  __name: "b-sliding-panel",
  props: {
    disableScroll: { type: Boolean }
  },
  setup(__props, { expose: __expose }) {
    useCssVars((_ctx) => ({
      "692e8fca": leftControlWidth.value,
      "20d80bfa": rightControlWidth.value
    }));
    const scrollRef = ref(null);
    const leftControlRef = ref(null);
    const rightControlRef = ref(null);
    const leftControlWidth = ref("");
    const rightControlWidth = ref("");
    const scrollPosition = ref(0);
    __expose({
      scrollElementIntoView
    });
    const { width: clientWidth } = useElementSize(scrollRef);
    const showLeftControl = computed(() => scrollPosition.value > 0);
    const showRightControl = computed(() => {
      var _a;
      const scrollVisibleWidth = clientWidth.value ?? 0;
      const scrollTotalWidth = ((_a = scrollRef.value) == null ? void 0 : _a.scrollWidth) ?? 0;
      return scrollPosition.value + scrollVisibleWidth <= scrollTotalWidth - 1;
    });
    watchEffect(() => {
      var _a;
      const { width = 0 } = ((_a = leftControlRef.value) == null ? void 0 : _a.getBoundingClientRect()) ?? {};
      leftControlWidth.value = `${width}px`;
    });
    watchEffect(() => {
      var _a;
      const { width = 0 } = ((_a = rightControlRef.value) == null ? void 0 : _a.getBoundingClientRect()) ?? {};
      rightControlWidth.value = `${width}px`;
    });
    function scrollTo(direction) {
      var _a, _b;
      const scrollValue = ((_a = scrollRef.value) == null ? void 0 : _a.clientWidth) ?? 0;
      const directionFactor = direction === "left" ? -1 : 1;
      (_b = scrollRef.value) == null ? void 0 : _b.scrollBy({
        left: directionFactor * scrollValue * SCROLL_FACTOR,
        behavior: "smooth"
      });
    }
    function updateScrollPosition() {
      var _a;
      scrollPosition.value = ((_a = scrollRef.value) == null ? void 0 : _a.scrollLeft) ?? 0;
    }
    function scrollElementIntoView(element) {
      var _a, _b;
      const elementLeftPosition = element.offsetLeft;
      const elementHalfWidth = element.clientWidth / 2;
      const scrollHalfWidth = (((_a = scrollRef.value) == null ? void 0 : _a.clientWidth) ?? 0) / 2;
      (_b = scrollRef.value) == null ? void 0 : _b.scrollTo({
        left: elementLeftPosition - scrollHalfWidth + elementHalfWidth,
        // Center the element in the scroll
        behavior: "smooth"
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$C, [
        showLeftControl.value ? (openBlock(), createElementBlock("button", {
          key: 0,
          ref_key: "leftControlRef",
          ref: leftControlRef,
          class: "b-sliding-panel__control-left",
          "data-cy": "sliding-panel-button-left",
          "aria-label": "Scroll to left",
          tabindex: "-1",
          onClick: _cache[0] || (_cache[0] = ($event) => scrollTo("left"))
        }, [
          renderSlot(_ctx.$slots, "button-left", {}, void 0, true)
        ], 512)) : createCommentVNode("", true),
        createElementVNode("div", {
          ref_key: "scrollRef",
          ref: scrollRef,
          class: normalizeClass(["b-sliding-panel__scroll", { "b-sliding-panel__scroll--disabled": _ctx.disableScroll }]),
          onScroll: updateScrollPosition
        }, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ], 34),
        showRightControl.value ? (openBlock(), createElementBlock("button", {
          key: 1,
          ref_key: "rightControlRef",
          ref: rightControlRef,
          class: "b-sliding-panel__control-right",
          "data-cy": "sliding-panel-button-right",
          "aria-label": "Scroll to right",
          tabindex: "-1",
          onClick: _cache[1] || (_cache[1] = ($event) => scrollTo("right"))
        }, [
          renderSlot(_ctx.$slots, "button-right", {}, void 0, true)
        ], 512)) : createCommentVNode("", true)
      ]);
    };
  }
});
const bSlidingPanel_vue_vue_type_style_index_0_scoped_3989ee7e_lang = "";
const BSlidingPanel = /* @__PURE__ */ _export_sfc(_sfc_main$P, [["__scopeId", "data-v-3989ee7e"]]);
const STEPPER_STATE_KEY$1 = Symbol("stepperState");
const _hoisted_1$B = { class: "b-horizontal-stepper__scroll-button" };
const _hoisted_2$r = { class: "b-horizontal-stepper__scroll-button" };
const _sfc_main$O = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: true
  },
  __name: "b-horizontal-stepper",
  props: {
    activeStep: {},
    linear: { type: Boolean, default: true },
    labelReversed: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const stepperAttr = useSafeAttrs(useAttrs());
    const registeredSteps = ref(/* @__PURE__ */ new Set());
    const completedSteps = ref(/* @__PURE__ */ new Set());
    const stepperState = computed(() => ({
      activeStep: props.activeStep,
      linear: props.linear,
      labelReversed: props.labelReversed,
      disabled: props.disabled,
      registeredSteps: registeredSteps.value.size,
      completedSteps: props.linear ? props.activeStep - 1 : completedSteps.value.size,
      registerStep,
      unregisterStep,
      setCompletedStep
    }));
    const { smallerOrEqual } = useBreakpoints();
    const isSingleStep = smallerOrEqual("md");
    const wrapperComponent = computed(
      () => isSingleStep.value ? "div" : BSlidingPanel
    );
    provide(STEPPER_STATE_KEY$1, stepperState);
    function registerStep(id) {
      registeredSteps.value.add(id);
    }
    function unregisterStep(id) {
      registeredSteps.value.delete(id);
    }
    function setCompletedStep(id, completed) {
      if (completed) {
        completedSteps.value.add(id);
      } else {
        completedSteps.value.delete(id);
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(wrapperComponent.value), null, {
        "button-left": withCtx(() => [
          createElementVNode("div", _hoisted_1$B, [
            createVNode(unref(ChevronLeftIcon), {
              size: "lg",
              fill: "currentColor"
            })
          ])
        ]),
        default: withCtx(() => [
          createElementVNode("ul", mergeProps({
            class: ["b-horizontal-stepper", { "b-horizontal-stepper--single-step": unref(isSingleStep) }]
          }, unref(stepperAttr)), [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 16)
        ]),
        "button-right": withCtx(() => [
          createElementVNode("div", _hoisted_2$r, [
            createVNode(unref(ChevronRightIcon), {
              size: "lg",
              fill: "currentColor"
            })
          ])
        ]),
        _: 3
      });
    };
  }
});
const bHorizontalStepper_vue_vue_type_style_index_0_scoped_4e97efaa_lang = "";
const bHorizontalStepper = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["__scopeId", "data-v-4e97efaa"]]);
const _withScopeId$5 = (n) => (pushScopeId("data-v-0ea5c489"), n = n(), popScopeId(), n);
const _hoisted_1$A = ["alt"];
const _hoisted_2$q = ["id"];
const _hoisted_3$i = /* @__PURE__ */ _withScopeId$5(() => /* @__PURE__ */ createElementVNode("circle", {
  r: "22",
  cx: "24",
  cy: "24",
  "stroke-width": "4",
  stroke: "white"
}, null, -1));
const _hoisted_4$c = [
  _hoisted_3$i
];
const _hoisted_5$6 = ["mask"];
const _hoisted_6$6 = /* @__PURE__ */ _withScopeId$5(() => /* @__PURE__ */ createElementVNode("div", { class: "b-progress-indicator__circle" }, null, -1));
const _hoisted_7$5 = [
  _hoisted_6$6
];
const _sfc_main$N = /* @__PURE__ */ defineComponent({
  __name: "b-progress-indicator",
  props: {
    altText: {},
    completedPercentage: {}
  },
  setup(__props) {
    const props = __props;
    useCssVars((_ctx) => ({
      "6d220c98": computedPercentage.value
    }));
    const svgId = generateUniqueId();
    const computedPercentage = computed(() => `${props.completedPercentage}%`);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", {
        height: "48",
        width: "48",
        class: "b-progress-indicator",
        alt: _ctx.altText
      }, [
        createElementVNode("defs", null, [
          createElementVNode("mask", { id: unref(svgId) }, _hoisted_4$c, 8, _hoisted_2$q)
        ]),
        (openBlock(), createElementBlock("foreignObject", {
          x: "0",
          y: "0",
          width: "48",
          height: "48",
          mask: `url(#${unref(svgId)})`
        }, _hoisted_7$5, 8, _hoisted_5$6))
      ], 8, _hoisted_1$A);
    };
  }
});
const bProgressIndicator_vue_vue_type_style_index_0_scoped_0ea5c489_lang = "";
const BPropgressIndicator = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["__scopeId", "data-v-0ea5c489"]]);
const _withScopeId$4 = (n) => (pushScopeId("data-v-89a845af"), n = n(), popScopeId(), n);
const _hoisted_1$z = ["tabindex", "aria-label", "aria-hidden", "disabled", "onKeydown"];
const _hoisted_2$p = {
  key: 1,
  class: "b-step__number"
};
const _hoisted_3$h = {
  key: 0,
  class: "b-step__label"
};
const _hoisted_4$b = {
  key: 1,
  class: "b-step__sub-label"
};
const _hoisted_5$5 = {
  key: 1,
  class: "b-step__progress"
};
const _hoisted_6$5 = { class: "b-step__progress-label" };
const _hoisted_7$4 = { "aria-label": "Current step" };
const _hoisted_8$3 = /* @__PURE__ */ _withScopeId$4(() => /* @__PURE__ */ createElementVNode("span", { "aria-hidden": "true" }, "/", -1));
const _hoisted_9$2 = { "aria-label": "Total steps" };
const _sfc_main$M = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-horizontal-stepper-step",
  props: {
    stepNumber: {},
    name: {},
    label: {},
    subLabel: {},
    tagLabel: {},
    completed: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    const stepId = generateUniqueId();
    const stepperState = inject(STEPPER_STATE_KEY$1);
    const stepAttr = useSafeAttrs(useAttrs());
    const { smallerOrEqual } = useBreakpoints();
    const isSingleStep = smallerOrEqual("md");
    const isDisabled = computed(
      () => (stepperState == null ? void 0 : stepperState.value.disabled) || ((stepperState == null ? void 0 : stepperState.value.linear) ? props.stepNumber > (stepperState == null ? void 0 : stepperState.value.activeStep) : props.disabled)
    );
    const isActive = computed(
      () => props.stepNumber === (stepperState == null ? void 0 : stepperState.value.activeStep)
    );
    const isCompleted = computed(
      () => (stepperState == null ? void 0 : stepperState.value.linear) ? props.stepNumber < (stepperState == null ? void 0 : stepperState.value.activeStep) : props.completed
    );
    const tagVariant = computed(
      () => isCompleted.value && !isDisabled.value ? "green" : "blue"
    );
    const hasLabels = computed(
      () => props.label !== void 0 || props.subLabel !== void 0 || props.tagLabel !== void 0
    );
    const completedPercentage = computed(
      () => Math.round(
        ((stepperState == null ? void 0 : stepperState.value.completedSteps) ?? 0) / ((stepperState == null ? void 0 : stepperState.value.registeredSteps) ?? 1) * 100
      )
    );
    const progressAltText = computed(
      () => `${(stepperState == null ? void 0 : stepperState.value.completedSteps) ?? 0} of ${(stepperState == null ? void 0 : stepperState.value.registeredSteps) ?? 0} steps completed`
    );
    const showStep = computed(
      () => !isSingleStep.value || isActive.value || ((stepperState == null ? void 0 : stepperState.value.activeStep) ?? 0) > props.stepNumber && (stepperState == null ? void 0 : stepperState.value.registeredSteps) === props.stepNumber
    );
    stepperState == null ? void 0 : stepperState.value.registerStep(stepId);
    watch(
      () => props.completed,
      () => stepperState == null ? void 0 : stepperState.value.setCompletedStep(stepId, props.completed),
      { immediate: true }
    );
    onBeforeUnmount(() => {
      stepperState == null ? void 0 : stepperState.value.unregisterStep(stepId);
      stepperState == null ? void 0 : stepperState.value.setCompletedStep(stepId, false);
    });
    function onStepClick() {
      if (!isDisabled.value) {
        emit("click", props.stepNumber);
      }
    }
    return (_ctx, _cache) => {
      var _a, _b, _c, _d;
      return showStep.value ? (openBlock(), createElementBlock("li", mergeProps({
        key: 0,
        class: "b-step"
      }, unref(stepAttr), {
        class: {
          "b-step--disabled": isDisabled.value,
          "b-step--linear": (_a = unref(stepperState)) == null ? void 0 : _a.linear,
          "b-step--non-linear": !((_b = unref(stepperState)) == null ? void 0 : _b.linear),
          "b-step--active": isActive.value,
          "b-step--completed": isCompleted.value,
          "b-step--single-step": unref(isSingleStep)
        },
        tabindex: isDisabled.value ? -1 : 0,
        role: "button",
        "aria-label": _ctx.name,
        "aria-hidden": !showStep.value,
        disabled: isDisabled.value,
        onClick: onStepClick,
        onKeydown: [
          withKeys(onStepClick, ["enter"]),
          withKeys(withModifiers(onStepClick, ["prevent"]), ["space"])
        ]
      }), [
        !unref(isSingleStep) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          isCompleted.value && !isDisabled.value ? (openBlock(), createBlock(unref(BFeedbackIcon), {
            key: 0,
            size: "xl",
            type: "success",
            class: "b-step__completed-icon"
          })) : (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(["b-step__default-icon", { "b-step__default-icon--disabled": isDisabled.value }])
          }, [
            isActive.value ? (openBlock(), createBlock(unref(EditIcon), {
              key: 0,
              size: "md"
            })) : (openBlock(), createElementBlock("span", _hoisted_2$p, toDisplayString(_ctx.stepNumber), 1))
          ], 2))
        ], 64)) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass(["b-step__description", {
            "b-step__description--reversed": (_c = unref(stepperState)) == null ? void 0 : _c.labelReversed,
            "b-step__description--single-step": unref(isSingleStep)
          }])
        }, [
          createElementVNode("span", {
            class: normalizeClass(["b-step__name", { "b-step__name--disabled": isDisabled.value }])
          }, toDisplayString(_ctx.name), 3),
          hasLabels.value ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["b-step__labels", { "b-step__labels--disabled": isDisabled.value }])
          }, [
            _ctx.label ? (openBlock(), createElementBlock("span", _hoisted_3$h, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true),
            _ctx.subLabel ? (openBlock(), createElementBlock("span", _hoisted_4$b, toDisplayString(_ctx.subLabel), 1)) : createCommentVNode("", true),
            _ctx.tagLabel ? (openBlock(), createElementBlock("div", {
              key: 2,
              class: normalizeClass(["b-step__tag", { "b-step__tag--disabled": isDisabled.value }])
            }, [
              createVNode(unref(BTag), {
                "color-scheme": tagVariant.value,
                variant: "outline"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.tagLabel), 1)
                ]),
                _: 1
              }, 8, ["color-scheme"])
            ], 2)) : createCommentVNode("", true)
          ], 2)) : createCommentVNode("", true)
        ], 2),
        unref(isSingleStep) ? (openBlock(), createElementBlock("div", _hoisted_5$5, [
          createVNode(BPropgressIndicator, {
            class: "b-step__progress-indicator",
            "alt-text": progressAltText.value,
            "completed-percentage": completedPercentage.value
          }, null, 8, ["alt-text", "completed-percentage"]),
          createElementVNode("div", _hoisted_6$5, [
            createElementVNode("span", _hoisted_7$4, toDisplayString(_ctx.stepNumber), 1),
            _hoisted_8$3,
            createElementVNode("span", _hoisted_9$2, toDisplayString((_d = unref(stepperState)) == null ? void 0 : _d.registeredSteps), 1)
          ])
        ])) : createCommentVNode("", true)
      ], 16, _hoisted_1$z)) : createCommentVNode("", true);
    };
  }
});
const bHorizontalStepperStep_vue_vue_type_style_index_0_scoped_89a845af_lang = "";
const bHorizontalStepperStep = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["__scopeId", "data-v-89a845af"]]);
const _hoisted_1$y = ["disabled", "aria-label"];
const _sfc_main$L = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-icon-button",
  props: {
    label: {},
    colorScheme: { default: "black" },
    size: { default: "md" },
    disabled: { type: Boolean, default: void 0 },
    showTooltip: { type: Boolean, default: false },
    tooltipPlacement: { default: "top-start" }
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    const iconSizeMap = {
      xs: "md",
      sm: "md",
      md: "lg",
      lg: "lg"
    };
    const ariaLabel = computed(() => props.showTooltip ? void 0 : props.label);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(BTooltip), { placement: _ctx.tooltipPlacement }, {
        trigger: withCtx((tooltipProps) => [
          createElementVNode("button", mergeProps(_ctx.showTooltip ? tooltipProps : {}, {
            class: ["b-icon-button", [
              `b-icon-button--${_ctx.colorScheme}`,
              `b-icon-button--${_ctx.size}`,
              {
                "b-icon-button--disabled": _ctx.disabled
              }
            ]],
            disabled: _ctx.disabled,
            "aria-label": ariaLabel.value,
            onClick: _cache[0] || (_cache[0] = ($event) => emit("click", $event))
          }), [
            renderSlot(_ctx.$slots, "icon", {
              size: iconSizeMap[_ctx.size],
              fill: "currentColor"
            }, void 0, true)
          ], 16, _hoisted_1$y)
        ]),
        content: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.label), 1)
        ]),
        _: 3
      }, 8, ["placement"]);
    };
  }
});
const bIconButton_vue_vue_type_style_index_0_scoped_5b7593c8_lang = "";
const BIconButton = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["__scopeId", "data-v-5b7593c8"]]);
const _sfc_main$K = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-input",
  props: {
    invalid: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    colorScheme: { default: "black" },
    disabled: { type: Boolean, default: false },
    modelValue: {},
    errorMessage: {},
    label: {},
    hint: {},
    type: {}
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(__props, { expose: __expose, emit }) {
    const props = __props;
    const slots = useSlots();
    const inputRef = ref(null);
    __expose({
      input: inputRef
    });
    const id = generateUniqueId();
    const attrs = useAttrs();
    const inputAttrs = useSafeAttrs(attrs);
    const proxiedModel = computed({
      get: () => props.modelValue,
      set: (value) => {
        emit("update:modelValue", value);
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(BFormControl, {
        "label-for": unref(id),
        populated: !!proxiedModel.value,
        label: _ctx.label,
        invalid: _ctx.invalid,
        "color-scheme": _ctx.colorScheme,
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        hint: _ctx.hint
      }, createSlots({
        control: withCtx(() => [
          withDirectives(createElementVNode("input", mergeProps({
            ref_key: "inputRef",
            ref: inputRef,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => proxiedModel.value = $event),
            "data-cy": "b-input",
            class: "b-input"
          }, {
            ...unref(inputAttrs),
            "aria-invalid": _ctx.invalid,
            type: _ctx.type,
            disabled: _ctx.disabled,
            id: unref(id),
            readonly: _ctx.readonly
          }, {
            onFocus: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("focus", $event)),
            onBlur: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("blur", $event))
          }), null, 16), [
            [vModelDynamic, proxiedModel.value]
          ])
        ]),
        error: withCtx(() => [
          _ctx.invalid && _ctx.errorMessage ? (openBlock(), createBlock(unref(BFormError), {
            key: 0,
            "error-message": _ctx.errorMessage,
            "color-scheme": _ctx.colorScheme
          }, null, 8, ["error-message", "color-scheme"])) : createCommentVNode("", true)
        ]),
        _: 2
      }, [
        !!unref(slots).icon ? {
          name: "suffix",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "icon", {
              size: "md",
              fill: "currentColor"
            }, void 0, true)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["label-for", "populated", "label", "invalid", "color-scheme", "disabled", "readonly", "hint"]);
    };
  }
});
const bInput_vue_vue_type_style_index_0_scoped_b89714c2_lang = "";
const bInput = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["__scopeId", "data-v-b89714c2"]]);
const useNavigationBarDropdown = (items) => {
  const dropdownId = generateUniqueId();
  const activeTriggerId = ref(null);
  const dropdownRef = ref(null);
  const isDropdownOpen = ref(false);
  const activeItem = computed(() => {
    var _a;
    if (activeTriggerId.value === null) {
      return null;
    }
    return ((_a = items.value) == null ? void 0 : _a.find((item) => item.id === activeTriggerId.value)) ?? null;
  });
  onClickOutside(dropdownRef, (e) => {
    if (e.target instanceof HTMLElement && e.target.id === activeTriggerId.value) {
      return;
    }
    closeDropdown();
  });
  function toggleDropdown(id) {
    _updateActiveId(id);
    isDropdownOpen.value = !isDropdownOpen.value;
  }
  function closeDropdown() {
    isDropdownOpen.value = false;
    activeTriggerId.value = null;
  }
  function _updateActiveId(id) {
    if (activeTriggerId.value === id) {
      activeTriggerId.value = null;
      return;
    } else {
      activeTriggerId.value = id;
    }
  }
  return {
    activeItem,
    activeTriggerId,
    dropdownId,
    dropdownRef,
    isDropdownOpen,
    toggleDropdown,
    closeDropdown
  };
};
const _sfc_main$J = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-action-button",
  props: {
    actionButtonProps: {},
    isMobileMenu: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const actionButtonAs = computed(() => {
      var _a;
      return ((_a = props.actionButtonProps) == null ? void 0 : _a.as) || "button";
    });
    const actionButtonParsedProps = computed(() => {
      const { as: _, to, ...rest } = props.actionButtonProps;
      if (to) {
        return {
          ...rest,
          ...linkHrefParser({ as: actionButtonAs.value, to })
        };
      }
      return rest;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(actionButtonAs.value), mergeProps(actionButtonParsedProps.value, {
        class: ["b-navigation-action-button", { "b-navigation-action-button--mobile": _ctx.isMobileMenu }]
      }), {
        default: withCtx(() => [
          createTextVNode(toDisplayString(actionButtonParsedProps.value.label), 1)
        ]),
        _: 1
      }, 16, ["class"]);
    };
  }
});
const bNavigationBarActionButton_vue_vue_type_style_index_0_scoped_e1f933b2_lang = "";
const BNavigationBarActionButton = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["__scopeId", "data-v-e1f933b2"]]);
const _hoisted_1$x = { class: "b-navigation-bar-brand" };
const _hoisted_2$o = {
  key: 0,
  class: "b-navigation-bar-brand__divider"
};
const _sfc_main$I = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-brand",
  props: {
    brandProps: {},
    isBottomBar: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const brandAs = computed(() => {
      return props.brandProps.as || "button";
    });
    const brandParsedProps = computed(() => {
      const { as: _, to, ...rest } = props.brandProps;
      if (to) {
        return {
          ...rest,
          ...linkHrefParser({ as: brandAs.value, to })
        };
      }
      return rest;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$x, [
        !_ctx.isBottomBar ? (openBlock(), createElementBlock("div", _hoisted_2$o)) : createCommentVNode("", true),
        (openBlock(), createBlock(resolveDynamicComponent(brandAs.value), mergeProps({
          class: ["b-navigation-bar-brand__link", {
            "b-navigation-bar-brand__link--top-bar": !_ctx.isBottomBar,
            "b-navigation-bar-brand__link--bottom-bar": _ctx.isBottomBar
          }]
        }, brandParsedProps.value), {
          default: withCtx(() => [
            createTextVNode(toDisplayString(brandParsedProps.value.label), 1)
          ]),
          _: 1
        }, 16, ["class"]))
      ]);
    };
  }
});
const bNavigationBarBrand_vue_vue_type_style_index_0_scoped_d4715505_lang = "";
const BNavigationBarBrand = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["__scopeId", "data-v-d4715505"]]);
const _hoisted_1$w = { class: "b-navigation-bottom-bar" };
const _hoisted_2$n = { class: "b-navigation-bottom-bar__wrapper" };
const _hoisted_3$g = { class: "b-navigation-bottom-bar__items" };
const _sfc_main$H = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-bottom-bar",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$w, [
        createElementVNode("div", _hoisted_2$n, [
          renderSlot(_ctx.$slots, "brand", {}, void 0, true),
          createElementVNode("div", _hoisted_3$g, [
            renderSlot(_ctx.$slots, "menu-items", {}, void 0, true)
          ]),
          renderSlot(_ctx.$slots, "dropdown", {}, void 0, true)
        ])
      ]);
    };
  }
});
const bNavigationBarBottomBar_vue_vue_type_style_index_0_scoped_1116c445_lang = "";
const BNavigationBarBottomBar = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["__scopeId", "data-v-1116c445"]]);
const _withScopeId$3 = (n) => (pushScopeId("data-v-10bcece0"), n = n(), popScopeId(), n);
const _hoisted_1$v = {
  key: 0,
  class: "b-navigation-dropdown"
};
const _hoisted_2$m = { class: "b-navigation-dropdown__title" };
const _hoisted_3$f = /* @__PURE__ */ _withScopeId$3(() => /* @__PURE__ */ createElementVNode("div", { class: "b-navigation-dropdown__divider" }, null, -1));
const _hoisted_4$a = { key: 0 };
const _hoisted_5$4 = ["onClick"];
const _hoisted_6$4 = { class: "b-navigation-dropdown__link-text" };
const _hoisted_7$3 = { key: 1 };
const _hoisted_8$2 = { class: "b-navigation-dropdown__link-text" };
const NUMBER_OF_COLS_WITH_STANDARD_GAP = 4;
const _sfc_main$G = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-dropdown",
  props: {
    item: {}
  },
  emits: ["close"],
  setup(__props) {
    return (_ctx, _cache) => {
      return Array.isArray(_ctx.item.children) && _ctx.item.children.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_1$v, [
        createElementVNode("div", {
          class: normalizeClass(["b-navigation-dropdown__wrapper", {
            "b-navigation-dropdown__wrapper--small-gap": _ctx.item.children.length > NUMBER_OF_COLS_WITH_STANDARD_GAP
          }]),
          onKeydown: _cache[0] || (_cache[0] = withKeys(($event) => _ctx.$emit("close"), ["esc"]))
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.item.children, ({ title, items: childItem }) => {
            return openBlock(), createElementBlock("div", {
              key: title,
              class: "b-navigation-dropdown__col"
            }, [
              title ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createElementVNode("span", _hoisted_2$m, toDisplayString(title), 1),
                _hoisted_3$f
              ], 64)) : createCommentVNode("", true),
              createElementVNode("ul", {
                class: normalizeClass(["b-navigation-dropdown__links", {
                  "b-navigation-dropdown__links--without-title": !!title
                }])
              }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(childItem, ({ as, to, label, onClick, ...rest }) => {
                  return openBlock(), createElementBlock(Fragment, { key: label }, [
                    typeof onClick === "function" && !to ? (openBlock(), createElementBlock("li", _hoisted_4$a, [
                      createElementVNode("button", {
                        class: "b-navigation-dropdown__link-button",
                        onClick
                      }, [
                        createElementVNode("span", _hoisted_6$4, toDisplayString(label), 1)
                      ], 8, _hoisted_5$4)
                    ])) : to ? (openBlock(), createElementBlock("li", _hoisted_7$3, [
                      createVNode(unref(BLink), mergeProps({
                        "color-scheme": "black",
                        as,
                        to
                      }, rest, {
                        onClick: ($event) => onClick == null ? void 0 : onClick()
                      }), {
                        default: withCtx(() => [
                          createElementVNode("span", _hoisted_8$2, toDisplayString(label), 1)
                        ]),
                        _: 2
                      }, 1040, ["as", "to", "onClick"])
                    ])) : createCommentVNode("", true)
                  ], 64);
                }), 128))
              ], 2)
            ]);
          }), 128))
        ], 34)
      ])) : createCommentVNode("", true);
    };
  }
});
const bNavigationBarDropdown_vue_vue_type_style_index_0_scoped_10bcece0_lang = "";
const BNavigationBarDropdown = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["__scopeId", "data-v-10bcece0"]]);
const _hoisted_1$u = ["data-dropdown-active"];
const _hoisted_2$l = ["id"];
const _sfc_main$F = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-menu-item",
  props: {
    isBottomBar: { type: Boolean, default: false },
    item: {},
    activeId: {},
    dropdownId: {},
    toggleDropdown: {}
  },
  setup(__props) {
    const props = __props;
    const hrefProp = computed(() => {
      if (isDropdownTrigger.value || !props.item.to) {
        return {};
      }
      return linkHrefParser({
        as: props.item.as,
        to: props.item.to
      });
    });
    const linkAttr = computed(() => {
      const { label, onClick, to, as, children, id, ...rest } = props.item;
      return rest;
    });
    const componentTag = computed(
      () => props.item.as !== void 0 ? props.item.as : props.item.to ? "a" : "button"
    );
    const isDropdownTrigger = computed(() => {
      return Array.isArray(props.item.children);
    });
    const isDropdownOpen = computed(() => {
      return props.activeId === props.item.id;
    });
    const accessibilityProps = computed(
      () => {
        let attributes = {
          "aria-label": props.item.label
        };
        if (!isDropdownTrigger.value) {
          return attributes;
        }
        attributes = {
          "aria-haspopup": "true",
          "aria-expanded": isDropdownOpen.value ? "false" : "true",
          "aria-controls": props.dropdownId
        };
        return attributes;
      }
    );
    const dropdownAttrs = computed(() => {
      const {
        id: _,
        to: _1,
        onClick: _2,
        children: _3,
        as: _4,
        ...rest
      } = props.item;
      return {
        ...rest,
        ...accessibilityProps.value
      };
    });
    function onTriggerClick() {
      var _a, _b;
      if (isDropdownTrigger.value && typeof props.toggleDropdown === "function") {
        props.toggleDropdown(props.item.id);
      }
      (_b = (_a = props.item).onClick) == null ? void 0 : _b.call(_a);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["b-navigation-item", {
          "b-navigation-item--open": isDropdownOpen.value
        }]),
        "data-dropdown-active": isDropdownOpen.value,
        onClick: onTriggerClick
      }, [
        !isDropdownTrigger.value ? (openBlock(), createBlock(resolveDynamicComponent(componentTag.value), mergeProps({
          key: 0,
          id: _ctx.item.id
        }, {
          ...hrefProp.value,
          ...linkAttr.value,
          "exact-active-class": "b-navigation-item__trigger--active"
        }, { class: "b-navigation-item__trigger" }), {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.item.label), 1)
          ]),
          _: 1
        }, 16, ["id"])) : (openBlock(), createElementBlock("button", mergeProps({
          key: 1,
          id: _ctx.item.id,
          class: "b-navigation-item__trigger"
        }, dropdownAttrs.value), [
          createTextVNode(toDisplayString(_ctx.item.label) + " ", 1),
          createVNode(unref(ChevronDownIcon), {
            class: normalizeClass(["b-navigation-item__icon", {
              "b-navigation-item__icon--open": isDropdownOpen.value
            }])
          }, null, 8, ["class"])
        ], 16, _hoisted_2$l))
      ], 10, _hoisted_1$u);
    };
  }
});
const bNavigationBarMenuItem_vue_vue_type_style_index_0_scoped_45f8be30_lang = "";
const BNavigationBarMenuItem = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["__scopeId", "data-v-45f8be30"]]);
function omit(item, ...keys) {
  const ret = {};
  let key;
  for (key in item) {
    if (!keys.includes(key)) {
      ret[key] = item[key];
    }
  }
  return ret;
}
const _sfc_main$E = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-navigation-bar-service-button",
  props: {
    as: { default: "button" },
    to: {},
    label: {},
    active: { type: Boolean },
    iconOnly: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const attrs = useSafeAttrs(useAttrs());
    const linkProps = computed(() => {
      const { as, to } = props;
      if (to) {
        return linkHrefParser({ to, as });
      }
      return {};
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.as), mergeProps({
        "aria-label": _ctx.iconOnly ? _ctx.label : void 0
      }, { ...unref(attrs), ...linkProps.value }, {
        class: ["b-navigation-service-button", {
          "b-navigation-service-button--active": _ctx.active,
          "b-navigation-service-button--icon-only": _ctx.iconOnly
        }]
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", {
            iconProps: {
              fill: "currentColor",
              size: _ctx.iconOnly ? "lg" : "md"
            }
          }, void 0, true)
        ]),
        _: 3
      }, 16, ["aria-label", "class"]);
    };
  }
});
const bNavigationBarServiceButton_vue_vue_type_style_index_0_scoped_3753a4ff_lang = "";
const BNavigationBarServiceButton = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["__scopeId", "data-v-3753a4ff"]]);
const _hoisted_1$t = { class: "b-navigation-service-area" };
const _sfc_main$D = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-service-area",
  props: {
    items: {}
  },
  setup(__props) {
    function removeSchemaProps(item) {
      const attributeMap = omit(
        item,
        "as",
        "to",
        "label",
        "onClick",
        "children",
        "iconComponent",
        "iconPosition",
        "iconOnly"
      );
      return attributeMap;
    }
    function isContextMenu(item) {
      return Array.isArray(item.children) && item.children.length > 0;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$t, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item) => {
          return openBlock(), createElementBlock(Fragment, {
            key: item.label
          }, [
            isContextMenu(item) ? (openBlock(), createBlock(unref(BContextualMenu), { key: 0 }, {
              trigger: withCtx((triggerProps) => [
                createVNode(BNavigationBarServiceButton, mergeProps({
                  label: item.label
                }, {
                  ...removeSchemaProps(item),
                  ...triggerProps
                }, {
                  onClick: item.onClick
                }), {
                  default: withCtx(({ iconProps }) => [
                    item.iconComponent ? (openBlock(), createBlock(resolveDynamicComponent(item.iconComponent), normalizeProps(mergeProps({ key: 0 }, iconProps)), null, 16)) : createCommentVNode("", true),
                    createTextVNode(" " + toDisplayString(item.label) + " ", 1),
                    createVNode(unref(ChevronDownIcon), mergeProps(iconProps, {
                      class: ["b-navigation-service-area__chevron", {
                        "b-navigation-service-area__chevron--open": triggerProps["aria-Expanded"]
                      }]
                    }), null, 16, ["class"])
                  ]),
                  _: 2
                }, 1040, ["label", "onClick"])
              ]),
              content: withCtx(() => [
                createElementVNode("div", null, [
                  createVNode(unref(BContextualMenuContent), {
                    items: item.children
                  }, null, 8, ["items"])
                ])
              ]),
              _: 2
            }, 1024)) : (openBlock(), createBlock(BNavigationBarServiceButton, mergeProps({
              key: 1,
              label: item.label,
              to: item.to,
              as: item.as,
              "icon-only": item.iconOnly
            }, removeSchemaProps(item), {
              onClick: item.onClick
            }), {
              default: withCtx(({ iconProps }) => [
                !item.iconOnly && item.iconComponent && (item.iconPosition === "left" || !item.iconPosition) ? (openBlock(), createBlock(resolveDynamicComponent(item.iconComponent), normalizeProps(mergeProps({ key: 0 }, iconProps)), null, 16)) : createCommentVNode("", true),
                item.iconOnly ? (openBlock(), createBlock(resolveDynamicComponent(item.iconComponent), normalizeProps(mergeProps({ key: 1 }, iconProps)), null, 16)) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                  createTextVNode(toDisplayString(item.label), 1)
                ], 64)),
                !item.iconOnly && item.iconComponent && item.iconPosition === "right" ? (openBlock(), createBlock(resolveDynamicComponent(item.iconComponent), normalizeProps(mergeProps({ key: 3 }, iconProps)), null, 16)) : createCommentVNode("", true)
              ]),
              _: 2
            }, 1040, ["label", "to", "as", "icon-only", "onClick"]))
          ], 64);
        }), 128))
      ]);
    };
  }
});
const bNavigationBarServiceArea_vue_vue_type_style_index_0_scoped_aa85d00d_lang = "";
const BNavigationBarServiceArea = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["__scopeId", "data-v-aa85d00d"]]);
const _hoisted_1$s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 2712 569"
};
const _hoisted_2$k = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#a)"><path fill="#6D6E70" d="M633.872 233.191h-42.674v-57.246h42.674c0-19.776 2.082-35.388 5.204-48.919 4.164-13.531 9.368-23.94 17.695-31.226 8.326-8.326 18.735-13.53 32.266-16.653 13.531-3.122 29.143-5.204 47.878-5.204h21.858c7.286 0 14.572 1.04 21.857 1.04v62.451c-8.326-1.041-16.653-2.082-23.939-2.082-10.408 0-17.694 1.041-23.939 4.164-6.245 3.122-9.368 10.408-9.368 22.898v13.531h53.083v57.246h-53.083v213.373h-89.512V233.191Zm160.289-57.246h86.39v47.879h1.041c6.245-17.694 16.653-30.184 31.225-39.552 14.572-9.367 31.225-13.531 49.96-13.531h10.409c3.122 0 7.286 1.041 10.408 2.082v81.185c-6.245-2.081-11.449-3.122-16.653-4.163-5.204-1.041-11.449-1.041-16.654-1.041-11.449 0-20.816 2.082-29.143 5.204-8.327 3.123-15.613 8.327-20.817 14.572-5.204 6.245-10.408 12.49-12.49 20.817-3.123 8.327-4.163 15.613-4.163 23.939v133.228h-88.472V175.945h-1.041ZM989.84 311.254c0-19.776 3.122-39.552 10.41-56.205 7.28-17.695 16.65-32.266 29.14-45.797 12.49-13.531 27.06-22.899 44.76-30.185 17.69-7.285 36.43-11.449 57.24-11.449 20.82 0 39.56 4.164 57.25 11.449 17.69 7.286 32.27 17.695 45.8 30.185 12.49 12.49 22.9 28.102 29.14 45.797 7.29 17.694 10.41 36.429 10.41 56.205 0 20.817-3.12 39.552-10.41 57.246-7.29 17.695-16.65 32.266-29.14 44.756-12.49 12.49-28.11 22.899-45.8 30.185-17.69 7.286-36.43 11.449-57.25 11.449-20.81 0-40.59-4.163-57.24-11.449-17.7-7.286-32.27-17.695-44.76-30.185-12.49-12.49-21.86-28.102-29.14-44.756-7.288-17.694-10.41-36.429-10.41-57.246Zm88.47 0c0 8.327 1.04 17.694 3.12 26.021 2.09 9.368 5.21 16.653 9.37 23.939 4.16 7.286 9.37 13.531 16.65 17.695 7.29 4.163 15.62 7.285 26.03 7.285 10.4 0 18.73-2.081 26.02-7.285 7.28-4.164 12.49-10.409 16.65-17.695 4.16-7.286 7.29-15.612 9.37-23.939 2.08-9.368 3.12-17.694 3.12-26.021 0-8.327-1.04-17.694-3.12-26.021-2.08-9.368-5.21-16.653-9.37-23.939-4.16-7.286-9.37-13.531-16.65-17.695-7.29-5.204-15.62-7.285-26.02-7.285-10.41 0-18.74 2.081-26.03 7.285-7.28 5.205-12.49 10.409-16.65 17.695-4.16 7.286-7.28 15.612-9.37 23.939-2.08 9.368-3.12 17.694-3.12 26.021Zm227.94-135.309h86.39v37.47h1.04c4.17-7.286 9.37-13.531 15.62-18.735 6.24-5.204 13.53-10.408 20.81-14.572 7.29-4.163 15.62-7.286 23.94-9.367 8.33-2.082 16.66-3.123 24.98-3.123 22.9 0 40.6 4.164 53.09 11.449 13.53 7.286 22.89 16.654 29.14 27.062 6.24 10.409 10.41 21.858 12.49 34.348 2.08 12.49 2.08 22.898 2.08 33.307v172.779h-88.47V288.356c0-9.368-1.04-16.654-4.16-23.94-3.13-7.286-7.29-12.49-13.53-16.653-6.25-4.164-15.62-6.245-27.07-6.245-8.32 0-15.61 2.081-21.85 5.204-6.25 3.122-11.45 7.286-14.58 13.531-4.16 5.204-6.24 11.449-8.32 18.735s-3.12 14.572-3.12 21.858v145.717h-88.48V175.945Zm474.63 57.245h-55.17v122.819c0 10.409 3.12 17.695 8.33 20.817 6.24 3.123 13.53 5.204 22.9 5.204 4.16 0 7.28 0 11.45-1.04h11.45v65.572c-8.33 0-15.62 1.041-23.94 2.082-8.33 1.041-16.66 1.041-23.94 1.041-18.74 0-34.35-2.082-46.84-5.204-12.49-3.123-21.86-8.327-29.14-15.613-7.29-7.286-12.49-16.653-14.58-29.143-3.12-12.49-4.16-27.062-4.16-45.797V233.19h-44.76v-57.246h44.76V93.718h88.47v82.226h55.17v57.246Zm121.78-90.551h-88.48V74.984h88.48v67.655Zm-89.52 33.307h88.48v270.618h-88.48V175.946Zm211.29 157.165c1.04 18.735 6.25 33.307 16.66 44.756 10.4 11.449 24.98 16.654 43.71 16.654 10.41 0 20.82-2.082 30.19-7.286 9.36-5.204 16.65-12.49 20.81-22.899h83.27c-4.16 15.613-10.41 29.144-19.78 40.593-9.36 11.449-19.77 20.817-31.22 28.103-12.49 7.286-24.98 12.49-39.55 16.653-14.57 3.123-29.15 5.204-43.72 5.204-21.86 0-41.63-3.122-60.37-9.367-18.73-6.245-34.34-15.613-46.83-28.103-12.49-12.49-22.9-27.062-30.19-45.797-7.28-17.694-10.41-38.511-10.41-60.369 0-20.816 4.17-39.552 11.45-57.246 7.29-17.694 17.7-32.266 31.23-44.756 13.53-12.49 29.14-21.858 46.83-29.143 17.7-7.286 36.43-10.409 56.21-10.409 23.94 0 45.8 4.164 63.49 12.49 17.7 8.327 33.31 19.776 44.76 35.389 11.45 15.612 20.81 32.266 26.02 52.042 5.2 19.776 8.33 41.633 7.28 64.532h-199.84v-1.041Zm110.33-49.96c-1.04-15.613-6.24-28.103-15.61-39.552-9.37-10.409-21.86-16.654-37.47-16.654s-28.1 5.205-38.51 15.613c-10.41 10.408-16.66 23.939-18.74 40.593h110.33Zm119.7-107.206h86.39v47.879h1.04c6.25-17.694 16.65-30.184 31.23-39.552 14.57-9.367 31.22-13.531 49.96-13.531h10.4c3.13 0 7.29 1.041 10.41 2.082v81.185c-6.24-2.081-11.45-3.122-16.65-4.163-5.21-1.041-11.45-1.041-16.65-1.041-11.45 0-20.82 2.082-29.15 5.204-8.32 3.123-15.61 8.327-20.81 14.572-6.25 6.245-10.41 12.49-12.49 20.817-3.13 8.327-4.17 15.613-4.17 23.939v133.228h-88.47V175.945h-1.04Zm279.99 182.146c0 7.286 1.04 12.49 4.16 17.694 3.12 5.205 6.24 9.368 10.41 12.491 4.16 3.122 9.36 5.204 14.57 7.285 6.24 2.082 11.45 2.082 17.69 2.082 4.17 0 8.33 0 13.53-2.082 5.21-1.04 9.37-3.122 13.53-5.204 4.17-2.081 7.29-5.204 10.41-9.367 3.13-4.164 4.17-8.327 4.17-13.531 0-5.204-2.09-9.368-5.21-12.49-3.12-3.123-7.28-6.245-11.45-8.327-4.16-2.082-9.36-4.163-14.57-5.204-5.2-1.041-9.37-2.082-13.53-3.123-13.53-3.122-28.1-6.245-42.67-9.367-14.58-3.123-28.11-7.286-40.6-12.49-12.49-6.245-22.9-13.531-30.18-23.94-8.33-10.408-11.45-23.939-11.45-42.674 0-16.654 4.16-30.184 11.45-40.593 8.33-10.408 17.69-18.735 30.18-24.98 12.49-6.245 26.02-10.408 40.6-13.531 14.57-3.122 28.1-4.163 41.63-4.163 14.57 0 29.14 1.041 43.71 4.163 14.58 2.082 27.07 7.286 39.56 13.531 12.49 6.245 21.85 15.613 29.14 27.062 7.29 11.449 11.45 26.021 12.49 43.715h-82.23c0-10.408-4.16-18.735-11.45-23.939-7.28-4.164-16.65-7.286-28.1-7.286-4.16 0-8.32 0-12.49 1.041-4.16 1.041-8.32 1.041-12.49 2.081-4.16 1.041-7.28 3.123-9.37 6.245-2.08 3.123-4.16 6.245-4.16 11.45 0 6.245 3.12 11.449 10.41 15.612 6.24 4.164 14.57 7.286 24.98 10.409 10.41 2.081 20.82 5.204 32.27 7.286 11.44 2.081 22.89 4.163 33.3 6.245 13.53 3.122 24.98 7.285 33.31 13.53 9.37 6.246 15.61 12.491 20.82 19.776 5.2 7.286 9.36 14.572 11.45 21.858 2.08 7.286 3.12 13.531 3.12 19.776 0 17.694-4.17 33.307-11.45 45.797-8.33 12.49-17.7 21.858-30.19 30.184-12.49 7.286-26.02 12.49-41.63 16.654-15.61 3.122-31.22 5.204-45.8 5.204-15.61 0-32.26-1.041-47.87-4.163-15.62-3.123-29.15-8.327-41.64-15.613a83.852 83.852 0 0 1-30.18-30.184c-8.33-12.49-12.49-28.103-12.49-46.838h84.31v-2.082Z"></path><path fill="#8BC53F" d="M0 480.91V280.028l187.351-58.287v200.882L0 480.91Z"></path><path fill="#EBD417" d="M187.351 422.623V221.741l126.983 87.431v200.882l-126.983-87.431Z"></path><path fill="#034EA1" d="M126.982 568.342 0 480.911l187.351-58.287 126.983 87.431-187.352 58.287Z"></path><path fill="#712E74" d="m183.188 211.331 51.001-116.574 65.573 155.085-51.001 116.574-65.573-155.085Z"></path><path fill="#009FD1" d="m248.761 366.415 51.001-116.574 171.739-28.102-49.96 115.533-172.78 29.143Z"></path><path fill="#F6921E" d="M299.762 249.843 234.189 94.758l171.739-28.103 65.573 155.085-171.739 28.103Z"></path><path fill="#DA2128" d="M187.352 221.741 59.328 197.802 44.757 70.819 172.78 94.76l14.572 126.982Z"></path><path fill="#25BCBD" d="M172.78 94.758 44.757 70.82 115.534.042l128.023 23.94-70.777 70.776Z"></path><path fill="#00844A" d="m258.129 152.005-70.777 69.736-14.571-126.982 70.777-70.778 14.571 128.024Z"></path></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h2712v569H0z"></path></clipPath></defs>', 2);
const _hoisted_4$9 = [
  _hoisted_2$k
];
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$s, _hoisted_4$9);
}
const FrontiersLogo = { render };
const _sfc_main$C = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-logo",
  props: {
    logoProps: {},
    withBrand: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const logoAs = computed(() => {
      var _a, _b;
      return ((_a = props.logoProps) == null ? void 0 : _a.as) || ((_b = props.logoProps) == null ? void 0 : _b.to) ? "a" : "div";
    });
    const logoParsedProps = computed(() => {
      const { as: _, to, label, ...rest } = props.logoProps || {};
      if (logoAs.value === "div") {
        return {};
      }
      if (to) {
        return {
          "aria-label": label,
          ...rest,
          ...linkHrefParser({ as: logoAs.value, to })
        };
      }
      return { ...rest, "aria-label": label };
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["b-navigation-bar-logo", [
          {
            "b-navigation-bar-logo--no-margin": _ctx.withBrand
          }
        ]])
      }, [
        (openBlock(), createBlock(resolveDynamicComponent(logoAs.value), mergeProps(logoParsedProps.value, { class: "b-navigation-bar-logo__item" }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default", {}, () => [
              createVNode(unref(FrontiersLogo), { class: "b-navigation-bar-logo__base-logo" })
            ], true)
          ]),
          _: 3
        }, 16))
      ], 2);
    };
  }
});
const bNavigationBarLogo_vue_vue_type_style_index_0_scoped_dd1b5d4c_lang = "";
const BNavigationBarLogo = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["__scopeId", "data-v-dd1b5d4c"]]);
const _hoisted_1$r = { class: "b-navigation-bar-top" };
const _hoisted_2$j = { class: "b-navigation-bar-top__wrapper" };
const _hoisted_3$e = { class: "b-navigation-bar__brand" };
const _hoisted_4$8 = { class: "b-navigation-bar-top__service-login-area" };
const _sfc_main$B = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-top-bar",
  props: {
    logoProps: {},
    withBrand: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$r, [
        createElementVNode("div", _hoisted_2$j, [
          createVNode(BNavigationBarLogo, {
            "logo-props": _ctx.logoProps,
            "with-brand": _ctx.withBrand
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "logo", {}, void 0, true)
            ]),
            _: 3
          }, 8, ["logo-props", "with-brand"]),
          createElementVNode("div", _hoisted_3$e, [
            renderSlot(_ctx.$slots, "brand", {}, void 0, true)
          ]),
          renderSlot(_ctx.$slots, "menu-items", {}, void 0, true),
          renderSlot(_ctx.$slots, "action-button", {}, void 0, true),
          createElementVNode("div", _hoisted_4$8, [
            renderSlot(_ctx.$slots, "service-area", {}, void 0, true),
            renderSlot(_ctx.$slots, "login", {}, void 0, true)
          ]),
          renderSlot(_ctx.$slots, "dropdown", {}, void 0, true)
        ])
      ]);
    };
  }
});
const bNavigationBarTopBar_vue_vue_type_style_index_0_scoped_2048ee95_lang = "";
const BNavigationBarTopBar$1 = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["__scopeId", "data-v-2048ee95"]]);
const _hoisted_1$q = {
  class: "b-navigation-bar",
  "aria-label": "Main navigation bar"
};
const _sfc_main$A = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-desktop",
  props: {
    items: {},
    bottomBarItems: {},
    brandProps: {},
    bottomBarBrandProps: {},
    actionButtonProps: {},
    logoProps: {},
    serviceAreaItems: {}
  },
  setup(__props) {
    const props = __props;
    const items = computed(
      () => props.items.map((item) => ({
        ...item,
        id: generateUniqueId()
      }))
    );
    const bottomBarItems = computed(
      () => {
        var _a;
        return (_a = props.bottomBarItems) == null ? void 0 : _a.map((item) => ({
          ...item,
          id: generateUniqueId()
        }));
      }
    );
    const {
      activeItem: topActiveItem,
      activeTriggerId: topActiveTriggerId,
      dropdownRef: topDropdownRef,
      dropdownId: topDropdownId,
      closeDropdown: closeTopDropdown,
      toggleDropdown: toggleTopDropdown,
      isDropdownOpen: isTopDropdownOpen
    } = useNavigationBarDropdown(items);
    const {
      activeItem: bottomActiveItem,
      activeTriggerId: bottomActiveTriggerId,
      dropdownId: bottomDropdownId,
      dropdownRef: bottomDropdownRef,
      closeDropdown: closeBottomDropdown,
      toggleDropdown: toggleBottomDropdown,
      isDropdownOpen: isBottomDropdownOpen
    } = useNavigationBarDropdown(bottomBarItems);
    const hasBottomBar = computed(
      () => Array.isArray(bottomBarItems.value) && bottomBarItems.value.length > 0
    );
    const showtopBarDropdown = computed(() => {
      return isTopDropdownOpen.value && Array.isArray(items.value) && items.value.length > 0;
    });
    const showBottomBarDropdown = computed(() => {
      return isBottomDropdownOpen.value && hasBottomBar.value;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", _hoisted_1$q, [
        createVNode(BNavigationBarTopBar$1, {
          "logo-props": _ctx.logoProps,
          "with-brand": !!_ctx.brandProps
        }, {
          logo: withCtx(() => [
            renderSlot(_ctx.$slots, "logo", {}, void 0, true)
          ]),
          brand: withCtx(() => [
            _ctx.brandProps ? (openBlock(), createBlock(BNavigationBarBrand, {
              key: 0,
              "brand-props": _ctx.brandProps
            }, null, 8, ["brand-props"])) : createCommentVNode("", true)
          ]),
          "menu-items": withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(items.value, (item, index) => {
              return openBlock(), createBlock(BNavigationBarMenuItem, {
                key: item.label + index,
                "dropdown-id": unref(topDropdownId),
                "toggle-dropdown": unref(toggleTopDropdown),
                "active-id": unref(topActiveTriggerId),
                item
              }, null, 8, ["dropdown-id", "toggle-dropdown", "active-id", "item"]);
            }), 128))
          ]),
          "action-button": withCtx(() => [
            _ctx.actionButtonProps ? (openBlock(), createBlock(BNavigationBarActionButton, {
              key: 0,
              "action-button-props": _ctx.actionButtonProps
            }, null, 8, ["action-button-props"])) : createCommentVNode("", true)
          ]),
          "service-area": withCtx(() => [
            renderSlot(_ctx.$slots, "service-area", {}, () => [
              _ctx.serviceAreaItems ? (openBlock(), createBlock(BNavigationBarServiceArea, {
                key: 0,
                items: _ctx.serviceAreaItems
              }, null, 8, ["items"])) : createCommentVNode("", true)
            ], true)
          ]),
          login: withCtx(() => [
            renderSlot(_ctx.$slots, "login", {}, void 0, true)
          ]),
          dropdown: withCtx(() => [
            createVNode(Transition, { name: "b-navigation-bar__dropdown-fade-" }, {
              default: withCtx(() => [
                showtopBarDropdown.value && unref(topActiveItem) ? (openBlock(), createBlock(BNavigationBarDropdown, {
                  key: 0,
                  id: unref(topDropdownId),
                  ref_key: "topDropdownRef",
                  ref: topDropdownRef,
                  item: unref(topActiveItem),
                  onClose: unref(closeTopDropdown)
                }, null, 8, ["id", "item", "onClose"])) : createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 3
        }, 8, ["logo-props", "with-brand"]),
        hasBottomBar.value ? (openBlock(), createBlock(BNavigationBarBottomBar, { key: 0 }, {
          brand: withCtx(() => [
            _ctx.bottomBarBrandProps ? (openBlock(), createBlock(BNavigationBarBrand, {
              key: 0,
              "brand-props": _ctx.bottomBarBrandProps,
              "is-bottom-bar": true
            }, null, 8, ["brand-props"])) : createCommentVNode("", true)
          ]),
          "menu-items": withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(bottomBarItems.value, (item, index) => {
              return openBlock(), createBlock(BNavigationBarMenuItem, {
                key: item.label + index,
                "dropdown-id": unref(bottomDropdownId),
                "is-bottom-bar": true,
                "active-id": unref(bottomActiveTriggerId),
                "toggle-dropdown": unref(toggleBottomDropdown),
                item
              }, null, 8, ["dropdown-id", "active-id", "toggle-dropdown", "item"]);
            }), 128))
          ]),
          dropdown: withCtx(() => [
            createVNode(Transition, { name: "b-navigation-bar__dropdown-second-level-fade-" }, {
              default: withCtx(() => [
                showBottomBarDropdown.value && unref(bottomActiveItem) ? (openBlock(), createBlock(BNavigationBarDropdown, {
                  key: 0,
                  id: unref(bottomDropdownId),
                  ref_key: "bottomDropdownRef",
                  ref: bottomDropdownRef,
                  item: unref(bottomActiveItem),
                  onClose: unref(closeBottomDropdown)
                }, null, 8, ["id", "item", "onClose"])) : createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : createCommentVNode("", true)
      ]);
    };
  }
});
const bNavigationBarDesktop_vue_vue_type_style_index_0_scoped_9b20e9ed_lang = "";
const BNavigationBarDesktop = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["__scopeId", "data-v-9b20e9ed"]]);
const _hoisted_1$p = { class: "b-navigation-bar-mobile-brand" };
const _sfc_main$z = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-mobile-brand",
  props: {
    brandProps: {}
  },
  setup(__props) {
    const props = __props;
    const brandAs = computed(() => {
      return props.brandProps.as || "button";
    });
    const brandParsedProps = computed(() => {
      const { as: _, to, label: __, ...rest } = props.brandProps;
      if (to) {
        return {
          ...rest,
          ...linkHrefParser({ to, as: brandAs.value })
        };
      }
      return rest;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$p, [
        (openBlock(), createBlock(resolveDynamicComponent(brandAs.value), mergeProps({
          class: "b-navigation-bar-mobile-brand__link",
          "aria-label": brandParsedProps.value.label
        }, brandParsedProps.value), {
          default: withCtx(() => [
            createTextVNode(toDisplayString(brandParsedProps.value.label), 1)
          ]),
          _: 1
        }, 16, ["aria-label"]))
      ]);
    };
  }
});
const bNavigationBarMobileBrand_vue_vue_type_style_index_0_scoped_1aeeeb5c_lang = "";
const BNavigationBarMobileBrand = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["__scopeId", "data-v-1aeeeb5c"]]);
const _sfc_main$y = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-mobile-item",
  props: {
    item: {},
    activeId: {}
  },
  emits: ["toggle-secondary-menu"],
  setup(__props, { emit }) {
    const props = __props;
    const linkAttr = computed(() => {
      const { label, onClick, to, as, children, id, ...rest } = props.item;
      return rest;
    });
    const componentTag = computed(
      () => props.item.as !== void 0 ? props.item.as : props.item.to ? "a" : "button"
    );
    const isDropdownTrigger = computed(() => {
      return Array.isArray(props.item.children);
    });
    const isMobileMenuOpen = computed(() => {
      return props.activeId === props.item.id;
    });
    const hrefProp = computed(() => {
      if (isDropdownTrigger.value || !props.item.to) {
        return {};
      }
      return linkHrefParser({
        as: componentTag.value,
        to: props.item.to
      });
    });
    const accessibilityProps = computed(
      () => {
        let attributes = {
          "aria-label": props.item.label
        };
        if (!isDropdownTrigger.value) {
          return attributes;
        }
        attributes = {
          "aria-haspopup": "true",
          "aria-expanded": isMobileMenuOpen.value ? "false" : "true",
          "aria-controls": props.activeId ?? void 0
        };
        return attributes;
      }
    );
    function onTriggerClick() {
      var _a, _b;
      if (isDropdownTrigger.value) {
        emit("toggle-secondary-menu", props.item.id);
      }
      (_b = (_a = props.item).onClick) == null ? void 0 : _b.call(_a);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "b-navigation-mobile-item",
        onClick: onTriggerClick
      }, [
        !isDropdownTrigger.value ? (openBlock(), createBlock(resolveDynamicComponent(componentTag.value), mergeProps({ key: 0 }, {
          ...hrefProp.value,
          ...linkAttr.value,
          "exact-active-class": "b-navigation-mobile-item__trigger--active"
        }, { class: "b-navigation-mobile-item__trigger" }), {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.item.label), 1)
          ]),
          _: 1
        }, 16)) : (openBlock(), createElementBlock("button", mergeProps({
          key: 1,
          class: "b-navigation-mobile-item__trigger"
        }, accessibilityProps.value), [
          createTextVNode(toDisplayString(_ctx.item.label) + " ", 1),
          createVNode(unref(ChevronRightIcon), { class: "b-navigation-mobile-item__icon" })
        ], 16))
      ]);
    };
  }
});
const bNavigationBarMobileItem_vue_vue_type_style_index_0_scoped_6d717911_lang = "";
const BNavigationBarMobileItem = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["__scopeId", "data-v-6d717911"]]);
const _hoisted_1$o = { class: "b-navigation-bar-mobile-menu-secondary" };
const _hoisted_2$i = { class: "b-navigation-bar-mobile-menu-secondary__top" };
const _hoisted_3$d = { class: "b-navigation-bar-mobile-menu-secondary__title" };
const _hoisted_4$7 = { class: "b-navigation-bar-mobile-menu-secondary__content" };
const _hoisted_5$3 = {
  key: 0,
  class: "b-navigation-bar-mobile-menu-secondary__item-title"
};
const _hoisted_6$3 = { class: "b-navigation-bar-mobile-menu-secondary__links" };
const _hoisted_7$2 = { key: 0 };
const _hoisted_8$1 = ["onClick"];
const _hoisted_9$1 = { class: "b-navigation-bar-mobile-menu-secondary__link-text" };
const _hoisted_10$1 = { key: 1 };
const _hoisted_11 = { class: "b-navigation-bar-mobile-menu-secondary__link-text" };
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-mobile-menu-secondary",
  props: {
    item: {}
  },
  emits: ["close-mobile-menu-secondary", "close-mobile-menu"],
  setup(__props, { emit }) {
    const props = __props;
    const isButton = (item) => "onClick" in item && !("to" in item);
    const isLink = (item) => "to" in item;
    const hasItemsArray = (child) => "items" in child;
    const parseItemChildren = computed(() => {
      const children = props.item.children ?? [];
      if (children.length === 0) {
        return [];
      }
      if (hasItemsArray(children[0])) {
        return children;
      }
      return [{ items: children, title: void 0 }];
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$o, [
        createElementVNode("div", _hoisted_2$i, [
          createElementVNode("button", {
            type: "button",
            class: "b-navigation-bar-mobile-menu-secondary__back-button",
            onClick: _cache[0] || (_cache[0] = ($event) => emit("close-mobile-menu-secondary"))
          }, [
            createVNode(unref(ChevronLeftIcon), {
              size: "lg",
              fill: "currentColor"
            }),
            createElementVNode("span", _hoisted_3$d, toDisplayString(_ctx.item.label), 1)
          ]),
          createElementVNode("button", {
            type: "button",
            class: "b-navigation-bar-mobile-menu-secondary__close-button",
            onClick: _cache[1] || (_cache[1] = ($event) => emit("close-mobile-menu"))
          }, [
            createVNode(unref(CloseIcon), {
              size: "lg",
              fill: "currentColor"
            })
          ])
        ]),
        createElementVNode("div", _hoisted_4$7, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(parseItemChildren.value, ({ title, items: childItem }, index) => {
            return openBlock(), createElementBlock("div", {
              key: index,
              class: normalizeClass(["b-navigation-bar-mobile-menu-secondary__col", {
                "b-navigation-bar-mobile-menu-secondary__col--with-title": !!title
              }])
            }, [
              title ? (openBlock(), createElementBlock("span", _hoisted_5$3, toDisplayString(title), 1)) : createCommentVNode("", true),
              createElementVNode("ul", _hoisted_6$3, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(childItem, (grandChildItem, childIndex) => {
                  return openBlock(), createElementBlock(Fragment, { key: childIndex }, [
                    isButton(grandChildItem) ? (openBlock(), createElementBlock("li", _hoisted_7$2, [
                      createElementVNode("button", {
                        class: "b-navigation-bar-mobile-menu-secondary__link-button",
                        onClick: grandChildItem.onClick
                      }, [
                        createElementVNode("div", _hoisted_9$1, toDisplayString(grandChildItem.label), 1)
                      ], 8, _hoisted_8$1)
                    ])) : isLink(grandChildItem) ? (openBlock(), createElementBlock("li", _hoisted_10$1, [
                      createVNode(unref(BLink), {
                        "color-scheme": "black",
                        as: grandChildItem.as,
                        to: grandChildItem.to,
                        onClick: ($event) => {
                          var _a;
                          return (_a = grandChildItem.onClick) == null ? void 0 : _a.call(grandChildItem);
                        }
                      }, {
                        default: withCtx(() => [
                          createElementVNode("div", _hoisted_11, toDisplayString(grandChildItem.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["as", "to", "onClick"])
                    ])) : createCommentVNode("", true)
                  ], 64);
                }), 128))
              ])
            ], 2);
          }), 128))
        ])
      ]);
    };
  }
});
const bNavigationBarMobileMenuSecondary_vue_vue_type_style_index_0_scoped_a0492418_lang = "";
const BNavigationBarMobileMenuSecondary = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["__scopeId", "data-v-a0492418"]]);
const _hoisted_1$n = { class: "b-navigation-bar-mobile-side-panel" };
const _hoisted_2$h = { class: "b-navigation-bar-mobile-side-panel__header" };
const _hoisted_3$c = { class: "b-navigation-bar-mobile-side-panel__items" };
const _sfc_main$w = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-mobile-side-panel",
  props: {
    logoProps: {}
  },
  emits: ["close-mobile-menu"],
  setup(__props, { emit }) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$n, [
        createElementVNode("div", _hoisted_2$h, [
          createVNode(BNavigationBarLogo, {
            "logo-props": _ctx.logoProps,
            "with-brand": false
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "logo", {}, void 0, true)
            ]),
            _: 3
          }, 8, ["logo-props"]),
          createElementVNode("button", {
            type: "button",
            class: "b-navigation-bar-mobile-side-panel__close-button",
            onClick: _cache[0] || (_cache[0] = ($event) => emit("close-mobile-menu"))
          }, [
            createVNode(unref(CloseIcon), {
              size: "lg",
              fill: "currentColor"
            })
          ])
        ]),
        createElementVNode("div", _hoisted_3$c, [
          renderSlot(_ctx.$slots, "items", {}, void 0, true)
        ])
      ]);
    };
  }
});
const bNavigationBarMobileSidePanel_vue_vue_type_style_index_0_scoped_e643b5f8_lang = "";
const BNavigationBarMobileSidePanel = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["__scopeId", "data-v-e643b5f8"]]);
const _hoisted_1$m = { class: "b-navigation-bar-top" };
const _hoisted_2$g = { class: "b-navigation-bar-top__wrapper" };
const _hoisted_3$b = { class: "b-navigation-bar__brand" };
const _hoisted_4$6 = { class: "b-navigation-bar-top__service-login-area" };
const _sfc_main$v = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-mobile-top-bar",
  props: {
    logoProps: {},
    withBrand: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$m, [
        renderSlot(_ctx.$slots, "hamburger", {}, void 0, true),
        createElementVNode("div", _hoisted_2$g, [
          createVNode(BNavigationBarLogo, {
            "logo-props": _ctx.logoProps,
            "with-brand": _ctx.withBrand
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "logo", {}, void 0, true)
            ]),
            _: 3
          }, 8, ["logo-props", "with-brand"]),
          createElementVNode("div", _hoisted_3$b, [
            renderSlot(_ctx.$slots, "brand", {}, void 0, true)
          ]),
          createElementVNode("div", _hoisted_4$6, [
            renderSlot(_ctx.$slots, "login", {}, void 0, true)
          ])
        ])
      ]);
    };
  }
});
const bNavigationBarMobileTopBar_vue_vue_type_style_index_0_scoped_da64cc2c_lang = "";
const BNavigationBarTopBar = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["__scopeId", "data-v-da64cc2c"]]);
const _withScopeId$2 = (n) => (pushScopeId("data-v-69dd183c"), n = n(), popScopeId(), n);
const _hoisted_1$l = {
  class: "b-navigation-bar",
  "aria-label": "Main navigation bar"
};
const _hoisted_2$f = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("div", { class: "b-navigation-bar-mobile-menu__divider" }, null, -1));
const _hoisted_3$a = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("div", { class: "b-navigation-bar-mobile-menu__divider" }, null, -1));
const _sfc_main$u = /* @__PURE__ */ defineComponent({
  __name: "b-navigation-bar-mobile",
  props: {
    items: {},
    bottomBarItems: {},
    brandProps: {},
    bottomBarBrandProps: {},
    actionButtonProps: {},
    logoProps: {},
    serviceAreaItems: {}
  },
  setup(__props) {
    const props = __props;
    const items = computed(
      () => props.items.map((item) => ({
        ...item,
        id: generateUniqueId()
      }))
    );
    const bottomBarItems = computed(
      () => {
        var _a;
        return (_a = props.bottomBarItems) == null ? void 0 : _a.map((item) => ({
          ...item,
          id: generateUniqueId()
        }));
      }
    );
    const isLocked = useScrollLock(document.body);
    const showMobileMenu = ref(false);
    const activeMenuSecondaryId = ref(null);
    const serviceAreaItems = computed(() => {
      var _a;
      return (_a = props.serviceAreaItems) == null ? void 0 : _a.map((item) => ({
        ...item,
        id: generateUniqueId()
      }));
    });
    const activeMenuSecondaryItem = computed(() => {
      return [
        ...items.value,
        ...bottomBarItems.value || [],
        ...serviceAreaItems.value || []
      ].find((item) => item.id === activeMenuSecondaryId.value);
    });
    const toggleSecondaryMenu = (id) => {
      activeMenuSecondaryId.value = activeMenuSecondaryId.value === id ? null : id;
    };
    const closeMobileMenu = () => {
      activeMenuSecondaryId.value = null;
      showMobileMenu.value = false;
    };
    watch(showMobileMenu, (value) => isLocked.value = value);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", _hoisted_1$l, [
        createVNode(BNavigationBarTopBar, {
          "logo-props": _ctx.logoProps,
          "with-brand": !!_ctx.brandProps
        }, {
          hamburger: withCtx(() => [
            createElementVNode("button", {
              class: "b-navigation-bar__hamburger",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event) => showMobileMenu.value = true)
            }, [
              createVNode(unref(BurgerIcon), {
                size: "lg",
                fill: "currentColor"
              })
            ])
          ]),
          logo: withCtx(() => [
            renderSlot(_ctx.$slots, "logo", {}, void 0, true)
          ]),
          brand: withCtx(() => [
            _ctx.brandProps ? (openBlock(), createBlock(BNavigationBarBrand, {
              key: 0,
              "brand-props": _ctx.brandProps
            }, null, 8, ["brand-props"])) : createCommentVNode("", true)
          ]),
          login: withCtx(() => [
            renderSlot(_ctx.$slots, "login", {}, void 0, true)
          ]),
          _: 3
        }, 8, ["logo-props", "with-brand"]),
        createVNode(Transition, { name: "b-navigation-bar__mobile-menu-slide-" }, {
          default: withCtx(() => [
            withDirectives(createVNode(BNavigationBarMobileSidePanel, {
              "logo-props": _ctx.logoProps,
              onCloseMobileMenu: closeMobileMenu
            }, {
              logo: withCtx(() => [
                renderSlot(_ctx.$slots, "logo", {}, void 0, true)
              ]),
              items: withCtx(() => [
                _ctx.bottomBarBrandProps ? (openBlock(), createBlock(BNavigationBarMobileBrand, {
                  key: 0,
                  "brand-props": _ctx.bottomBarBrandProps
                }, null, 8, ["brand-props"])) : createCommentVNode("", true),
                (openBlock(true), createElementBlock(Fragment, null, renderList(bottomBarItems.value, (item, index) => {
                  return openBlock(), createBlock(BNavigationBarMobileItem, {
                    key: item.label + index,
                    "active-id": activeMenuSecondaryId.value,
                    item,
                    onToggleSecondaryMenu: toggleSecondaryMenu
                  }, null, 8, ["active-id", "item"]);
                }), 128)),
                _hoisted_2$f,
                (openBlock(true), createElementBlock(Fragment, null, renderList(items.value, (item, index) => {
                  return openBlock(), createBlock(BNavigationBarMobileItem, {
                    key: item.label + index,
                    "active-id": activeMenuSecondaryId.value,
                    item,
                    onToggleSecondaryMenu: toggleSecondaryMenu
                  }, null, 8, ["active-id", "item"]);
                }), 128)),
                _ctx.actionButtonProps ? (openBlock(), createBlock(BNavigationBarActionButton, {
                  key: 1,
                  "action-button-props": _ctx.actionButtonProps,
                  "is-mobile-menu": ""
                }, null, 8, ["action-button-props"])) : createCommentVNode("", true),
                _hoisted_3$a,
                (openBlock(true), createElementBlock(Fragment, null, renderList(serviceAreaItems.value, (item, index) => {
                  return openBlock(), createBlock(BNavigationBarMobileItem, {
                    key: item.label + index,
                    "active-id": activeMenuSecondaryId.value,
                    item,
                    onToggleSecondaryMenu: toggleSecondaryMenu
                  }, null, 8, ["active-id", "item"]);
                }), 128))
              ]),
              _: 3
            }, 8, ["logo-props"]), [
              [vShow, showMobileMenu.value]
            ])
          ]),
          _: 3
        }),
        createVNode(Transition, { name: "b-navigation-bar__mobile-menu-slide-" }, {
          default: withCtx(() => [
            activeMenuSecondaryItem.value ? (openBlock(), createBlock(BNavigationBarMobileMenuSecondary, {
              key: 0,
              id: activeMenuSecondaryId.value,
              item: activeMenuSecondaryItem.value,
              onCloseMobileMenu: closeMobileMenu,
              onCloseMobileMenuSecondary: _cache[1] || (_cache[1] = ($event) => activeMenuSecondaryId.value = null)
            }, null, 8, ["id", "item"])) : createCommentVNode("", true)
          ]),
          _: 1
        })
      ]);
    };
  }
});
const bNavigationBarMobile_vue_vue_type_style_index_0_scoped_69dd183c_lang = "";
const BNavigationBarMobile = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["__scopeId", "data-v-69dd183c"]]);
const _sfc_main$t = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-navigation-bar",
  props: {
    items: {},
    bottomBarItems: {},
    brandProps: {},
    bottomBarBrandProps: {},
    actionButtonProps: {},
    logoProps: {},
    serviceAreaItems: {}
  },
  setup(__props) {
    const breakpoint = useBreakpoints();
    const smallerThanMd = breakpoint.smaller("md");
    const isMobile = computed(() => isBrowser() ? smallerThanMd.value : false);
    return (_ctx, _cache) => {
      return !isMobile.value ? (openBlock(), createBlock(BNavigationBarDesktop, normalizeProps(mergeProps({ key: 0 }, { ..._ctx.$props, ..._ctx.$attrs })), {
        logo: withCtx(() => [
          renderSlot(_ctx.$slots, "logo")
        ]),
        login: withCtx(() => [
          renderSlot(_ctx.$slots, "login")
        ]),
        "service-area": withCtx(() => [
          renderSlot(_ctx.$slots, "service-area")
        ]),
        _: 3
      }, 16)) : (openBlock(), createBlock(BNavigationBarMobile, normalizeProps(mergeProps({ key: 1 }, { ..._ctx.$props, ..._ctx.$attrs })), {
        logo: withCtx(() => [
          renderSlot(_ctx.$slots, "logo")
        ]),
        login: withCtx(() => [
          renderSlot(_ctx.$slots, "login")
        ]),
        _: 3
      }, 16));
    };
  }
});
function roundDown(number, step) {
  return number % step === 0 ? number : Math.floor(number / step) * step;
}
function roundUp(number, step) {
  return number % step === 0 ? number : Math.ceil(number / step) * step;
}
const _hoisted_1$k = ["inputmode", "aria-invalid", "onKeydown"];
const _hoisted_2$e = { class: "b-number-input__stepper" };
const _hoisted_3$9 = ["aria-label", "disabled"];
const _hoisted_4$5 = ["aria-label", "disabled"];
const _sfc_main$s = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-number-input",
  props: {
    invalid: { type: Boolean },
    readonly: { type: Boolean },
    colorScheme: { default: "black" },
    disabled: { type: Boolean },
    modelValue: {},
    errorMessage: {},
    label: {},
    hint: {},
    max: { default: Number.POSITIVE_INFINITY },
    min: { default: Number.NEGATIVE_INFINITY },
    step: {},
    decimal: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit }) {
    const props = __props;
    const id = generateUniqueId();
    const decimalNumberShape = /^[+-]?\d*\.?\d*([Ee][+-]?)?\d*$/;
    const integerNumberShape = /^[+-]?\d*([Ee]\+?)?\d*$/;
    const inputRef = ref(null);
    __expose({
      input: inputRef
    });
    const inputAttrs = useSafeAttrs(useAttrs());
    watch(
      () => props.modelValue,
      (modelValue) => {
        if (valueAsNumber.value !== modelValue) {
          internalModel.value = formatNumberToString(props.modelValue);
        }
      }
    );
    const internalModel = ref(formatNumberToString(props.modelValue));
    const isPopulated = computed(() => !!internalModel.value);
    const valueAsNumber = computed(() => {
      return Number(internalModel.value.replaceAll(",", ""));
    });
    const hasReachedMax = computed(() => {
      const stepValue = props.step ?? 1;
      return valueAsNumber.value + stepValue > props.max;
    });
    const isIncrementDisabled = computed(() => {
      if (props.disabled) {
        return true;
      }
      return hasReachedMax.value;
    });
    const hasReachedMin = computed(() => {
      const stepValue = props.step ?? 1;
      return valueAsNumber.value - stepValue < props.min;
    });
    const isDecrementDisabled = computed(() => {
      if (props.disabled) {
        return true;
      }
      return hasReachedMin.value;
    });
    const inputmode = computed(
      () => (
        // Some devices numeric/decimal keyboards do not include propert decimal separator or minus sign.
        // We fall back to the text one.
        props.decimal || props.min < 0 ? "text" : "numeric"
      )
    );
    function discardInvalidValues(event) {
      const inputEvent = event;
      const data = inputEvent.data;
      if (!data) {
        return;
      }
      const futureValue = getFutureValue(event.target, data);
      if (!isNumber(futureValue)) {
        return event.preventDefault();
      }
    }
    function getFutureValue(inputElement, newChars) {
      const actualValue = inputElement.value;
      return actualValue.slice(0, Math.max(0, inputElement.selectionStart ?? 0)) + newChars + actualValue.slice(Math.max(0, inputElement.selectionEnd ?? 0));
    }
    function emitUpdate() {
      if (!internalModel.value) {
        return emit("update:modelValue", null);
      }
      if (!Number.isNaN(valueAsNumber.value)) {
        emit("update:modelValue", valueAsNumber.value);
      }
    }
    function restoreValidValue() {
      if (props.modelValue !== valueAsNumber.value) {
        internalModel.value = formatNumberToString(props.modelValue);
      }
    }
    function increment() {
      if (props.readonly || props.disabled) {
        return;
      }
      const step = props.step ?? 1;
      if (valueAsNumber.value < props.min) {
        emit("update:modelValue", roundUp(props.min, step));
      } else {
        const minValue = Math.min((valueAsNumber.value || 0) + step, props.max);
        emit("update:modelValue", roundDown(minValue, step));
      }
    }
    function decrement() {
      if (props.readonly || props.disabled) {
        return;
      }
      const step = props.step ?? 1;
      if (valueAsNumber.value > props.max) {
        emit("update:modelValue", roundDown(props.max, step));
      } else {
        const minValue = Math.max((valueAsNumber.value || 0) - step, props.min);
        emit("update:modelValue", roundUp(minValue, step));
      }
    }
    function formatNumberToString(number) {
      return (number == null ? void 0 : number.toLocaleString("fullwide", { useGrouping: false })) ?? "";
    }
    function isNumber(numberString) {
      return props.decimal ? decimalNumberShape.test(numberString) : integerNumberShape.test(numberString);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(BFormControl, {
        "label-for": unref(id),
        populated: isPopulated.value,
        label: _ctx.label,
        invalid: _ctx.invalid,
        "color-scheme": _ctx.colorScheme,
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        hint: _ctx.hint
      }, {
        control: withCtx(() => [
          withDirectives(createElementVNode("input", mergeProps({
            ref_key: "inputRef",
            ref: inputRef,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => internalModel.value = $event),
            class: "b-number-input",
            inputmode: inputmode.value,
            type: "text",
            "aria-invalid": _ctx.invalid
          }, {
            ...unref(inputAttrs),
            disabled: _ctx.disabled,
            id: unref(id),
            readonly: _ctx.readonly
          }, {
            onBeforeinput: discardInvalidValues,
            onInput: emitUpdate,
            onBlur: restoreValidValue,
            onKeydown: [
              withKeys(withModifiers(increment, ["prevent"]), ["up"]),
              withKeys(withModifiers(decrement, ["prevent"]), ["down"])
            ]
          }), null, 16, _hoisted_1$k), [
            [vModelText, internalModel.value]
          ])
        ]),
        suffix: withCtx(() => [
          createElementVNode("div", _hoisted_2$e, [
            createElementVNode("button", {
              class: normalizeClass(["b-number-input__stepper-action", [
                `b-number-input__stepper-action--${_ctx.colorScheme}`,
                {
                  "b-number-input__stepper-action--has-reached-limit": !_ctx.disabled && hasReachedMax.value
                }
              ]]),
              "aria-label": `Increase by ${_ctx.step ?? 1}`,
              disabled: isIncrementDisabled.value,
              tabindex: "-1",
              onClick: increment
            }, [
              createVNode(unref(ChevronUpIcon), { size: "sm" })
            ], 10, _hoisted_3$9),
            createElementVNode("button", {
              class: normalizeClass(["b-number-input__stepper-action", [
                `b-number-input__stepper-action--${_ctx.colorScheme}`,
                {
                  "b-number-input__stepper-action--has-reached-limit": !_ctx.disabled && hasReachedMin.value
                }
              ]]),
              "aria-label": `Decrease by ${_ctx.step ?? 1}`,
              disabled: isDecrementDisabled.value,
              tabindex: "-1",
              onClick: decrement
            }, [
              createVNode(unref(ChevronDownIcon), { size: "sm" })
            ], 10, _hoisted_4$5)
          ])
        ]),
        error: withCtx(() => [
          _ctx.invalid && _ctx.errorMessage ? (openBlock(), createBlock(unref(BFormError), {
            key: 0,
            "error-message": _ctx.errorMessage,
            "color-scheme": _ctx.colorScheme
          }, null, 8, ["error-message", "color-scheme"])) : createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["label-for", "populated", "label", "invalid", "color-scheme", "disabled", "readonly", "hint"]);
    };
  }
});
const bNumberInput_vue_vue_type_style_index_0_scoped_b44c2387_lang = "";
const bNumberInput = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["__scopeId", "data-v-b44c2387"]]);
const _sfc_main$r = /* @__PURE__ */ defineComponent({
  __name: "b-pagination-control",
  props: {
    as: { default: "button" },
    disabled: { type: Boolean, default: false },
    hideOnMobile: { type: Boolean, default: false }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.as), {
        disabled: _ctx.disabled,
        tabindex: _ctx.disabled ? -1 : 0,
        "aria-hidden": _ctx.disabled,
        class: normalizeClass(["b-pagination-control", {
          "b-pagination-control--disabled": _ctx.disabled,
          "b-pagination-control--hide-on-mobile": _ctx.hideOnMobile
        }])
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        _: 3
      }, 8, ["disabled", "tabindex", "aria-hidden", "class"]);
    };
  }
});
const bPaginationControl_vue_vue_type_style_index_0_scoped_b282db57_lang = "";
const BPaginationControl = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["__scopeId", "data-v-b282db57"]]);
const _sfc_main$q = /* @__PURE__ */ defineComponent({
  __name: "b-pagination-link",
  props: {
    isActive: { type: Boolean },
    page: {},
    as: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.as), {
        class: normalizeClass(["b-pagination-link", {
          "b-pagination-link--active": _ctx.isActive
        }])
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.page), 1)
        ]),
        _: 1
      }, 8, ["class"]);
    };
  }
});
const bPaginationLink_vue_vue_type_style_index_0_scoped_6e7a2a98_lang = "";
const BPaginationLink = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["__scopeId", "data-v-6e7a2a98"]]);
const _hoisted_1$j = { class: "b-pagination-input" };
const _hoisted_2$d = ["aria-label", "disabled"];
const _hoisted_3$8 = { class: "b-pagination-input__counter" };
const _sfc_main$p = /* @__PURE__ */ defineComponent({
  __name: "b-pagination-number-input",
  props: {
    modelValue: {},
    pagesCount: {},
    delay: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const internalModel = ref(props.modelValue.toString());
    watch(
      () => props.modelValue,
      (newValue) => {
        internalModel.value = newValue.toString();
      }
    );
    const hasOnlyOnePage = computed(() => props.pagesCount === 1);
    const onInput = (event) => {
      const pageNum = Number.parseInt(event.target.value);
      if (Number.isNaN(pageNum)) {
        return;
      }
      if (pageNum === props.modelValue) {
        return;
      }
      if (pageNum === 0) {
        internalModel.value = "1";
        emit("update:modelValue", 1);
        return;
      }
      if (pageNum > props.pagesCount) {
        internalModel.value = props.pagesCount.toString();
        emit("update:modelValue", props.pagesCount);
        return;
      }
      emit("update:modelValue", pageNum);
    };
    const debouncedOnInput = useDebounceFn(
      onInput,
      props.delay
    );
    const onBlur = () => {
      const currentValue = Number.parseInt(internalModel.value);
      if (Number.isNaN(currentValue)) {
        internalModel.value = props.modelValue.toString();
        return;
      }
    };
    function discardInvalidValues(event) {
      const inputEvent = event;
      const data = inputEvent.data;
      if (!data) {
        return;
      }
      if (!isDigitOnly(data)) {
        return event.preventDefault();
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", _hoisted_1$j, [
        withDirectives(createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => internalModel.value = $event),
          class: normalizeClass(["b-pagination-input__control", {
            "b-pagination-input__control--disabled": hasOnlyOnePage.value
          }]),
          type: "text",
          inputmode: "numeric",
          "aria-label": `Goto page ${_ctx.modelValue} of ${_ctx.pagesCount}`,
          disabled: hasOnlyOnePage.value,
          onBeforeinput: discardInvalidValues,
          onInput: _cache[1] || (_cache[1] = //@ts-ignore
          (...args) => unref(debouncedOnInput) && unref(debouncedOnInput)(...args)),
          onBlur
        }, null, 42, _hoisted_2$d), [
          [vModelText, internalModel.value]
        ]),
        createElementVNode("span", _hoisted_3$8, "of " + toDisplayString(_ctx.pagesCount), 1)
      ]);
    };
  }
});
const bPaginationNumberInput_vue_vue_type_style_index_0_scoped_cb71e9e8_lang = "";
const BPaginationNumberInput = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["__scopeId", "data-v-cb71e9e8"]]);
const _hoisted_1$i = { class: "b-pagination-per-page-select" };
const _hoisted_2$c = ["for"];
const _hoisted_3$7 = ["id", "value"];
const _hoisted_4$4 = ["value"];
const _sfc_main$o = /* @__PURE__ */ defineComponent({
  __name: "b-pagination-per-page-select",
  props: {
    itemsPerPageOptions: {},
    itemsPerPage: {}
  },
  emits: ["update:items-per-page"],
  setup(__props, { emit }) {
    const controlId = generateUniqueId();
    const change = (event) => {
      const selected = Number.parseInt(event.target.value);
      emit("update:items-per-page", selected);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$i, [
        createElementVNode("label", {
          for: unref(controlId),
          class: "b-pagination-per-page-select__label"
        }, " Items per page ", 8, _hoisted_2$c),
        createElementVNode("select", {
          id: unref(controlId),
          value: _ctx.itemsPerPage,
          class: "b-pagination-per-page-select__control",
          onChange: _cache[0] || (_cache[0] = ($event) => change($event))
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.itemsPerPageOptions, (option) => {
            return openBlock(), createElementBlock("option", {
              key: option,
              value: option
            }, toDisplayString(option), 9, _hoisted_4$4);
          }), 128))
        ], 40, _hoisted_3$7),
        createVNode(unref(ChevronDownIcon), {
          size: "md",
          class: "b-pagination-per-page-select__icon"
        })
      ]);
    };
  }
});
const bPaginationPerPageSelect_vue_vue_type_style_index_0_scoped_b7e3c914_lang = "";
const BPaginationPerPageSelect = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["__scopeId", "data-v-b7e3c914"]]);
const _hoisted_1$h = { class: "b-pagination-summary" };
const _hoisted_2$b = { class: "b-pagination-summary__summary" };
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  __name: "b-pagination-summary",
  props: {
    itemsCountName: {},
    itemsCount: {},
    rangeOfItems: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$h, [
        renderSlot(_ctx.$slots, "select", {}, void 0, true),
        createElementVNode("div", _hoisted_2$b, toDisplayString(_ctx.rangeOfItems) + " of " + toDisplayString(_ctx.itemsCount) + " " + toDisplayString(_ctx.itemsCountName), 1)
      ]);
    };
  }
});
const bPaginationSummary_vue_vue_type_style_index_0_scoped_206e3070_lang = "";
const BPaginationSummary = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["__scopeId", "data-v-206e3070"]]);
const usePagination = ({
  page,
  itemsPerPage,
  itemsCount,
  itemsPerPageOptions,
  onPageUpdate,
  onItemsPerPageUpdate
}) => {
  const pageModel = computed({
    get() {
      return page.value;
    },
    set(newPage) {
      if (newPage !== page.value) {
        onPageUpdate(newPage);
      }
    }
  });
  const itemsPerPageModel = computed({
    get() {
      return itemsPerPage.value;
    },
    set(newItemsPerPage) {
      onItemsPerPageUpdate(newItemsPerPage);
    }
  });
  watch(
    () => itemsPerPageModel.value,
    () => {
      goToFirstPage();
    }
  );
  watchEffect(() => {
    if (Array.isArray(itemsPerPageOptions.value) && !itemsPerPageOptions.value.includes(itemsPerPageModel.value)) {
      console.warn(
        "You are using an invalid itemsPerPage value. Please use one of the following values:",
        itemsPerPageOptions.value
      );
    }
  });
  const isFirstPageButtonDisabled = computed(
    () => pageModel.value <= 1
  );
  const isLastPageButtonDisabled = computed(
    () => pageModel.value >= pagesCount.value
  );
  const pagesCount = computed(
    () => Math.ceil(itemsCount.value / itemsPerPageModel.value)
  );
  const perPageItemsRange = computed(() => {
    const _itemsPerPage = itemsPerPageModel.value;
    const _page = pageModel.value;
    if (Number.isNaN(_itemsPerPage) || Number.isNaN(_page)) {
      return null;
    }
    const firstItem = _itemsPerPage * (_page - 1) + 1;
    const lastItem = Math.min(_itemsPerPage * _page, itemsCount.value);
    return firstItem === lastItem ? `${lastItem}` : `${firstItem}-${lastItem}`;
  });
  const changePage = (newPage) => {
    pageModel.value = newPage;
  };
  const goToFirstPage = () => {
    changePage(1);
  };
  const goToLastPage = () => {
    if (pageModel.value < pagesCount.value) {
      changePage(pagesCount.value);
    }
  };
  const goToPreviousPage = () => {
    if (pageModel.value > 1) {
      changePage(pageModel.value - 1);
    }
  };
  const goToNextPage = () => {
    if (pageModel.value < pagesCount.value) {
      changePage(pageModel.value + 1);
    }
  };
  return {
    pageModel,
    itemsPerPageModel,
    changePage,
    goToFirstPage,
    goToLastPage,
    goToPreviousPage,
    goToNextPage,
    isFirstPageButtonDisabled,
    isLastPageButtonDisabled,
    perPageItemsRange,
    pagesCount
  };
};
const _hoisted_1$g = { class: "b-pagination-summary__text" };
const _hoisted_2$a = ["aria-label"];
const _hoisted_3$6 = { class: "b-pagination__list" };
const _hoisted_4$3 = {
  key: 0,
  class: "b-pagination__list-item b-pagination__first-page b-pagination__list-item-control"
};
const _hoisted_5$2 = { class: "b-pagination__list-item b-pagination__previous-page b-pagination__list-item-control" };
const _hoisted_6$2 = {
  key: 0,
  class: "b-pagination__list-item-control-label"
};
const _hoisted_7$1 = { class: "b-pagination__list-item b-pagination__next-page b-pagination__list-item-control" };
const _hoisted_8 = {
  key: 0,
  class: "b-pagination__list-item-control-label"
};
const _hoisted_9 = {
  key: 3,
  class: "b-pagination__list-item b-pagination__last-page b-pagination__list-item-control"
};
const _hoisted_10 = { class: "b-pagination-summary__text" };
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-pagination",
  props: {
    display: { default: "block" },
    page: {},
    itemsCount: {},
    itemsPerPage: {},
    itemsPerPageOptions: { default: null },
    itemsCountName: { default: "items" },
    navAriaLabel: { default: "Pagination Navigation" },
    nextPageAriaLabel: { default: "Go to the next page" },
    previousPageAriaLabel: { default: "Go to the previous page" },
    firstPageAriaLabel: { default: "Go to the first page" },
    lastPageAriaLabel: { default: "Go to the last page" },
    pageLinkAriaLabel: { type: Function, default: (pageNumber) => `Go to page ${pageNumber}` },
    controlsAs: { default: "button" },
    genHref: {},
    additionalLinkProps: {},
    inputDebounceDelay: { default: 1e3 }
  },
  emits: ["update:page", "update:items-per-page"],
  setup(__props, { emit }) {
    const props = __props;
    const paginationAttrs = useSafeAttrs(useAttrs());
    const breakpoints = useBreakpoints();
    const maxViewportSupportedForLine = useMediaQuery("(max-width: 460px)");
    const shouldForceBlockVariant = computed(() => {
      return maxViewportSupportedForLine.value;
    });
    const {
      changePage,
      goToFirstPage,
      goToLastPage,
      goToNextPage,
      goToPreviousPage,
      isFirstPageButtonDisabled,
      isLastPageButtonDisabled,
      pageModel,
      pagesCount,
      itemsPerPageModel,
      perPageItemsRange
    } = usePagination({
      page: toRef(props, "page"),
      itemsCount: toRef(props, "itemsCount"),
      itemsPerPage: toRef(props, "itemsPerPage"),
      itemsPerPageOptions: toRef(props, "itemsPerPageOptions"),
      onItemsPerPageUpdate: (newItemsPerPageValue) => {
        emit("update:items-per-page", newItemsPerPageValue);
      },
      onPageUpdate: (newPageValue) => {
        emit("update:page", newPageValue);
      }
    });
    const isSmallerThanMd = breakpoints.smaller("md");
    const display = computed(() => {
      if (shouldForceBlockVariant.value) {
        return "block";
      }
      return props.display;
    });
    const showItemsPerPageSelect = computed(() => {
      if (display.value === "line" && isSmallerThanMd.value) {
        return false;
      }
      return Array.isArray(props.itemsPerPageOptions);
    });
    const showControlTextLabel = breakpoints.greaterOrEqual("md");
    const hideFirstAndLastPageControls = computed(() => {
      return isSmallerThanMd.value && variant.value === "up-to-5";
    });
    const variant = computed(() => {
      return pagesCount.value >= 6 ? "over-5" : "up-to-5";
    });
    const genLinkProps = (page) => {
      var _a;
      const href = (_a = props.genHref) == null ? void 0 : _a.call(props, page);
      if (props.controlsAs === "a") {
        return {
          ...props.additionalLinkProps,
          "href": href,
          "aria-current": page === pageModel.value ? "page" : void 0
        };
      } else if (props.controlsAs === "router-link" || typeof props.controlsAs === "object") {
        return {
          ...props.additionalLinkProps,
          "to": href,
          "aria-current": page === pageModel.value ? "page" : void 0
        };
      }
      return {};
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({
        class: ["b-pagination", `b-pagination--${display.value}`]
      }, unref(paginationAttrs)), [
        unref(perPageItemsRange) && display.value === "line" ? (openBlock(), createBlock(BPaginationSummary, {
          key: 0,
          "items-count": _ctx.itemsCount,
          "items-count-name": _ctx.itemsCountName,
          "range-of-items": unref(perPageItemsRange)
        }, createSlots({ _: 2 }, [
          showItemsPerPageSelect.value ? {
            name: "select",
            fn: withCtx(() => [
              createElementVNode("div", _hoisted_1$g, toDisplayString(unref(capitalizeFirstLetter)(_ctx.itemsCountName)) + " per page ", 1),
              createVNode(BPaginationPerPageSelect, {
                "items-per-page": unref(itemsPerPageModel),
                "onUpdate:itemsPerPage": _cache[0] || (_cache[0] = ($event) => isRef(itemsPerPageModel) ? itemsPerPageModel.value = $event : null),
                "items-per-page-options": _ctx.itemsPerPageOptions
              }, null, 8, ["items-per-page", "items-per-page-options"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items-count", "items-count-name", "range-of-items"])) : createCommentVNode("", true),
        createElementVNode("nav", {
          role: "navigation",
          "aria-label": _ctx.navAriaLabel
        }, [
          createElementVNode("ul", _hoisted_3$6, [
            !hideFirstAndLastPageControls.value ? (openBlock(), createElementBlock("li", _hoisted_4$3, [
              createVNode(BPaginationControl, mergeProps(genLinkProps(1), {
                disabled: unref(isFirstPageButtonDisabled),
                "aria-label": _ctx.firstPageAriaLabel,
                as: _ctx.controlsAs,
                onClick: unref(goToFirstPage)
              }), {
                default: withCtx(() => [
                  createVNode(unref(FirstPageIcon), { size: "md" })
                ]),
                _: 1
              }, 16, ["disabled", "aria-label", "as", "onClick"])
            ])) : createCommentVNode("", true),
            createElementVNode("li", _hoisted_5$2, [
              createVNode(BPaginationControl, mergeProps(genLinkProps(unref(pageModel) > 1 ? unref(pageModel) - 1 : 1), {
                disabled: unref(isFirstPageButtonDisabled),
                "aria-label": _ctx.previousPageAriaLabel,
                as: _ctx.controlsAs,
                onClick: unref(goToPreviousPage)
              }), {
                default: withCtx(() => [
                  createVNode(unref(ChevronLeftIcon), { size: "md" }),
                  unref(showControlTextLabel) ? (openBlock(), createElementBlock("span", _hoisted_6$2, "Previous")) : createCommentVNode("", true)
                ]),
                _: 1
              }, 16, ["disabled", "aria-label", "as", "onClick"])
            ]),
            variant.value === "up-to-5" ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(unref(pagesCount), (pageNumber, idx) => {
              return openBlock(), createElementBlock("li", {
                key: pageNumber,
                class: normalizeClass(["b-pagination__list-item b-pagination__list-item-number", {
                  "b-pagination__list-item-number--first": idx === 0,
                  "b-pagination__list-item-number--last": idx === unref(pagesCount) - 1
                }])
              }, [
                createVNode(BPaginationLink, mergeProps(genLinkProps(pageNumber), {
                  "aria-label": _ctx.pageLinkAriaLabel(pageNumber),
                  "aria-current": pageNumber === unref(pageModel) ? "page" : void 0,
                  "is-active": pageNumber === unref(pageModel),
                  page: pageNumber,
                  as: _ctx.controlsAs,
                  onClick: ($event) => unref(changePage)(pageNumber)
                }), null, 16, ["aria-label", "aria-current", "is-active", "page", "as", "onClick"])
              ], 2);
            }), 128)) : (openBlock(), createBlock(BPaginationNumberInput, {
              key: 2,
              modelValue: unref(pageModel),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => isRef(pageModel) ? pageModel.value = $event : null),
              "pages-count": unref(pagesCount),
              delay: _ctx.inputDebounceDelay
            }, null, 8, ["modelValue", "pages-count", "delay"])),
            createElementVNode("li", _hoisted_7$1, [
              createVNode(BPaginationControl, mergeProps(
                genLinkProps(unref(pageModel) < unref(pagesCount) ? unref(pageModel) + 1 : unref(pagesCount)),
                {
                  as: _ctx.controlsAs,
                  "aria-label": _ctx.nextPageAriaLabel,
                  disabled: unref(isLastPageButtonDisabled),
                  onClick: unref(goToNextPage)
                }
              ), {
                default: withCtx(() => [
                  unref(showControlTextLabel) ? (openBlock(), createElementBlock("span", _hoisted_8, "Next")) : createCommentVNode("", true),
                  createVNode(unref(ChevronRightIcon), { size: "md" })
                ]),
                _: 1
              }, 16, ["as", "aria-label", "disabled", "onClick"])
            ]),
            !hideFirstAndLastPageControls.value ? (openBlock(), createElementBlock("li", _hoisted_9, [
              createVNode(BPaginationControl, mergeProps(genLinkProps(unref(pagesCount)), {
                as: _ctx.controlsAs,
                "aria-label": _ctx.lastPageAriaLabel,
                disabled: unref(isLastPageButtonDisabled),
                onClick: unref(goToLastPage)
              }), {
                default: withCtx(() => [
                  createVNode(unref(LastPageIcon), { size: "md" })
                ]),
                _: 1
              }, 16, ["as", "aria-label", "disabled", "onClick"])
            ])) : createCommentVNode("", true)
          ])
        ], 8, _hoisted_2$a),
        unref(perPageItemsRange) && display.value === "block" ? (openBlock(), createBlock(BPaginationSummary, {
          key: 1,
          "items-count": _ctx.itemsCount,
          "items-count-name": _ctx.itemsCountName,
          "range-of-items": unref(perPageItemsRange)
        }, createSlots({ _: 2 }, [
          showItemsPerPageSelect.value ? {
            name: "select",
            fn: withCtx(() => [
              createElementVNode("div", _hoisted_10, toDisplayString(unref(capitalizeFirstLetter)(_ctx.itemsCountName)) + " per page ", 1),
              createVNode(BPaginationPerPageSelect, {
                "items-per-page": unref(itemsPerPageModel),
                "onUpdate:itemsPerPage": _cache[2] || (_cache[2] = ($event) => isRef(itemsPerPageModel) ? itemsPerPageModel.value = $event : null),
                class: "b-pagination__items-per-page-select",
                "items-per-page-options": _ctx.itemsPerPageOptions
              }, null, 8, ["items-per-page", "items-per-page-options"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items-count", "items-count-name", "range-of-items"])) : createCommentVNode("", true)
      ], 16);
    };
  }
});
const bPagination_vue_vue_type_style_index_0_scoped_dc2bc06a_lang = "";
const bPagination = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["__scopeId", "data-v-dc2bc06a"]]);
function getFocusableElements(element = document) {
  return [
    ...element.querySelectorAll(
      'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
    )
  ].filter(
    (el) => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden") && window.getComputedStyle(el).display !== "none"
  );
}
const POPOVER_LABELLEDBY_KEY = Symbol(
  "popoverLabelledbyKey"
);
function useFloatingPopover({
  placement,
  anchorRef,
  popoverRef,
  arrowRef,
  anchorPopoverGap,
  borderArrowDistance,
  screenBorderPadding
}) {
  const middleware = ref([
    // to use autoPlacement or flip behaviour depending on the placement
    placement.value === "auto" ? autoPlacement() : flip({ fallbackAxisSideDirection: "start" }),
    offset({
      // the gap between the Popover and the Anchor
      mainAxis: anchorPopoverGap
    }),
    shift({
      // the minimun distance from the border of the screen to the popover
      padding: screenBorderPadding,
      limiter: limitShift({
        // Limiting the shift using the anchor axis size and the arrow distance from the border
        offset: (middlewareState) => {
          const anchorAxisSize = getAnchorAxisSize(middlewareState);
          return anchorAxisSize / 2 + borderArrowDistance;
        }
      })
    }),
    arrow({
      element: arrowRef
    })
  ]);
  const floatingPlacement = computed(
    () => placement.value === "auto" ? void 0 : placement.value
  );
  const {
    floatingStyles: popoverStyles,
    placement: realPlacement,
    // in the case of `auto` we need the real placement applied.
    middlewareData
  } = useFloating(anchorRef, popoverRef, {
    placement: floatingPlacement,
    middleware,
    whileElementsMounted: autoUpdate
  });
  const arrowStyles = computed(() => {
    const { x, y } = middlewareData.value.arrow ?? {};
    const isLeftPlacement = realPlacement.value.includes("left");
    const isTopPlacement = realPlacement.value.includes("top");
    return {
      left: x ? `${x}px` : isLeftPlacement ? "100%" : "0",
      top: y ? `${y}px` : isTopPlacement ? "100%" : "0"
    };
  });
  return {
    arrowStyles,
    popoverStyles
  };
}
function getAnchorAxisSize({
  rects,
  placement: realPlacement
}) {
  return realPlacement.includes("left") || realPlacement.includes("right") ? rects.reference.height : rects.reference.width;
}
const _hoisted_1$f = ["aria-label", "aria-labelledby", "onKeydown"];
const _hoisted_2$9 = { class: "b-popover__close" };
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-popover",
  props: {
    modelValue: { type: Boolean },
    anchorRef: {},
    placement: { default: "auto" },
    ariaLabel: {}
  },
  emits: ["update:modelValue", "close"],
  setup(__props, { emit }) {
    const props = __props;
    const popoverAttrs = useSafeAttrs(useAttrs());
    const popoverRef = ref(null);
    const arrowRef = ref(null);
    const ariaLabeledBy = ref(void 0);
    const { arrowStyles, popoverStyles } = useFloatingPopover({
      placement: computed(() => props.placement),
      anchorRef: computed(() => props.anchorRef),
      popoverRef,
      arrowRef,
      anchorPopoverGap: 10,
      borderArrowDistance: 20,
      screenBorderPadding: 10
    });
    onClickOutside(popoverRef, () => setTimeout(emitClose));
    watch(
      () => props.modelValue,
      async (isOpen) => {
        if (isOpen) {
          await nextTick();
          const [firstElement] = getFocusableElements(
            popoverRef.value ?? void 0
          );
          firstElement == null ? void 0 : firstElement.focus({ preventScroll: true });
        }
      }
    );
    function emitClose() {
      emit("update:modelValue", false);
      emit("close");
    }
    provide(POPOVER_LABELLEDBY_KEY, ariaLabeledBy);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Teleport, { to: "body" }, [
        createVNode(Transition, {
          appear: "",
          name: "b-popover-fade-"
        }, {
          default: withCtx(() => [
            _ctx.modelValue ? (openBlock(), createElementBlock("div", mergeProps({ key: 0 }, unref(popoverAttrs), {
              ref_key: "popoverRef",
              ref: popoverRef,
              class: "b-popover",
              role: "dialog",
              "aria-modal": "true",
              "aria-label": !!ariaLabeledBy.value ? void 0 : _ctx.ariaLabel,
              "aria-labelledby": ariaLabeledBy.value,
              style: unref(popoverStyles),
              onKeydown: withKeys(emitClose, ["escape"])
            }), [
              renderSlot(_ctx.$slots, "content", {}, void 0, true),
              createElementVNode("div", {
                ref_key: "arrowRef",
                ref: arrowRef,
                class: "b-popover__arrow",
                style: normalizeStyle(unref(arrowStyles))
              }, null, 4),
              createElementVNode("div", _hoisted_2$9, [
                createVNode(unref(BIconButton), {
                  size: "xs",
                  label: "close",
                  onClick: emitClose
                }, {
                  icon: withCtx((iconProps) => [
                    createVNode(unref(CloseIcon), normalizeProps(guardReactiveProps(iconProps)), null, 16)
                  ]),
                  _: 1
                })
              ])
            ], 16, _hoisted_1$f)) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ]);
    };
  }
});
const bPopover_vue_vue_type_style_index_0_scoped_841a47dd_lang = "";
const bPopover = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["__scopeId", "data-v-841a47dd"]]);
const bPopoverDescription_vue_vue_type_style_index_0_scoped_54445c79_lang = "";
const _sfc_main$k = {};
const _hoisted_1$e = { class: "b-popover-description" };
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("p", _hoisted_1$e, [
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ]);
}
const bPopoverDescription = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render], ["__scopeId", "data-v-54445c79"]]);
const _hoisted_1$d = ["id"];
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "b-popover-title",
  setup(__props) {
    const id = generateUniqueId();
    const labelledBy = inject(POPOVER_LABELLEDBY_KEY);
    if (labelledBy) {
      labelledBy.value = id;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("h1", {
        id: unref(id),
        class: "b-popover-title"
      }, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 8, _hoisted_1$d);
    };
  }
});
const bPopoverTitle_vue_vue_type_style_index_0_scoped_153cfc58_lang = "";
const bPopoverTitle = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["__scopeId", "data-v-153cfc58"]]);
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-progress-indicator",
  props: {
    percentage: {},
    colorScheme: { default: "blue" }
  },
  setup(__props) {
    const props = __props;
    const progressBarWidth = computed(() => ({
      width: `${props.percentage}%`
    }));
    const progressBarAttr = useSafeAttrs(useAttrs());
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({ class: "b-progress-bar" }, unref(progressBarAttr)), [
        createElementVNode("div", {
          class: normalizeClass(["b-progress-bar__track", [`b-progress-bar__track--${_ctx.colorScheme}`]]),
          style: normalizeStyle(progressBarWidth.value)
        }, null, 6)
      ], 16);
    };
  }
});
const bProgressIndicator_vue_vue_type_style_index_0_scoped_750f6839_lang = "";
const bProgressIndicator = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["__scopeId", "data-v-750f6839"]]);
const RADIO_GROUP_STATE_KEY = Symbol("radioGroupProps");
const _hoisted_1$c = ["for"];
const _hoisted_2$8 = ["id", "disabled", "aria-invalid", "aria-checked", "aria-readonly", "value", "name"];
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-radio",
  props: {
    value: { type: [String, Number, Boolean] },
    label: {},
    disabled: { type: Boolean, default: void 0 },
    name: {},
    readonly: { type: Boolean, default: void 0 }
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    const radioRef = ref(null);
    __expose({
      radio: radioRef
    });
    const safeAttrs = useSafeAttrs(useAttrs());
    const radioGroupState = inject(RADIO_GROUP_STATE_KEY);
    const computedReadOnly = computed(
      () => (radioGroupState == null ? void 0 : radioGroupState.value.readonly) ?? props.readonly
    );
    const computedName = computed(() => props.name || (radioGroupState == null ? void 0 : radioGroupState.value.name));
    const computedColorScheme = computed(() => radioGroupState == null ? void 0 : radioGroupState.value.colorScheme);
    const computedInvalid = computed(
      () => !computedDisabled.value && !!(radioGroupState == null ? void 0 : radioGroupState.value.invalid)
    );
    const computedDisabled = computed(
      () => (radioGroupState == null ? void 0 : radioGroupState.value.disabled) ?? props.disabled
    );
    const isChecked = computed(() => (radioGroupState == null ? void 0 : radioGroupState.value.value) === props.value);
    const proxiedModel = computed({
      get() {
        return radioGroupState == null ? void 0 : radioGroupState.value.value;
      },
      set(value) {
        radioGroupState == null ? void 0 : radioGroupState.value.update(value);
      }
    });
    const radioId = generateUniqueId();
    function preventDisabledOrReadonlyChange(event) {
      if (computedReadOnly.value || computedDisabled.value) {
        event.preventDefault();
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("label", {
        class: normalizeClass(["b-radio", {
          "b-radio--disabled": computedDisabled.value,
          "b-radio--readonly": computedReadOnly.value
        }]),
        for: unref(radioId)
      }, [
        withDirectives(createElementVNode("input", mergeProps(unref(safeAttrs), {
          id: unref(radioId),
          ref_key: "radioRef",
          ref: radioRef,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => proxiedModel.value = $event),
          type: "radio",
          disabled: computedDisabled.value,
          "aria-invalid": computedInvalid.value,
          "aria-checked": isChecked.value,
          "aria-readonly": computedReadOnly.value,
          value: _ctx.value,
          name: computedName.value,
          class: ["b-radio__input", `b-radio__input--${computedColorScheme.value}`],
          onClick: preventDisabledOrReadonlyChange
        }), null, 16, _hoisted_2$8), [
          [vModelRadio, proxiedModel.value]
        ]),
        createElementVNode("div", {
          class: normalizeClass(["b-radio__button", [
            `b-radio__button--${computedColorScheme.value}`,
            {
              "b-radio__button--disabled": computedDisabled.value,
              "b-radio__button--readonly": computedReadOnly.value,
              "b-radio__button--checked": isChecked.value,
              "b-radio__button--invalid": computedInvalid.value
            }
          ]])
        }, null, 2),
        createElementVNode("div", {
          class: normalizeClass(["b-radio__label", [
            `b-radio__label--${computedColorScheme.value}`,
            {
              "b-radio__label--disabled": computedDisabled.value,
              "b-radio__label--readonly": computedReadOnly.value,
              "b-radio__label--checked": isChecked.value,
              "b-radio__label--invalid": computedInvalid.value
            }
          ]])
        }, [
          renderSlot(_ctx.$slots, "custom-label", {}, () => [
            createTextVNode(toDisplayString(_ctx.label), 1)
          ], true)
        ], 2)
      ], 10, _hoisted_1$c);
    };
  }
});
const bRadio_vue_vue_type_style_index_0_scoped_6d5ba88b_lang = "";
const bRadio = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["__scopeId", "data-v-6d5ba88b"]]);
const _hoisted_1$b = { class: "b-radio-group__wrapper" };
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-radio-group",
  props: {
    colorScheme: { default: "black" },
    modelValue: { type: [Boolean, String, Number] },
    disabled: { type: Boolean, default: void 0 },
    name: { default: void 0 },
    invalid: { type: Boolean },
    errorMessage: { default: null },
    readonly: { type: Boolean, default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const safeAttrs = useSafeAttrs(useAttrs());
    const updateValue = (value) => {
      emit("update:modelValue", value);
    };
    const radioGroupState = computed(() => ({
      colorScheme: props.colorScheme,
      disabled: props.disabled,
      invalid: props.invalid,
      readonly: props.readonly,
      value: props.modelValue,
      name: props.name,
      update: updateValue
    }));
    const showErrorMessage = computed(
      () => props.invalid && !props.disabled && !props.readonly
    );
    provide(RADIO_GROUP_STATE_KEY, radioGroupState);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({ class: "b-radio-group" }, { ...unref(safeAttrs), disabled: _ctx.disabled || _ctx.readonly, name: _ctx.name }), [
        createElementVNode("div", _hoisted_1$b, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        showErrorMessage.value ? (openBlock(), createBlock(unref(BFormError), {
          key: 0,
          class: "b-radio-group__error",
          "color-scheme": _ctx.colorScheme,
          "error-message": _ctx.errorMessage
        }, null, 8, ["color-scheme", "error-message"])) : createCommentVNode("", true)
      ], 16);
    };
  }
});
const bRadioGroup_vue_vue_type_style_index_0_scoped_df453f17_lang = "";
const bRadioGroup = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["__scopeId", "data-v-df453f17"]]);
const _hoisted_1$a = ["aria-pressed", "aria-label", "onClick"];
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-segment",
  props: {
    items: {},
    activeIndex: {},
    size: { default: "lg" },
    width: { default: "full" },
    colorScheme: { default: "black" }
  },
  emits: ["update:activeIndex"],
  setup(__props, { emit }) {
    const props = __props;
    const segmentAttrs = useSafeAttrs(useAttrs());
    const { smallerOrEqual } = useBreakpoints();
    const isMobile = smallerOrEqual("sm");
    const computedIsMobile = computed(() => isBrowser() ? isMobile.value : false);
    const internalactiveIndex = ref(0);
    const slidingPanelRef = ref();
    const segmentSizeToIconSize = {
      lg: "md",
      xl: "lg"
    };
    const iconSize = computed(() => segmentSizeToIconSize[props.size]);
    const computedWidth = computed(
      () => computedIsMobile.value ? props.width : "content"
    );
    watch(
      () => props.activeIndex,
      (index) => {
        if (index !== void 0) {
          internalactiveIndex.value = index;
        }
      },
      { immediate: true }
    );
    watchEffect(() => {
      if (props.items.length > 5) {
        console.warn(
          `Only 5 segment items are allowed. Received ${props.items.length}`
        );
      }
    });
    function handleItemClick(index) {
      if (props.activeIndex === void 0) {
        internalactiveIndex.value = index;
      }
      emit("update:activeIndex", index);
    }
    function scrollButtonIntoView(event) {
      var _a;
      (_a = slidingPanelRef.value) == null ? void 0 : _a.scrollElementIntoView(event.target);
    }
    const hasIcons = computed(
      () => props.items.every((item) => !!item.iconComponent)
    );
    const disableScroll = computed(() => !computedIsMobile.value && hasIcons.value);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({
        class: ["b-segment", [`b-segment--${computedWidth.value}`, `b-segment--${_ctx.size}`]]
      }, unref(segmentAttrs)), [
        createVNode(unref(BSlidingPanel), {
          ref_key: "slidingPanelRef",
          ref: slidingPanelRef,
          "disable-scroll": disableScroll.value
        }, {
          "button-left": withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(["b-segment__scroll-button b-segment__scroll-button--left", [`b-segment__scroll-button--${_ctx.size}`]])
            }, [
              createVNode(unref(ChevronLeftIcon))
            ], 2)
          ]),
          default: withCtx(() => [
            createElementVNode("ul", {
              class: normalizeClass(["b-segment__list", [`b-segment__list--${computedWidth.value}`]])
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, ({ label, iconComponent, ...extraAttrs }, index) => {
                return openBlock(), createElementBlock("li", {
                  key: index,
                  class: "b-segment__item"
                }, [
                  createVNode(unref(BTooltip), { placement: "top" }, {
                    trigger: withCtx((tooltipScope) => [
                      createElementVNode("button", mergeProps({
                        class: ["b-segment__button", [
                          `b-segment__button--${_ctx.colorScheme}`,
                          `b-segment__button--${_ctx.size}`,
                          {
                            "b-segment__button--active": index === internalactiveIndex.value,
                            "b-segment__button--text": !iconComponent
                          }
                        ]]
                      }, { ...extraAttrs, ...disableScroll.value && tooltipScope }, {
                        "aria-pressed": index === internalactiveIndex.value,
                        "aria-label": label,
                        onFocus: scrollButtonIntoView,
                        onClick: ($event) => handleItemClick(index)
                      }), [
                        iconComponent ? (openBlock(), createBlock(resolveDynamicComponent(iconComponent), {
                          key: 0,
                          size: iconSize.value
                        }, null, 8, ["size"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                          createTextVNode(toDisplayString(label), 1)
                        ], 64))
                      ], 16, _hoisted_1$a)
                    ]),
                    content: withCtx(() => [
                      createTextVNode(toDisplayString(label), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]);
              }), 128))
            ], 2)
          ]),
          "button-right": withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(["b-segment__scroll-button b-segment__scroll-button--right", [`b-segment__scroll-button--${_ctx.size}`]])
            }, [
              createVNode(unref(ChevronRightIcon))
            ], 2)
          ]),
          _: 1
        }, 8, ["disable-scroll"])
      ], 16);
    };
  }
});
const bSegment_vue_vue_type_style_index_0_scoped_b8eb55db_lang = "";
const bSegment = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["__scopeId", "data-v-b8eb55db"]]);
const _hoisted_1$9 = ["onKeydown"];
const _hoisted_2$7 = ["id", "aria-readonly", "aria-controls", "aria-expanded", "aria-activedescendant", "tabindex", "onKeydown"];
const _hoisted_3$5 = { class: "b-select__chevron-icon" };
const _hoisted_4$2 = { class: "b-listbox__empty-content" };
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "b-select",
  props: {
    colorScheme: { default: "black" },
    options: {},
    modelValue: {},
    label: {},
    invalid: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    errorMessage: { default: void 0 },
    hint: { default: void 0 },
    variant: { default: "single" },
    emptyMessage: { default: "No options available" }
  },
  emits: ["update:modelValue", "change"],
  setup(__props, { expose: __expose, emit: emits }) {
    const props = __props;
    const selectRef = ref(null);
    const triggerRef = ref(null);
    const listboxRef = ref(null);
    const formControlRef = ref(null);
    __expose({
      select: selectRef,
      trigger: triggerRef
    });
    const formControlDivRef = computed(
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
      () => {
        var _a;
        return ((_a = formControlRef.value) == null ? void 0 : _a.formControlRef) ?? null;
      }
    );
    const isExpanded = ref(false);
    const internalModel = ref(props.modelValue);
    const { listboxId, triggerId } = createListboxIds();
    const { floatingStyles } = useListboxFloating({
      listboxRef,
      referenceRef: formControlDivRef
    });
    const proxiedModel = computed({
      get: () => internalModel.value,
      set: (value) => {
        internalModel.value = value;
        emits("update:modelValue", value);
        emits("change", value);
      }
    });
    const isPopulated = computed(
      () => isExpanded.value || proxiedModel.value.length > 0
    );
    const displaySelection = computed(() => {
      var _a;
      if (props.variant === "multiple" && proxiedModel.value.length === 0) {
        return "";
      }
      if (props.variant === "multiple" && proxiedModel.value.length > 0) {
        return `${proxiedModel.value.length} selected`;
      }
      if (props.variant !== "multiple" && typeof proxiedModel.value === "string" && proxiedModel.value.length > 0) {
        return ((_a = props.options.find((option) => option.value === internalModel.value)) == null ? void 0 : _a.label) ?? "";
      }
      return "";
    });
    const {
      activeDescendantId,
      getActiveDescendant,
      getActiveDescendantValue,
      goToNextDescendant,
      goToPreviousDescendant,
      goToLastDescendant,
      goToFirstDescendant,
      resetDescendant
    } = useActiveDescendant({
      descendants: toRef(props, "options")
    });
    watch(
      () => activeDescendantId.value,
      (value) => {
        if (value) {
          const activeDescendant = getActiveDescendant();
          activeDescendant == null ? void 0 : activeDescendant.scrollIntoView({
            block: "nearest",
            inline: "nearest"
          });
        }
      }
    );
    const { focused } = useFocusWithin(selectRef);
    watch(
      () => focused.value,
      (isFocused) => {
        if (!isFocused) {
          closeDropdown();
          return;
        }
        if (isFocused && !isExpanded.value) {
          openDropdown();
        }
      }
    );
    watch(
      () => props.modelValue,
      (value) => {
        proxiedModel.value = value;
      }
    );
    onClickOutside(selectRef, closeDropdown);
    function onLetterKeyPress(e) {
      const key = e.key.toLowerCase();
      if (key.length > 1 || key <= "a" || key >= "z") {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      const option = props.options.find(
        (someOption) => someOption.label.toLowerCase().startsWith(key)
      );
      if (!option) {
        return;
      }
      const optionElement = document.querySelector(
        `[data-option="${option.value}"]`
      );
      optionElement == null ? void 0 : optionElement.scrollIntoView({ block: "nearest" });
      optionElement == null ? void 0 : optionElement.focus();
    }
    function onSelect(value) {
      if (isSelected(value)) {
        return deselect(value);
      }
      if (props.variant === "multiple") {
        proxiedModel.value = [...proxiedModel.value, value];
      } else {
        proxiedModel.value = value;
        closeDropdown();
      }
    }
    function onResetModel() {
      if (props.variant === "multiple") {
        proxiedModel.value = [];
      } else {
        proxiedModel.value = "";
      }
    }
    function onEnterOrSpaceKey() {
      if (isExpanded.value) {
        const value = getActiveDescendantValue();
        if (value) {
          onSelect(value);
        }
      } else {
        openDropdown();
      }
    }
    function onTriggerArrowDownKey() {
      if (isExpanded.value) {
        goToNextDescendant();
      } else {
        openDropdown();
      }
    }
    function onTriggerArrowUpKey() {
      if (isExpanded.value) {
        goToPreviousDescendant();
      } else {
        openDropdown();
      }
    }
    function isSelected(value) {
      if (props.variant === "multiple") {
        return proxiedModel.value.includes(value);
      } else {
        return proxiedModel.value === value;
      }
    }
    function deselect(value) {
      if (props.variant === "multiple") {
        proxiedModel.value = proxiedModel.value.filter(
          (v) => v !== value
        );
      } else {
        closeDropdown();
      }
    }
    function closeDropdown() {
      isExpanded.value = false;
      resetDescendant();
    }
    function openDropdown() {
      var _a;
      if (props.disabled || props.readonly) {
        return;
      }
      (_a = triggerRef.value) == null ? void 0 : _a.focus();
      isExpanded.value = true;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "selectRef",
        ref: selectRef,
        class: "b-select",
        onMousedown: _cache[3] || (_cache[3] = withModifiers(() => {
        }, ["prevent"])),
        onKeydown: [
          withKeys(withModifiers(closeDropdown, ["prevent"]), ["escape"]),
          onLetterKeyPress
        ]
      }, [
        createVNode(unref(BFormControl), {
          ref_key: "formControlRef",
          ref: formControlRef,
          "label-for": unref(triggerId),
          label: _ctx.label,
          invalid: _ctx.invalid,
          "color-scheme": _ctx.colorScheme,
          disabled: _ctx.disabled,
          readonly: _ctx.readonly,
          populated: isPopulated.value,
          hint: _ctx.hint,
          "show-cursor-pointer": !_ctx.disabled && !_ctx.readonly,
          onClickFormControl: _cache[2] || (_cache[2] = ($event) => isExpanded.value ? closeDropdown() : openDropdown())
        }, {
          control: withCtx(() => [
            createElementVNode("div", {
              id: unref(triggerId),
              ref_key: "triggerRef",
              ref: triggerRef,
              "aria-readonly": _ctx.readonly,
              "aria-controls": unref(listboxId),
              "aria-expanded": isExpanded.value,
              "aria-activedescendant": unref(activeDescendantId),
              tabindex: _ctx.disabled ? -1 : 0,
              "aria-haspopup": "listbox",
              class: "b-select__trigger",
              role: "combobox",
              onKeydown: [
                withKeys(withModifiers(onEnterOrSpaceKey, ["prevent"]), ["enter"]),
                withKeys(withModifiers(onEnterOrSpaceKey, ["prevent"]), ["space"]),
                withKeys(withModifiers(onTriggerArrowUpKey, ["prevent"]), ["up"]),
                withKeys(withModifiers(onTriggerArrowDownKey, ["prevent"]), ["down"]),
                _cache[0] || (_cache[0] = withKeys(
                  //@ts-ignore
                  (...args) => unref(goToFirstDescendant) && unref(goToFirstDescendant)(...args),
                  ["home"]
                )),
                _cache[1] || (_cache[1] = withKeys(
                  //@ts-ignore
                  (...args) => unref(goToLastDescendant) && unref(goToLastDescendant)(...args),
                  ["end"]
                ))
              ]
            }, toDisplayString(displaySelection.value), 41, _hoisted_2$7)
          ]),
          suffix: withCtx(() => [
            createElementVNode("div", _hoisted_3$5, [
              isExpanded.value ? (openBlock(), createBlock(unref(ChevronUpIcon), {
                key: 0,
                size: "md"
              })) : (openBlock(), createBlock(unref(ChevronDownIcon), {
                key: 1,
                size: "md"
              }))
            ])
          ]),
          error: withCtx(() => [
            _ctx.invalid ? (openBlock(), createBlock(unref(BFormError), {
              key: 0,
              "color-scheme": _ctx.colorScheme,
              invalid: _ctx.invalid,
              "error-message": _ctx.errorMessage
            }, null, 8, ["color-scheme", "invalid", "error-message"])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label-for", "label", "invalid", "color-scheme", "disabled", "readonly", "populated", "hint", "show-cursor-pointer"]),
        isExpanded.value ? (openBlock(), createBlock(unref(BListbox), {
          key: 0,
          id: unref(listboxId),
          ref_key: "listboxRef",
          ref: listboxRef,
          style: normalizeStyle(unref(floatingStyles)),
          "aria-labelledby": unref(triggerId),
          options: _ctx.options,
          variant: props.variant === "multiple" ? "checkbox" : "ticks",
          "multi-selectable": props.variant === "multiple",
          "model-value": proxiedModel.value,
          onClickSelected: onSelect,
          onClearAll: onResetModel
        }, createSlots({ _: 2 }, [
          _ctx.options.length === 0 ? {
            name: "empty-content",
            fn: withCtx(() => [
              createElementVNode("div", _hoisted_4$2, toDisplayString(_ctx.emptyMessage), 1)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["id", "style", "aria-labelledby", "options", "variant", "multi-selectable", "model-value"])) : createCommentVNode("", true)
      ], 40, _hoisted_1$9);
    };
  }
});
const bSelect_vue_vue_type_style_index_0_scoped_77b4f319_lang = "";
const bSelect = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["__scopeId", "data-v-77b4f319"]]);
const COMPACT_TEXT_DELIMITER = 40;
const TEXT_LENGTH_DELIMITER = 120;
const AUTO_DISMISS_DURATION = {
  SHORT: 5e3,
  LONG: 7e3
};
const snackbarStore = ref([]);
const clearAllSnackbarNotification = () => {
  snackbarStore.value = [];
};
const dismissSnackbarNotification = (id) => {
  snackbarStore.value = snackbarStore.value.filter((item) => item.id !== id);
};
const createSnackbarNotification = (item) => {
  const id = generateUniqueId();
  snackbarStore.value = [...snackbarStore.value, { ...item, id }];
};
const _withScopeId$1 = (n) => (pushScopeId("data-v-e5fb055c"), n = n(), popScopeId(), n);
const _hoisted_1$8 = ["aria-live", "aria-label"];
const _hoisted_2$6 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", { class: "b-snackbar__left-bar" }, null, -1));
const _hoisted_3$4 = { class: "b-snackbar__wrapper" };
const _hoisted_4$1 = {
  key: 0,
  class: "b-snackbar__icon"
};
const _hoisted_5$1 = { class: "b-snackbar__content" };
const _hoisted_6$1 = {
  key: 1,
  class: "b-snackbar__additionalText"
};
const _hoisted_7 = {
  key: 2,
  class: "b-snackbar__action"
};
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "b-snackbar",
  props: {
    autoDismiss: { type: Boolean, default: true },
    id: {},
    type: { default: "neutral" },
    message: {},
    additionalText: { default: void 0 },
    showCloseIcon: { type: Boolean, default: false },
    actionLabel: { default: void 0 },
    onActionClick: { type: Function, default: void 0 },
    icon: { default: void 0 },
    iconPosition: { default: void 0 }
  },
  setup(__props) {
    const props = __props;
    const breakpoints = useBreakpoints();
    const greaterThanMd = breakpoints.greaterOrEqual("lg");
    const isLine = computed(
      () => !(props.message.length >= COMPACT_TEXT_DELIMITER || props.additionalText)
    );
    const isLongMessage = computed(
      () => props.message.length > TEXT_LENGTH_DELIMITER || props.additionalText
    );
    const hasAction = computed(
      () => !!props.actionLabel && typeof props.onActionClick === "function"
    );
    const duration = computed(() => {
      return isLongMessage.value ? AUTO_DISMISS_DURATION.LONG : AUTO_DISMISS_DURATION.SHORT;
    });
    const { start, stop } = useTimeoutFn(() => {
      if (props.autoDismiss) {
        dismiss();
      }
    }, duration);
    onMounted(() => {
      if (props.autoDismiss) {
        start();
      }
    });
    function onPause() {
      if (props.autoDismiss) {
        stop();
      }
    }
    function onResume() {
      if (props.autoDismiss) {
        start();
      }
    }
    function dismiss() {
      dismissSnackbarNotification(props.id);
    }
    function onClick() {
      var _a;
      (_a = props.onActionClick) == null ? void 0 : _a.call(props);
      dismiss();
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        "aria-live": _ctx.autoDismiss ? "assertive" : "polite",
        "aria-label": `${_ctx.message}. ${_ctx.additionalText ?? ""}`,
        "data-cy": "b-snackbar",
        class: normalizeClass(["b-snackbar", [
          _ctx.type ? `b-snackbar--${_ctx.type}` : ``,
          {
            "b-snackbar--line": isLine.value
          }
        ]]),
        onMouseleave: onResume,
        onMouseenter: onPause
      }, [
        _hoisted_2$6,
        createElementVNode("div", _hoisted_3$4, [
          _ctx.type !== "neutral" ? (openBlock(), createElementBlock("div", _hoisted_4$1, [
            createVNode(unref(BFeedbackIcon), {
              type: _ctx.type,
              size: unref(greaterThanMd) ? `lg` : `md`
            }, null, 8, ["type", "size"])
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_5$1, [
            createElementVNode("p", {
              class: normalizeClass(["b-snackbar__message", {
                "b-snackbar__message--with-max-width": !isLine.value && _ctx.showCloseIcon,
                "b-snackbar__message--with-icon": _ctx.type
              }])
            }, toDisplayString(_ctx.message), 3),
            _ctx.showCloseIcon ? (openBlock(), createElementBlock("button", {
              key: 0,
              "aria-label": "Close",
              "data-cy": "b-snackbar-close",
              class: "b-snackbar__close",
              onClick: dismiss
            }, [
              createVNode(unref(CloseIcon), { size: "md" })
            ])) : createCommentVNode("", true),
            _ctx.additionalText ? (openBlock(), createElementBlock("div", _hoisted_6$1, toDisplayString(_ctx.additionalText), 1)) : createCommentVNode("", true),
            hasAction.value ? (openBlock(), createElementBlock("div", _hoisted_7, [
              createVNode(unref(BButton), {
                "data-cy": "b-snackbar-action",
                "color-scheme": "white",
                variant: "outline",
                size: "md",
                "icon-position": props.iconPosition,
                onClick
              }, {
                icon: withCtx((iconProps) => [
                  (openBlock(), createBlock(resolveDynamicComponent(_ctx.icon), normalizeProps(guardReactiveProps(iconProps)), null, 16))
                ]),
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.actionLabel) + " ", 1)
                ]),
                _: 1
              }, 8, ["icon-position"])
            ])) : createCommentVNode("", true)
          ])
        ])
      ], 42, _hoisted_1$8);
    };
  }
});
const bSnackbar_vue_vue_type_style_index_0_scoped_e5fb055c_lang = "";
const BSnackbar = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["__scopeId", "data-v-e5fb055c"]]);
const _hoisted_1$7 = { class: "b-snackbar-manager" };
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "b-snackbar-manager",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Teleport, { to: "body" }, [
        createElementVNode("div", _hoisted_1$7, [
          createVNode(TransitionGroup, { name: "b-snackbar" }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(snackbarStore), (item) => {
                return openBlock(), createBlock(BSnackbar, mergeProps(item, {
                  key: item.id
                }), null, 16);
              }), 128))
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
});
const bSnackbarManager_vue_vue_type_style_index_0_scoped_4a2a3640_lang = "";
const bSnackbarManager = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["__scopeId", "data-v-4a2a3640"]]);
const _hoisted_1$6 = { class: "b-structured-list-modal" };
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "b-structured-list-modal",
  props: {
    open: { type: Boolean },
    labelledById: {}
  },
  emits: ["click-outside"],
  setup(__props, { emit }) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        renderSlot(_ctx.$slots, "default", { isFullScreenScoped: false }, void 0, true),
        (openBlock(), createBlock(Teleport, { to: "body" }, [
          _ctx.open ? (openBlock(), createBlock(unref(BModal), {
            key: 0,
            "labelled-by-id": "labelledById",
            onClickOutside: _cache[0] || (_cache[0] = ($event) => emit("click-outside"))
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1$6, [
                renderSlot(_ctx.$slots, "default", { isFullScreenScoped: true }, void 0, true)
              ])
            ]),
            _: 3
          })) : createCommentVNode("", true)
        ]))
      ], 64);
    };
  }
});
const bStructuredListModal_vue_vue_type_style_index_0_scoped_7de8d8e8_lang = "";
const BStructuredListModal = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["__scopeId", "data-v-7de8d8e8"]]);
const _hoisted_1$5 = ["id"];
const _hoisted_2$5 = { class: "b-structured-list-table__table" };
const _hoisted_3$3 = { class: "b-structured-list-table__header-row" };
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "b-structured-list-table",
  props: {
    data: {},
    columnDefs: {},
    title: {},
    size: { default: "md" },
    showDividers: { type: Boolean },
    align: { default: "baseline" },
    hideHeader: { type: Boolean },
    isFullScreen: { type: Boolean },
    titleId: {}
  },
  emits: ["toggle-fullscreen"],
  setup(__props, { emit }) {
    const props = __props;
    const isHorizontalScrolled = ref(false);
    const columnDefsWithStyles = computed(
      () => props.columnDefs.map((columnDef) => ({
        ...columnDef,
        styles: getColumnStyles(columnDef)
      }))
    );
    function getColumnStyles(columnDef) {
      let width = typeof columnDef.width === "number" ? `${columnDef.width}px` : columnDef.width ?? "auto";
      if (columnDef.sticky) {
        width = `min(${width}, 50vw)`;
      }
      return {
        width,
        minWidth: width
        // needed to shrink less that the content
      };
    }
    function getCellValue(row, columnDef) {
      const dataCell = row[columnDef.accessorKey];
      if (typeof dataCell === "string") {
        return dataCell;
      }
      if (typeof dataCell === "number") {
        return dataCell.toString();
      }
      if (dataCell === null || dataCell === void 0) {
        return "";
      }
      return JSON.stringify(dataCell);
    }
    function updateStickyDivider(event) {
      requestAnimationFrame(() => {
        isHorizontalScrolled.value = event.target.scrollLeft > 0;
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["b-structured-list-table", { "b-structured-list-table--fullscreen": _ctx.isFullScreen }])
      }, [
        !_ctx.hideHeader ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["b-structured-list-table__header", `b-structured-list-table__header--${_ctx.size}`])
        }, [
          createElementVNode("h1", {
            id: _ctx.titleId,
            class: "b-structured-list-table__title"
          }, toDisplayString(_ctx.title), 9, _hoisted_1$5),
          createVNode(unref(BIconButton), {
            label: _ctx.isFullScreen ? "exit table full screen" : "enter table full screen",
            onClick: _cache[0] || (_cache[0] = ($event) => emit("toggle-fullscreen"))
          }, {
            icon: withCtx((scope) => [
              _ctx.isFullScreen ? (openBlock(), createBlock(unref(NoFullScreenIcon), normalizeProps(mergeProps({ key: 0 }, scope)), null, 16)) : (openBlock(), createBlock(unref(FullScreenIcon), normalizeProps(mergeProps({ key: 1 }, scope)), null, 16))
            ]),
            _: 1
          }, 8, ["label"])
        ], 2)) : createCommentVNode("", true),
        createElementVNode("div", {
          class: "b-structured-list-table__scroll-wrapper",
          onScroll: updateStickyDivider
        }, [
          createElementVNode("table", _hoisted_2$5, [
            createElementVNode("thead", null, [
              createElementVNode("tr", _hoisted_3$3, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(columnDefsWithStyles.value, (columnDef) => {
                  return openBlock(), createElementBlock("th", {
                    key: columnDef.label,
                    class: normalizeClass(["b-structured-list-table__header-cell", [
                      `b-structured-list-table__header-cell--${_ctx.size}`,
                      `b-structured-list-table__header-cell--${columnDef.align ?? "left"}`,
                      {
                        "b-structured-list-table__header-cell--sticky": columnDef.sticky,
                        "b-structured-list-table__header-cell--show-right-divider": columnDef.sticky && isHorizontalScrolled.value
                      }
                    ]]),
                    style: normalizeStyle(columnDef.styles)
                  }, toDisplayString(columnDef.label), 7);
                }), 128))
              ])
            ]),
            createElementVNode("tbody", null, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.data, (row) => {
                return openBlock(), createElementBlock("tr", {
                  key: JSON.stringify(row),
                  class: "b-structured-list-table__row"
                }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(columnDefsWithStyles.value, (columnDef) => {
                    return openBlock(), createElementBlock("td", {
                      key: columnDef.accessorKey,
                      class: normalizeClass(["b-structured-list-table__cell", [
                        `b-structured-list-table__cell--${_ctx.size}`,
                        `b-structured-list-table__cell--${columnDef.align ?? "left"}`,
                        `b-structured-list-table__cell--${_ctx.align}`,
                        {
                          "b-structured-list-table__cell--show-divider": _ctx.showDividers,
                          "b-structured-list-table__cell--sticky": columnDef.sticky,
                          "b-structured-list-table__cell--show-right-divider": columnDef.sticky && isHorizontalScrolled.value
                        }
                      ]]),
                      style: normalizeStyle(columnDef.styles)
                    }, [
                      renderSlot(_ctx.$slots, columnDef.accessorKey, {
                        row,
                        columnDef
                      }, () => [
                        createTextVNode(toDisplayString(getCellValue(row, columnDef)), 1)
                      ], true)
                    ], 6);
                  }), 128))
                ]);
              }), 128))
            ])
          ])
        ], 32)
      ], 2);
    };
  }
});
const bStructuredListTable_vue_vue_type_style_index_0_scoped_73720a96_lang = "";
const BStructuredListTable = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["__scopeId", "data-v-73720a96"]]);
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-structured-list",
  props: {
    data: {},
    columnDefs: {},
    title: {},
    size: { default: "md" },
    showDividers: { type: Boolean },
    align: {},
    hideHeader: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const attrs = useSafeAttrs(useAttrs());
    const isFullScreen = ref(false);
    const titleId = generateUniqueId();
    const slicedData = computed(() => props.data.slice(0, 50));
    const parsedColumnDefs = computed(() => {
      const stickyColumn = props.columnDefs.find((c) => c.sticky);
      if (!stickyColumn) {
        return props.columnDefs;
      }
      if (props.columnDefs.filter((c) => c.sticky).length > 1) {
        console.warn(
          "Only one column can be sticky in a StructuredList component."
        );
      }
      return [
        stickyColumn,
        ...props.columnDefs.filter((c) => c !== stickyColumn).map((c) => ({ ...c, sticky: false }))
      ];
    });
    watch(
      () => props.data,
      (data) => {
        if (data.length > 50) {
          console.warn("StructuredList only shows the first 50 rows.");
        }
      },
      {
        immediate: true
      }
    );
    function toggleFullScreen() {
      isFullScreen.value = !isFullScreen.value;
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(BStructuredListModal, {
        open: isFullScreen.value,
        "labelled-by-id": unref(titleId),
        onClickOutside: toggleFullScreen
      }, {
        default: withCtx(({ isFullScreenScoped }) => [
          createVNode(BStructuredListTable, mergeProps(unref(attrs), {
            data: slicedData.value,
            "column-defs": parsedColumnDefs.value,
            size: _ctx.size,
            title: _ctx.title,
            "show-dividers": _ctx.showDividers,
            align: _ctx.align,
            "title-id": unref(titleId),
            "is-full-screen": isFullScreenScoped,
            "hide-header": _ctx.hideHeader,
            onToggleFullscreen: toggleFullScreen
          }), createSlots({ _: 2 }, [
            renderList(parsedColumnDefs.value, ({ accessorKey }) => {
              return {
                name: accessorKey,
                fn: withCtx((scope) => [
                  renderSlot(_ctx.$slots, accessorKey, normalizeProps(guardReactiveProps(scope)))
                ])
              };
            })
          ]), 1040, ["data", "column-defs", "size", "title", "show-dividers", "align", "title-id", "is-full-screen", "hide-header"])
        ]),
        _: 3
      }, 8, ["open", "labelled-by-id"]);
    };
  }
});
const _hoisted_1$4 = ["id", "aria-checked", "aria-labelledby", "aria-readonly", "disabled"];
const _hoisted_2$4 = ["id", "for"];
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "b-switch",
  props: {
    colorScheme: { default: "black" },
    disabled: { type: Boolean, default: false },
    label: { default: void 0 },
    modelValue: { type: Boolean },
    readonly: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit }) {
    const props = __props;
    const slots = useSlots();
    const switchRef = ref(null);
    __expose({
      switch: switchRef
    });
    const safeAttrs = useSafeAttrs(useAttrs());
    const buttonId = generateUniqueId();
    const labelId = generateUniqueId();
    const switchAttrs = computed(() => {
      const { value: _, ...attrs } = safeAttrs.value;
      return attrs;
    });
    function emitUpdateModelValue() {
      if (!props.readonly) {
        emit("update:modelValue", !props.modelValue);
      }
    }
    if (!props.label && !safeAttrs.value["aria-label"] && !slots["custom-label"]) {
      console.warn(
        "Please provide a label, aria-label or use the custom-label slot for a BSwitch"
      );
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["b-switch", [
          `b-switch--${_ctx.colorScheme}`,
          _ctx.modelValue ? "b-switch--on" : "b-switch--off",
          {
            "b-switch--disabled": _ctx.disabled,
            "b-switch--readonly": _ctx.readonly
          }
        ]])
      }, [
        createElementVNode("button", mergeProps({
          id: unref(buttonId),
          ref_key: "switchRef",
          ref: switchRef,
          class: ["b-switch__track", [
            `b-switch__track--${_ctx.colorScheme}`,
            _ctx.modelValue ? "b-switch__track--on" : "b-switch__track--off",
            {
              "b-switch__track--disabled": _ctx.disabled,
              "b-switch__track--readonly": _ctx.readonly
            }
          ]],
          "aria-checked": _ctx.modelValue,
          "aria-labelledby": unref(labelId),
          "aria-readonly": _ctx.readonly,
          disabled: _ctx.disabled,
          role: "switch"
        }, switchAttrs.value, { onClick: emitUpdateModelValue }), [
          createElementVNode("div", {
            class: normalizeClass(["b-switch__thumb", [
              `b-switch__thumb--${_ctx.colorScheme}`,
              _ctx.modelValue ? "b-switch__thumb--on" : "b-switch__thumb--off",
              {
                "b-switch__thumb--disabled": _ctx.disabled,
                "b-switch__thumb--readonly": _ctx.readonly
              }
            ]])
          }, null, 2)
        ], 16, _hoisted_1$4),
        _ctx.label || unref(slots)["custom-label"] ? (openBlock(), createElementBlock("label", {
          key: 0,
          id: unref(labelId),
          for: unref(buttonId),
          class: "b-switch__label"
        }, [
          renderSlot(_ctx.$slots, "custom-label", {}, () => [
            createTextVNode(toDisplayString(_ctx.label), 1)
          ], true)
        ], 8, _hoisted_2$4)) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const bSwitch_vue_vue_type_style_index_0_scoped_5b714814_lang = "";
const bSwitch = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["__scopeId", "data-v-5b714814"]]);
const _hoisted_1$3 = { class: "b-tabs" };
const _hoisted_2$3 = ["id", "aria-label", "aria-selected", "tabindex", "disabled", "onClick", "onKeydown", "onFocus"];
const _hoisted_3$2 = {
  key: 0,
  class: "b-tabs__tab-icon"
};
const extraSpaceForTooltip = "35px";
const extraSpaceForFocusRing = "4px";
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: true
  },
  __name: "b-tabs",
  props: {
    tabs: {},
    size: { default: "md" },
    iconOnly: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: {},
    hideDivider: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    useCssVars((_ctx) => ({
      "1d4712ca": extraSpace.value
    }));
    const tabsAttrs = useSafeAttrs(useAttrs());
    const activeTab = ref(props.modelValue);
    const tabsRef = ref([]);
    const showButtons = ref(false);
    const tabsId = generateUniqueId();
    const visibleTooltip = ref([]);
    const slidingPanelRef = ref(null);
    const tabsSizeToIconSizeMap = {
      sm: "md",
      md: "md",
      lg: "lg"
    };
    const iconSize = computed(() => tabsSizeToIconSizeMap[props.size]);
    const computedTabs = computed(() => {
      return props.tabs.map((tab, index) => {
        return {
          ...tab,
          id: `${tabsId}-${index}`
        };
      });
    });
    const activeTabId = computed(() => {
      return computedTabs.value[activeTab.value].id;
    });
    const isAnyIconOnly = computed(
      () => props.iconOnly || props.tabs.some(
        (tabConfig) => tabConfig.iconOnly && !!tabConfig.iconComponent
      )
    );
    const extraSpace = computed(() => {
      return isAnyIconOnly.value ? extraSpaceForTooltip : extraSpaceForFocusRing;
    });
    const breakpoints = useBreakpoints();
    const addPadding = breakpoints.smaller("lg");
    watch(() => props.modelValue, setTab);
    onMounted(() => showButtons.value = !isTouchableScreen());
    function setNextTab(direction) {
      let nextTabIndex = activeTab.value;
      do {
        if (direction === "right") {
          nextTabIndex = (nextTabIndex + 1) % props.tabs.length;
        } else {
          if (nextTabIndex > 0) {
            nextTabIndex--;
          } else {
            nextTabIndex = props.tabs.length - 1;
          }
        }
      } while (props.tabs[nextTabIndex].disabled || nextTabIndex === activeTab.value);
      setTab(nextTabIndex);
    }
    function setTab(tabIndex) {
      var _a, _b, _c, _d;
      if (activeTab.value === tabIndex) {
        return;
      }
      emit("update:modelValue", tabIndex);
      activeTab.value = tabIndex;
      const activeTabElement = (_a = tabsRef.value) == null ? void 0 : _a[activeTab.value];
      activeTabElement == null ? void 0 : activeTabElement.focus();
      (_b = slidingPanelRef.value) == null ? void 0 : _b.scrollElementIntoView(activeTabElement);
      (_d = (_c = props.tabs[tabIndex]).onClick) == null ? void 0 : _d.call(_c);
    }
    function isIconOnly(index) {
      return (props.iconOnly || props.tabs[index].iconOnly) && !!props.tabs[index].iconComponent;
    }
    function isTouchableScreen() {
      if (!isBrowser()) {
        return false;
      }
      return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    }
    function showTooltip(index) {
      hideTooltip();
      if (isIconOnly(index)) {
        visibleTooltip.value[index] = true;
      }
    }
    function hideTooltip() {
      visibleTooltip.value.fill(false, 0);
    }
    function tooltipPlacement(index) {
      if (index === 0) {
        return "top-start";
      } else if (index === props.tabs.length - 1) {
        return "top-end";
      } else {
        return "top";
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$3, [
        createElementVNode("div", {
          class: normalizeClass(["b-tabs__scroll-wrapper", `b-tabs__scroll-wrapper--${_ctx.size}`])
        }, [
          createVNode(unref(BSlidingPanel), {
            ref_key: "slidingPanelRef",
            ref: slidingPanelRef,
            class: "b-tabs__sliding-panel"
          }, {
            "button-left": withCtx(() => [
              showButtons.value ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(["b-tabs__button-left", `b-tabs__button-left--${_ctx.size}`])
              }, [
                createVNode(unref(ChevronLeftIcon))
              ], 2)) : createCommentVNode("", true)
            ]),
            "button-right": withCtx(() => [
              showButtons.value ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(["b-tabs__button-right", `b-tabs__button-right--${_ctx.size}`])
              }, [
                createVNode(unref(ChevronRightIcon))
              ], 2)) : createCommentVNode("", true)
            ]),
            default: withCtx(() => [
              createElementVNode("div", mergeProps({
                ref: "tablistRef",
                role: "tablist",
                class: ["b-tabs__tablist", [
                  `b-tabs__tablist--${_ctx.size}`,
                  {
                    "b-tabs__tablist--add-padding": unref(addPadding),
                    "b-tabs__tablist--add-divider": !_ctx.hideDivider
                  }
                ]]
              }, unref(tabsAttrs)), [
                (openBlock(true), createElementBlock(Fragment, null, renderList(computedTabs.value, (tab, index) => {
                  return openBlock(), createElementBlock("div", {
                    key: tab.id,
                    class: "b-tabs__tooltip-wrapper"
                  }, [
                    createVNode(unref(BTooltip), {
                      placement: tooltipPlacement(index),
                      "force-visible": visibleTooltip.value[index]
                    }, {
                      trigger: withCtx((tooltipProps) => [
                        createElementVNode("button", mergeProps(isIconOnly(index) ? tooltipProps : {}, {
                          id: tab.id,
                          ref_for: true,
                          ref_key: "tabsRef",
                          ref: tabsRef,
                          class: ["b-tabs__tab", [
                            `b-tabs__tab--${_ctx.size}`,
                            { "b-tabs__tab--active": activeTab.value === index },
                            { "b-tabs__tab--icon-only": isIconOnly(index) }
                          ]],
                          role: "tab",
                          "aria-label": tab.label,
                          "aria-selected": activeTab.value === index,
                          tabindex: activeTab.value === index ? 0 : -1,
                          disabled: tab.disabled || _ctx.disabled,
                          onClick: ($event) => setTab(index),
                          onKeydown: [
                            _cache[0] || (_cache[0] = withKeys(withModifiers(($event) => setNextTab("right"), ["prevent"]), ["right"])),
                            _cache[1] || (_cache[1] = withKeys(withModifiers(($event) => setNextTab("left"), ["prevent"]), ["left"])),
                            withKeys(($event) => setTab(index), ["enter"])
                          ],
                          onFocus: ($event) => showTooltip(index),
                          onBlur: hideTooltip,
                          onMouseleave: hideTooltip
                        }), [
                          createElementVNode("div", {
                            class: normalizeClass(["b-tabs__tab-title", {
                              "b-tabs__tab-title--active": activeTab.value === index
                            }])
                          }, [
                            !!tab.iconComponent ? (openBlock(), createElementBlock("div", _hoisted_3$2, [
                              (openBlock(), createBlock(resolveDynamicComponent(tab.iconComponent), {
                                fill: "currentColor",
                                size: iconSize.value
                              }, null, 8, ["size"]))
                            ])) : createCommentVNode("", true),
                            !isIconOnly(index) ? (openBlock(), createElementBlock("span", {
                              key: 1,
                              class: normalizeClass(["b-tabs__tab-label", [
                                `b-tabs__tab-label--${_ctx.size}`,
                                { "b-tabs__tab-label--active": activeTab.value === index }
                              ]])
                            }, toDisplayString(tab.label), 3)) : createCommentVNode("", true),
                            tab.counter ? (openBlock(), createElementBlock("span", {
                              key: 2,
                              class: normalizeClass(["b-tabs__tab-counter", {
                                "b-tabs__tab-counter--active": activeTab.value === index
                              }])
                            }, toDisplayString(tab.counter), 3)) : createCommentVNode("", true)
                          ], 2)
                        ], 16, _hoisted_2$3)
                      ]),
                      content: withCtx(() => [
                        createTextVNode(toDisplayString(tab.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["placement", "force-visible"])
                  ]);
                }), 128))
              ], 16)
            ]),
            _: 1
          }, 512)
        ], 2),
        renderSlot(_ctx.$slots, "panel", {
          "aria-Labelledby": activeTabId.value,
          role: "tabpanel",
          tabindex: "0"
        }, void 0, true)
      ]);
    };
  }
});
const bTabs_vue_vue_type_style_index_0_scoped_a5ba9401_lang = "";
const bTabs = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["__scopeId", "data-v-a5ba9401"]]);
const _hoisted_1$2 = ["id", "disabled", "readonly", "aria-invalid"];
const _hoisted_2$2 = { class: "b-textarea__error-messages" };
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-textarea",
  props: {
    invalid: { type: Boolean },
    readonly: { type: Boolean },
    colorScheme: { default: "black" },
    disabled: { type: Boolean },
    modelValue: {},
    errorMessage: {},
    label: {},
    maxCounter: {},
    minCounter: {},
    hint: {},
    height: {}
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(__props, { expose: __expose, emit }) {
    const props = __props;
    const id = generateUniqueId();
    const inputAttrs = useSafeAttrs(useAttrs());
    const proxiedModel = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value)
    });
    const inputLength = computed(() => props.modelValue.length ?? 0);
    const textareaRef = ref(null);
    __expose({
      /**
       * Expose the Textarea to clients to have full control over the input
       * For example, trigger focus programmatically via `componentInstanceRef.value.textarea.focus()`
       */
      textarea: textareaRef
    });
    const counterText = computed(() => {
      if (props.disabled || props.readonly) {
        return null;
      }
      if (props.minCounter && props.maxCounter) {
        return `${inputLength.value}/${props.maxCounter} (Min. ${props.minCounter})`;
      }
      if (props.maxCounter) {
        return `${inputLength.value}/${props.maxCounter}`;
      }
      if (props.minCounter) {
        return `${inputLength.value} (Min. ${props.minCounter})`;
      }
      return null;
    });
    const handleFocus = (event) => {
      emit("focus", event);
    };
    const handleBlur = (event) => {
      emit("blur", event);
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(BFormControl, {
        "color-scheme": _ctx.colorScheme,
        disabled: _ctx.disabled,
        invalid: _ctx.invalid,
        "label-for": unref(id),
        label: _ctx.label,
        "no-padding-right": true,
        populated: !!proxiedModel.value,
        readonly: _ctx.readonly,
        hint: _ctx.hint,
        height: "auto"
      }, createSlots({
        control: withCtx(() => [
          withDirectives(createElementVNode("textarea", mergeProps({
            id: unref(id),
            ref_key: "textareaRef",
            ref: textareaRef,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => proxiedModel.value = $event),
            disabled: _ctx.disabled,
            readonly: _ctx.readonly,
            "aria-invalid": _ctx.invalid,
            rows: "2",
            class: ["b-textarea", [
              `b-textarea--${_ctx.colorScheme}`,
              {
                "b-textarea--disabled": _ctx.disabled
              }
            ]]
          }, unref(inputAttrs), {
            style: {
              "--custom-height": _ctx.height ? `${_ctx.height}px` : void 0
            },
            onFocus: handleFocus,
            onBlur: handleBlur
          }), null, 16, _hoisted_1$2), [
            [vModelText, proxiedModel.value]
          ])
        ]),
        _: 2
      }, [
        _ctx.invalid && _ctx.errorMessage ? {
          name: "error",
          fn: withCtx(() => [
            createElementVNode("div", _hoisted_2$2, [
              createVNode(unref(BFormError), {
                "color-scheme": _ctx.colorScheme,
                invalid: _ctx.invalid,
                "error-message": _ctx.errorMessage
              }, null, 8, ["color-scheme", "invalid", "error-message"])
            ])
          ]),
          key: "0"
        } : void 0,
        counterText.value ? {
          name: "details-right",
          fn: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(["b-textarea__counter", `b-textarea__counter--${_ctx.colorScheme}`])
            }, toDisplayString(counterText.value), 3)
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["color-scheme", "disabled", "invalid", "label-for", "label", "populated", "readonly", "hint"]);
    };
  }
});
const bTextarea_vue_vue_type_style_index_0_scoped_97cece94_lang = "";
const bTextarea = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["__scopeId", "data-v-97cece94"]]);
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-timeline",
  setup(__props) {
    const safeAttrs = useSafeAttrs(useAttrs());
    const childrenAlignments = ref([]);
    const isCenterLayout = computed(() => {
      const isLeft = childrenAlignments.value.includes("left");
      const isRight = childrenAlignments.value.includes("right");
      return isLeft && isRight;
    });
    provide("childrenAlignments", childrenAlignments);
    provide("isCenterLayout", isCenterLayout);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", mergeProps(unref(safeAttrs), { class: "b-timeline" }), [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 16);
    };
  }
});
const bTimeline_vue_vue_type_style_index_0_scoped_f1b5a0c9_lang = "";
const bTimeline = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["__scopeId", "data-v-f1b5a0c9"]]);
const _withScopeId = (n) => (pushScopeId("data-v-3ce19fe8"), n = n(), popScopeId(), n);
const _hoisted_1$1 = { class: "b-timeline-item__axis" };
const _hoisted_2$1 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "b-timeline-item__line" }, null, -1));
const _hoisted_3$1 = {
  key: 0,
  class: "b-timeline-item__dot-text"
};
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-timeline-item",
  props: {
    align: { default: "right" },
    type: { default: "blackNumberDot" },
    typeText: {},
    tagColorScheme: { default: "blue" },
    tagLabel: {},
    title: {},
    titleAs: { default: "h6" }
  },
  setup(__props) {
    const props = __props;
    const safeAttrs = useSafeAttrs(useAttrs());
    const childrenAlignments = inject("childrenAlignments");
    const isCenterLayout = inject("isCenterLayout");
    const updateChildrenAlignments = () => {
      if (childrenAlignments) {
        childrenAlignments.value.push(props.align);
      }
    };
    updateChildrenAlignments();
    const isNumberDot = computed(() => props.type === "blackNumberDot");
    const isWhiteDot = computed(() => props.type === "whiteDot");
    const isBodyLeft = computed(() => props.align === "left");
    watch(
      () => props.align,
      () => {
        updateChildrenAlignments();
      }
    );
    onMounted(() => {
      if (!childrenAlignments) {
        console.warn(
          "BTimelineItem needs to be rendered within a BTimeline component to be displayed correctly."
        );
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", mergeProps(unref(safeAttrs), {
        class: ["b-timeline-item", [
          `b-timeline-item--${_ctx.align}`,
          {
            "b-timeline-item--center": unref(isCenterLayout)
          }
        ]]
      }), [
        createElementVNode("div", _hoisted_1$1, [
          _hoisted_2$1,
          createElementVNode("div", {
            class: normalizeClass(["b-timeline-item__dot", [
              {
                "b-timeline-item__dot--number": isNumberDot.value,
                "b-timeline-item__dot--white": isWhiteDot.value
              }
            ]])
          }, [
            isNumberDot.value ? (openBlock(), createElementBlock("p", _hoisted_3$1, toDisplayString(_ctx.typeText), 1)) : createCommentVNode("", true)
          ], 2)
        ]),
        createElementVNode("div", {
          class: normalizeClass(["b-timeline-item__body", { "b-timeline-item__body--left": isBodyLeft.value }])
        }, [
          _ctx.title || _ctx.tagLabel ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.titleAs), {
            key: 0,
            class: "b-timeline-item__title"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.title) + " ", 1),
              _ctx.tagLabel ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(["b-timeline-item__tag-wrapper", { "b-timeline-item__tag-wrapper--gap": _ctx.title }])
              }, [
                createVNode(unref(BTag), {
                  "color-scheme": _ctx.tagColorScheme,
                  size: "md",
                  variant: "outline"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.tagLabel), 1)
                  ]),
                  _: 1
                }, 8, ["color-scheme"])
              ], 2)) : createCommentVNode("", true)
            ]),
            _: 1
          })) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass(["b-timeline-item__content", { "b-timeline-item__content--left": isBodyLeft.value }])
          }, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 2)
        ], 2)
      ], 16);
    };
  }
});
const bTimelineItem_vue_vue_type_style_index_0_scoped_3ce19fe8_lang = "";
const bTimelineItem = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["__scopeId", "data-v-3ce19fe8"]]);
const typographyVariants = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "body",
  "small"
];
const __default__ = {};
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  ...__default__,
  __name: "b-typography",
  props: {
    as: { default: "p" },
    variant: { default: void 0 },
    hasSmallMarginTop: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const computedVariant = computed(() => {
      return props.variant ?? (typographyVariants.includes(props.as) ? props.as : "body");
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.as), {
        class: normalizeClass(["b-typography", [
          `b-typography--${computedVariant.value}`,
          { "b-typography--has-small-margin-top": _ctx.hasSmallMarginTop }
        ]])
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const bTypography_vue_vue_type_style_index_0_scoped_659a4070_lang = "";
const bTypography = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["__scopeId", "data-v-659a4070"]]);
const STEPPER_STATE_KEY = Symbol("stepperState");
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: true
  },
  __name: "b-vertical-stepper",
  props: {
    activeStep: {},
    linear: { type: Boolean, default: true },
    labelReversed: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const stepperAttr = useSafeAttrs(useAttrs());
    const stepperState = computed(() => ({
      activeStep: props.activeStep,
      linear: props.linear,
      labelReversed: props.labelReversed,
      disabled: props.disabled
    }));
    provide(STEPPER_STATE_KEY, stepperState);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", mergeProps({ class: "b-vertical-stepper" }, unref(stepperAttr)), [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 16);
    };
  }
});
const bVerticalStepper_vue_vue_type_style_index_0_scoped_624f0999_lang = "";
const bVerticalStepper = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["__scopeId", "data-v-624f0999"]]);
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "b-height-animation",
  setup(__props) {
    function expand(el) {
      const element = el;
      element.style.height = "0";
      element.getBoundingClientRect();
      requestAnimationFrame(() => {
        element.style.height = `${element.scrollHeight}px`;
      });
    }
    function collapse(el) {
      const element = el;
      element.style.height = `${element.scrollHeight}px`;
      element.getBoundingClientRect();
      requestAnimationFrame(() => {
        element.style.height = "0";
      });
    }
    function cleanUp(el) {
      const element = el;
      element.style.height = "";
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, mergeProps(_ctx.$attrs, {
        name: "b-height-animation-",
        onEnter: expand,
        onLeave: collapse,
        onAfterEnter: cleanUp,
        onAfterLeave: cleanUp
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        _: 3
      }, 16);
    };
  }
});
const bHeightAnimation_vue_vue_type_style_index_0_scoped_1370a765_lang = "";
const BHeightAnimation = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-1370a765"]]);
const _hoisted_1 = ["tabindex", "aria-label", "aria-expanded", "disabled", "onKeydown"];
const _hoisted_2 = {
  key: 1,
  class: "b-step__number"
};
const _hoisted_3 = {
  key: 0,
  class: "b-step__label"
};
const _hoisted_4 = {
  key: 1,
  class: "b-step__sub-label"
};
const _hoisted_5 = { class: "b-step__body" };
const _hoisted_6 = { class: "b-step__content" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "b-vertical-stepper-step",
  props: {
    stepNumber: {},
    name: {},
    label: { default: void 0 },
    subLabel: { default: void 0 },
    tagLabel: { default: void 0 },
    completed: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    const slots = useSlots();
    const stepperState = inject(STEPPER_STATE_KEY);
    const attrs = useAttrs();
    const stepAttr = useSafeAttrs(attrs);
    const contentId = `step-content-${generateUniqueId()}`;
    const isDisabled = computed(
      () => (stepperState == null ? void 0 : stepperState.value.disabled) || ((stepperState == null ? void 0 : stepperState.value.linear) ? props.stepNumber > (stepperState == null ? void 0 : stepperState.value.activeStep) : props.disabled)
    );
    const isActive = computed(
      () => props.stepNumber === (stepperState == null ? void 0 : stepperState.value.activeStep)
    );
    const isCompleted = computed(
      () => (stepperState == null ? void 0 : stepperState.value.linear) ? props.stepNumber < (stepperState == null ? void 0 : stepperState.value.activeStep) : props.completed
    );
    const isShowingContent = computed(
      () => !isDisabled.value && isActive.value && !!slots["expanded-content"]
    );
    const tagVariant = computed(
      () => isCompleted.value && !isDisabled.value ? "green" : "blue"
    );
    const hasLabels = computed(
      () => props.label !== void 0 || props.subLabel !== void 0 || props.tagLabel !== void 0
    );
    function onStepClick() {
      if (!isDisabled.value) {
        emit("click", props.stepNumber);
      }
    }
    return (_ctx, _cache) => {
      var _a, _b, _c, _d;
      return openBlock(), createElementBlock("li", mergeProps({ class: "b-step" }, unref(stepAttr)), [
        createElementVNode("div", {
          class: normalizeClass(["b-step__header", {
            "b-step__header--disabled": isDisabled.value
          }]),
          tabindex: isDisabled.value ? -1 : 0,
          role: "button",
          "aria-label": _ctx.name,
          "aria-expanded": isShowingContent.value,
          "aria-controls": contentId,
          disabled: isDisabled.value,
          onClick: onStepClick,
          onKeydown: [
            withKeys(onStepClick, ["enter"]),
            withKeys(withModifiers(onStepClick, ["prevent"]), ["space"])
          ]
        }, [
          createElementVNode("div", {
            class: normalizeClass(["b-step__icon-wrapper", {
              "b-step__icon-wrapper--linear": (_a = unref(stepperState)) == null ? void 0 : _a.linear,
              "b-step__icon-wrapper--active": isActive.value,
              "b-step__icon-wrapper--completed": isCompleted.value
            }])
          }, [
            isCompleted.value && !isDisabled.value ? (openBlock(), createBlock(unref(BFeedbackIcon), {
              key: 0,
              size: "xl",
              type: "success",
              class: "b-step__completed-icon"
            })) : (openBlock(), createElementBlock("div", {
              key: 1,
              class: normalizeClass(["b-step__default-icon", { "b-step__default-icon--disabled": isDisabled.value }])
            }, [
              isShowingContent.value ? (openBlock(), createBlock(unref(EditIcon), {
                key: 0,
                size: "md"
              })) : (openBlock(), createElementBlock("span", _hoisted_2, toDisplayString(_ctx.stepNumber), 1))
            ], 2))
          ], 2),
          createElementVNode("div", {
            class: normalizeClass(["b-step__description", {
              "b-step__description--reversed": (_b = unref(stepperState)) == null ? void 0 : _b.labelReversed
            }])
          }, [
            createElementVNode("span", {
              class: normalizeClass(["b-step__name", { "b-step__name--disabled": isDisabled.value }])
            }, toDisplayString(_ctx.name), 3),
            hasLabels.value ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["b-step__labels", { "b-step__labels--disabled": isDisabled.value }])
            }, [
              _ctx.label ? (openBlock(), createElementBlock("span", _hoisted_3, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true),
              _ctx.subLabel ? (openBlock(), createElementBlock("span", _hoisted_4, toDisplayString(_ctx.subLabel), 1)) : createCommentVNode("", true),
              _ctx.tagLabel ? (openBlock(), createElementBlock("div", {
                key: 2,
                class: normalizeClass(["b-step__tag", { "b-step__tag--disabled": isDisabled.value }])
              }, [
                createVNode(unref(BTag), {
                  "color-scheme": tagVariant.value,
                  variant: "outline"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.tagLabel), 1)
                  ]),
                  _: 1
                }, 8, ["color-scheme"])
              ], 2)) : createCommentVNode("", true)
            ], 2)) : createCommentVNode("", true)
          ], 2)
        ], 42, _hoisted_1),
        createElementVNode("div", _hoisted_5, [
          createElementVNode("div", {
            class: normalizeClass(["b-step__body-left", {
              "b-step__body-left--linear": (_c = unref(stepperState)) == null ? void 0 : _c.linear,
              "b-step__body-left--completed": isCompleted.value
            }])
          }, null, 2),
          createElementVNode("div", {
            class: normalizeClass(["b-step__body-right", { "b-step__body-right--non-linear": !((_d = unref(stepperState)) == null ? void 0 : _d.linear) }])
          }, [
            createVNode(BHeightAnimation, null, {
              default: withCtx(() => [
                isShowingContent.value ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  id: contentId
                }, [
                  createElementVNode("div", _hoisted_6, [
                    renderSlot(_ctx.$slots, "expanded-content", {}, void 0, true)
                  ])
                ])) : createCommentVNode("", true)
              ]),
              _: 3
            })
          ], 2)
        ])
      ], 16);
    };
  }
});
const bVerticalStepperStep_vue_vue_type_style_index_0_scoped_1600e092_lang = "";
const bVerticalStepperStep = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-1600e092"]]);
export {
  BAccordion,
  BAccordionItem,
  bAlert as BAlert,
  bAutocomplete as BAutocomplete,
  bAvatar as BAvatar,
  bBreadcrumbs as BBreadcrumbs,
  BBreadcrumbsItem,
  BButton,
  bCardArticle as BCardArticle,
  bCardPeople as BCardPeople,
  bCardRt as BCardRT,
  BCheckbox,
  bCheckboxGroup as BCheckboxGroup,
  bChipFilter as BChipFilter,
  BChipInput,
  _sfc_main$12 as BChipSelect,
  BContextualMenu,
  BContextualMenuContent,
  bDateInput as BDateInput,
  bDialog as BDialog,
  BFeedbackIcon,
  bFloatingButton as BFloatingButton,
  bFooter as BFooter,
  bHorizontalStepper as BHorizontalStepper,
  bHorizontalStepperStep as BHorizontalStepperStep,
  BIconButton,
  bInput as BInput,
  BLink,
  BListbox,
  BModal,
  _sfc_main$t as BNavigationBar,
  BNavigationBarServiceButton,
  bNumberInput as BNumberInput,
  bPagination as BPagination,
  bPopover as BPopover,
  bPopoverDescription as BPopoverDescription,
  bPopoverTitle as BPopoverTitle,
  bProgressIndicator as BProgressIndicator,
  BREAKPOINTS_MAP,
  bRadio as BRadio,
  bRadioGroup as BRadioGroup,
  bSegment as BSegment,
  bSelect as BSelect,
  BSnackbar,
  bSnackbarManager as BSnackbarManager,
  BSpinner,
  _sfc_main$9 as BStructuredList,
  bSwitch as BSwitch,
  bTabs as BTabs,
  BTag,
  bTextarea as BTextarea,
  bTimeline as BTimeline,
  bTimelineItem as BTimelineItem,
  BTooltip,
  bVerticalStepper as BVerticalStepper,
  bVerticalStepperStep as BVerticalStepperStep,
  BSlidingPanel as __BSlidingPanel,
  clearAllSnackbarNotification,
  createSnackbarNotification,
  bTypography as deprecated_BTypography,
  useBreakpoints
};
//# sourceMappingURL=index.js.map
